(function() {
  function normalizeHandleToKey(slug) {
    return String(slug || '').replace(/-/g, '').toLowerCase();
  }
  function normalizeModelToKey(name) {
    return String(name || '').replace(/\s+/g, '').toLowerCase();
  }
  function normalizeDriverName(name){
    const s = String(name || '').toLowerCase().trim();
    const raw = s.replace(/[^a-z0-9]/g, '');
    // Canonicalize common synonyms
    if (raw === 'ms' || raw === 'microspline' || raw === 'microspl') return 'microspline';
    if (raw === 'xd' || raw === 'sramxd') return 'xd';
    if (raw === 'xdr' || raw === 'sramxdr') return 'xdr';
    if (raw === 'hg' || raw === 'shimanohg' || raw === 'shimanohyperglide') return 'hg';
    if (raw === 'xdr' || raw === 'xd road' || s.includes('xd road') || s.includes('x d road') || s.includes('sram xdr')) return 'xd road';
    if (raw === 'hgr' || raw === 'hg road' || s.includes('hg road') || s.includes('h g road') || s.includes('hyperglide road')) return 'hg road';
    if (raw === 'msr' || raw === 'ms road' || s.includes('ms road') ||  s.includes('ms road with endcap') || s.includes('microspline road') || s.includes('micro spline road')) return 'microspline road';
    return raw;
  }

  function canonicalizeDriverStyle(value){
    return normalizeDriverName(value);
  }

  function normalizeAndCompareDriver(fieldVal, queryVal){
    if (!queryVal) return true;
    const canonicalQuery = canonicalizeDriverStyle(queryVal);
    const candidates = [];
    if (Array.isArray(fieldVal)) {
      for (const v of fieldVal) candidates.push(canonicalizeDriverStyle(v));
    } else if (typeof fieldVal === 'string') {
      let parsed = null;
      try { parsed = JSON.parse(fieldVal); } catch(_) {}
      if (Array.isArray(parsed)) {
        for (const v of parsed) candidates.push(canonicalizeDriverStyle(v));
      } else {
        candidates.push(canonicalizeDriverStyle(fieldVal));
      }
    } else if (fieldVal != null) {
      candidates.push(canonicalizeDriverStyle(String(fieldVal)));
    }
    // Accept synonyms like 'ms' for microspline
    const expanded = new Set();
    for (const c of candidates) {
      expanded.add(c);
      if (c === 'microspline') expanded.add('ms');
    }
    return expanded.has(canonicalQuery);
  }

  let hubWheelbuilderStoreRegistered = false;

  function hubGetAlpineData(el) {
    if (!el) return null;
    if (window.Alpine && typeof Alpine.$data === 'function') {
      try {
        return Alpine.$data(el);
      } catch (_) {}
    }
    if (el._x_dataStack && el._x_dataStack[0]) return el._x_dataStack[0];
    return null;
  }

  function hubbuilderTriggerHaptic(kind) {
    try {
      if (!window.matchMedia('(pointer: coarse)').matches) return;
      if (window.wheelbuilderSupportsHaptics && window.wheelbuilderHaptic) {
        if (kind === 'confirm' && typeof window.wheelbuilderHaptic.confirm === 'function') {
          window.wheelbuilderHaptic.confirm();
        } else {
          window.wheelbuilderHaptic();
        }
      }
    } catch (_) {}
  }

  /**
   * Completion check for hubBuilderForm — do NOT call formData.isEveryOptionSelected() from tabs;
   * under Alpine proxies that can resolve back to hubBuilderTabs and overflow the stack.
   */
  function computeHubBuilderFormEveryOptionSelected(formData) {
    if (!formData || !Array.isArray(formData.completeOptions)) return false;
    if (formData.completeOptions.length === 0) return false;
    return formData.completeOptions.every((option) => (option.value ?? '') !== '');
  }

  function hubRulesIndexPickKey(obj, fieldId) {
    if (!obj || fieldId == null) return undefined;
    const id = String(fieldId);
    if (Object.prototype.hasOwnProperty.call(obj, id)) return obj[id];
    const camel = id.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    if (camel !== id && Object.prototype.hasOwnProperty.call(obj, camel)) return obj[camel];
    return obj[id];
  }

  function hubNormMatchValue(s) {
    return String(s || '')
      .normalize('NFKC')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function hbGetRulesModelRaw(tabsData) {
    const fromTabs = String(tabsData?.rulesModel || '').trim();
    if (fromTabs) return fromTabs;
    const fromWindow = String(window.__HUB_BUILDER_RULES_MODEL__ || '').trim();
    if (fromWindow) return fromWindow;
    const fromOpts = window.__HUB_BUILDER_OPTIONS__?.hub_model;
    if (fromOpts != null && String(fromOpts).trim()) return String(fromOpts).trim();
    const el = typeof document !== 'undefined' ? document.querySelector('[data-hub-rules-model]') : null;
    const data = el?.getAttribute?.('data-hub-rules-model')?.trim();
    if (data) return data;
    return '';
  }

  function hbGetStemRulesModelRaw(tabsData) {
    const fromTabs = String(tabsData?.rulesModel || '').trim();
    if (fromTabs) return fromTabs;
    const fromWindow = String(window.__HUB_BUILDER_RULES_MODEL__ || '').trim();
    if (fromWindow) return fromWindow;
    const fromOpts = window.__HUB_BUILDER_OPTIONS__?.stem_model;
    if (fromOpts != null && String(fromOpts).trim()) return String(fromOpts).trim();
    const el = typeof document !== 'undefined' ? document.querySelector('[data-stem-rules-model]') : null;
    const data = el?.getAttribute?.('data-stem-rules-model')?.trim();
    if (data) return data;
    return '';
  }

  function hubbuilderReadPanelTab(formEl) {
    if (!formEl) return '';
    const el =
      typeof formEl.closest === 'function' ? formEl.closest('[data-wb-panel-tab]') || formEl : formEl;
    const a = el.getAttribute?.('data-wb-panel-tab');
    return a != null && String(a).trim() !== '' ? String(a).trim() : '';
  }

  /** @returns {HTMLElement|null} */
  function getVisibleHubbuilderSummarySheet() {
    if (typeof document === 'undefined') return null;
    const sheets = document.querySelectorAll('.wheelbuilder-mobile-summary-sheet');
    for (const el of sheets) {
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') continue;
      return el;
    }
    return null;
  }

  function hubbuilderPrefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {
      return false;
    }
  }

  /** @returns {{ n: number, fromIndex: number, fromEnd: number }} (parity: wheelBuilder.js) */
  function hubbuilderOptionGroupListMetrics(element) {
    if (!element) return { n: 0, fromIndex: -1, fromEnd: 999 };
    let groups;
    const optionGroupsRoot = element.closest('.wheelbuilder-option-groups');
    if (optionGroupsRoot) {
      groups = optionGroupsRoot.querySelectorAll('[data-option-group]');
    } else {
      const panel = element.closest("section[role=tabpanel]");
      if (!panel) return { n: 0, fromIndex: -1, fromEnd: 999 };
      groups = panel.querySelectorAll("[data-option-group]");
    }
    if (groups.length < 1) return { n: 0, fromIndex: -1, fromEnd: 999 };
    const i = Array.prototype.indexOf.call(groups, element);
    if (i < 0) return { n: groups.length, fromIndex: -1, fromEnd: 999 };
    return { n: groups.length, fromIndex: i, fromEnd: groups.length - 1 - i };
  }

  function hubbuilderOptionGroupFromEnd(element) {
    return hubbuilderOptionGroupListMetrics(element).fromEnd;
  }

  /**
   * Stem builder verbose logging (off by default).
   * Enable one of:
   *   window.__STEM_BUILDER_DEBUG__ = true  then reload
   *   localStorage.setItem('STEM_BUILDER_DEBUG', '1')  then reload
   *   ?stem_debug=1  on the product URL
   */
  function stemBuilderDeepDebugEnabled() {
    try {
      if (typeof window === 'undefined') return false;
      if (window.__STEM_BUILDER_DEBUG__ === true) return true;
      if (typeof localStorage !== 'undefined' && localStorage.getItem('STEM_BUILDER_DEBUG') === '1') {
        return true;
      }
      if (
        typeof window.location?.search === 'string' &&
        /(?:^|[?&])stem_debug=1(?:&|$)/.test(window.location.search)
      ) {
        return true;
      }
    } catch (_) {}
    return false;
  }

  function stemDebugLog(...args) {
    if (!stemBuilderDeepDebugEnabled()) return;
    console.log('[StemBuilder:debug]', ...args);
  }

  function stemDebugGroup(label, fn) {
    if (!stemBuilderDeepDebugEnabled() || typeof fn !== 'function') return;
    const g = console.groupCollapsed ? console.groupCollapsed.bind(console) : console.log;
    g.call(console, '[StemBuilder:debug]', label);
    try {
      fn();
    } finally {
      if (console.groupEnd) console.groupEnd();
    }
  }

  /** Match wheelBuilder.js: tail groups use a softer vertical anchor. */
  const HUB_WB_SCROLL_BOTTOM_GROUPS = 3;

  /** Match `--wb-cart-check-*` on `.wheelbuilder-cart-btn.loading` in wheel-builder.css.
   *  Celebration starts as soon as /cart/add succeeds (drawer refresh is background). */
  const HUBBUILDER_ADDTOCART_CHECK_MS = 560;

  function hubbuilderOptionGroupScrollBlockFromMetrics(m) {
    if (m.n < 1 || m.fromIndex < 0) return 'center';
    if (m.fromEnd <= 1) return 'end';
    if (m.n <= 4) {
      return m.fromEnd <= 3 ? 'nearest' : 'center';
    }
    const p = m.n > 1 ? m.fromIndex / (m.n - 1) : 0;
    if (m.fromEnd <= 3) return 'nearest';
    if (m.n >= 6 && p > 0.4) return 'nearest';
    if (p >= 0.5) return 'nearest';
    return 'center';
  }

  /**
   * Desktop `scrollIntoView` `block` (keep in sync with wheelBuilder.js).
   */
  function hubbuilderOptionGroupScrollIntoViewBlock(element) {
    return hubbuilderOptionGroupScrollBlockFromMetrics(hubbuilderOptionGroupListMetrics(element));
  }

  /**
   * Vertical scrollport for options is `.drawer-content` (all hub/stem tabs — same as wheel set builder).
   * @param {HTMLElement|null|undefined} drawerEl
   * @returns {HTMLElement|null}
   */
  function hubbuilderResolveOptionsScrollContainer(drawerEl) {
    if (!drawerEl) return null;
    return drawerEl;
  }

  function hubbuilderProductImageUrl(product) {
    if (!product) return '';
    if (typeof product.featured_image === 'string' && product.featured_image) return product.featured_image;
    if (product.featured_image?.src) return product.featured_image.src;
    if (Array.isArray(product.images) && product.images.length > 0) {
      const img = product.images[0];
      return typeof img === 'string' ? img : img?.src || '';
    }
    return '';
  }

  function hubbuilderMobileCartAddedEnabled() {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 768;
  }

  function hubbuilderMobileDrawerScrollGroupToViewportCenter(
    element,
    scrollContainer,
    behavior = "auto",
    topOffset = 10,
  ) {
    if (!element || !scrollContainer) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const containerH = scrollContainer.clientHeight;
        if (containerH < 48) return;

        const elementRect = element.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const currentScroll = scrollContainer.scrollTop;
        const relativeTop = elementRect.top - containerRect.top;
        const elTopInContent = currentScroll + relativeTop;
        const maxScroll = Math.max(0, scrollContainer.scrollHeight - containerH);

        let targetScroll;
        if (elementRect.height > containerH) {
          targetScroll = elTopInContent - topOffset;
        } else {
          const elCenterInContent = elTopInContent + elementRect.height / 2;
          targetScroll = elCenterInContent - containerH * 0.5;
        }

        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

        if (Math.abs(targetScroll - currentScroll) > 1) {
          scrollContainer.scrollTo({ top: targetScroll, behavior });
        }
      });
    });
  }

  function hubbuilderScrollMobileSummaryCardToCenter(behavior = 'auto', attempt = 0) {
    if (typeof window === 'undefined') return;
    const sheet = getVisibleHubbuilderSummarySheet();
    if (!sheet) {
      if (attempt < 18) {
        requestAnimationFrame(() =>
          hubbuilderScrollMobileSummaryCardToCenter(behavior, attempt + 1),
        );
      }
      return;
    }
    const scrollPort = sheet.querySelector('.wheelbuilder-mobile-summary-sheet__scroll');
    if (!scrollPort) {
      if (attempt < 18) {
        requestAnimationFrame(() =>
          hubbuilderScrollMobileSummaryCardToCenter(behavior, attempt + 1),
        );
      }
      return;
    }
    if (Math.abs(scrollPort.scrollTop) <= 2) return;
    scrollPort.scrollTo({ top: 0, behavior });
  }

  /**
   * @param {HTMLElement} container
   * @param {Element|null|undefined} restoreFocusEl
   */
  function createHubbuilderFocusTrap(container, restoreFocusEl) {
    const selector =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const focusable = () =>
      Array.from(container.querySelectorAll(selector)).filter(
        (el) => el.offsetWidth > 0 && el.offsetHeight > 0 && !el.closest('[inert]'),
      );

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      const nodes = focusable();
      if (nodes.length === 0) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    return {
      activate() {
        document.addEventListener('keydown', onKeydown, true);
        const edit = container.querySelector('[data-wb-summary-edit]');
        const nodes = focusable();
        (edit || nodes[0])?.focus({ preventScroll: true });
      },
      deactivate() {
        document.removeEventListener('keydown', onKeydown, true);
        if (restoreFocusEl && typeof restoreFocusEl.focus === 'function') {
          try {
            restoreFocusEl.focus({ preventScroll: true });
          } catch (_) {}
        }
      },
    };
  }

  /** Match wheel builder: mobile wizard uses viewport width OR expanded options drawer. */
  function hubbuilderIsMobileViewport(tabsData) {
    if (typeof window === 'undefined') return false;
    const byWidth = window.innerWidth <= 768;
    if (tabsData && typeof tabsData.isMobileViewport === 'boolean') {
      return Boolean(tabsData.isMobileViewport) || byWidth;
    }
    return byWidth;
  }

  /**
   * Mobile-only wizard chrome (summary sheet, option-group gating). Must NOT key off `mobileShowOptions`
   * alone: single-tab builders set that true on init so the drawer opens on phones, which would
   * incorrectly treat desktop as “wizard active” and keep option accordions visible beside the summary.
   */
  function hubbuilderMobileWizardActive(tabsData) {
    if (!tabsData) return false;
    return hubbuilderIsMobileViewport(tabsData);
  }

  /** Intentional no-op: do not `window.scrollTo` the product hero; only `.drawer-content` scrolls. */
  function hubbuilderScrollBuilderMediaIntoView() {}

  let hubRulesStoreRegistered = false;

  /** Reactive rules-fetch state for shared snippet (window.* is not tracked by Alpine). */
  function ensureHubRulesStore() {
    if (hubRulesStoreRegistered || !window.Alpine || typeof Alpine.store !== 'function') return;
    try {
      Alpine.store('hubRules', { fetching: false, error: null });
    } catch (_) {
      /* store may already exist */
    }
    hubRulesStoreRegistered = true;
  }

  function hubRulesStore() {
    try {
      return Alpine.store('hubRules');
    } catch (_) {
      return null;
    }
  }

  function ensureHubWheelbuilderStore() {
    if (hubWheelbuilderStoreRegistered || !window.Alpine || typeof Alpine.store !== 'function') return;
    try {
      Alpine.store('wheelbuilder', {
        showMobileFooter: true,
        showSummaryPage: false,
        isMobileViewport: typeof window !== 'undefined' && window.innerWidth <= 768,
        derivedWheelOptions: null,
        derivedRimOptions: null,
        getKeysForTab() {
          return [];
        },
        getDerivedOptionsForTab() {
          return {};
        },
      });
    } catch (_) {
      /* store may already exist */
    }
    hubWheelbuilderStoreRegistered = true;
  }

  /** Scales desktop summary to fit the viewport; same as wheelBuilder.js */
  function wbSummaryDesktopFit() {
    return {
      _rAF: null,
      _ro: null,
      _onResize: null,
      _onProgress: null,
      init() {
        const schedule = () => {
          if (this._rAF) return;
          this._rAF = requestAnimationFrame(() => {
            this._rAF = null;
            this.$nextTick(() => {
              this._fit();
            });
          });
        };
        this._onResize = schedule;
        this._onProgress = schedule;
        window.addEventListener("resize", this._onResize, { passive: true });
        document.addEventListener("wheelbuilder:update-progress", this._onProgress);
        const inner = this.$refs?.wbSummaryFitInner;
        if (inner && typeof ResizeObserver !== "undefined") {
          this._ro = new ResizeObserver(this._onProgress);
          this._ro.observe(inner);
        }
        schedule();
      },
      _fit() {
        const el = this.$el;
        const inner = this.$refs?.wbSummaryFitInner;
        if (!el || !inner) return;
        if (window.innerWidth < 768) {
          el.style.removeProperty("height");
          inner.style.removeProperty("transform");
          inner.style.removeProperty("width");
          inner.style.removeProperty("max-width");
          return;
        }
        if (el.offsetWidth < 2) return;

        inner.style.transform = "none";
        inner.style.width = "100%";
        inner.style.removeProperty("max-width");

        const h = Math.ceil(inner.getBoundingClientRect().height);
        const w = Math.ceil(inner.getBoundingClientRect().width);
        if (h < 2 || w < 2) return;

        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        const t = Math.max(0, rect.top);
        const marginBottom = 20;
        let availH = window.innerHeight - t - marginBottom;
        const vvh = window.visualViewport?.height;
        if (vvh) {
          availH = Math.min(
            availH,
            vvh - Math.max(0, t - (window.visualViewport?.offsetTop || 0) - 8)
          );
        }
        if (!Number.isFinite(availH) || availH < 72) return;

        const kH = availH / h;
        const kW = (rect.width * 0.99) / w;
        const k0 = Math.min(1, kH, kW);

        if (k0 >= 0.999) {
          el.style.removeProperty("height");
          inner.style.removeProperty("transform");
          return;
        }

        const k = Math.max(0.42, Math.min(1, k0));
        inner.style.transformOrigin = "top center";
        inner.style.willChange = "transform";
        inner.style.transform = "scale(" + k + ")";
        el.style.height = h * k + "px";
      },
    };
  }

  function register() {
    if (!window.Alpine) return;
    ensureHubWheelbuilderStore();
    ensureHubRulesStore();

    Alpine.data("wbSummaryDesktopFit", wbSummaryDesktopFit);

    Alpine.data('hubBuilderTabs', ({
      labels,
      model,
      singleTabMode = false,
      mobileWizardTitle = '',
      ecomEngineUrl = '',
      ecomEngineApiPath = '',
      rulesModel = '',
    }) => {
      return {
      selectedId: null,
      selectedTab: null,
      labels,
      model,
      ecomEngineUrl: ecomEngineUrl || '',
      ecomEngineApiPath: ecomEngineApiPath || '',
      rulesModel: rulesModel || '',
      hubRulesIndex: null,
      singleTabMode: !!singleTabMode,
      mobileWizardTitle: mobileWizardTitle || '',
      normalizedModelKey: null,
      rules: [],
      fetchingRules: false,
      ruleFetchError: null,
      progress: 0,
      progressRailSteps: 0,
      progressRailVisible: false,
      _progressRailObserver: null,
      isMobileViewport: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
      drawerState: typeof window !== 'undefined' && window.innerWidth > 768 ? 'expanded' : 'peek',
      mobileShowOptions: false,
      isScreenTransitioning: false,
      /** 'forward' (chooser→options→summary) | 'backward' (reverse). Drives the
       *  panel's `.wb-wizard--back` class so CSS resolves slide direction. */
      wizardDirection: 'forward',
      cartItemCount: 0,
      _cartCountFetchInFlight: false,
      /** Bumped on every `wheelbuilder:form-state-changed` so tabs-scope CTAs
       *  (peek/footer busy spinner) re-read form busy flags across Alpine trees. */
      _formStateEpoch: 0,
      fetchCartItemCount() {
        if (typeof window === 'undefined') return;
        if (this._cartCountFetchInFlight) return;
        this._cartCountFetchInFlight = true;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => { this.cartItemCount = Number(cart?.item_count) || 0; })
          .catch(() => {})
          .finally(() => { this._cartCountFetchInFlight = false; });
      },
      selectedTabLabel: '',
      hasShownSummary: false,
      mobileForceOptions: false,
      collapsedOffset: 122,
      isDragging: false,
      startY: 0,
      startTime: 0,
      currentY: 0,
      _touchCancelUnlock: null,
      _hubTabsResize: null,
      _mobileDrawerScrollRO: null,
      screenTransitionTimer: null,
      summarySheetPainted: false,
      _mobileSummaryA11yActive: false,
      _mobileSummaryEscapeHandler: null,
      _mobileSummarySheetTrap: null,
      _mobileSummaryPrevFocus: null,
      _mobileSummaryA11yDeferTimer: null,
      _prevIsSummaryReady: false,
      /** Direct panel children marked `inert` for summary sheet (footer excluded so CTAs stay clickable). */
      _mobileSummaryInertTargets: null,

      init() {
        try {
          this.normalizedModelKey = normalizeHandleToKey(this.model);
          this.calculateCollapsedOffset = () => {
            if (window.innerWidth <= 768) {
              this.collapsedOffset = window.innerHeight - 122;
            }
          };
          this.calculateCollapsedOffset();
          window.addEventListener('resize', this.calculateCollapsedOffset, { passive: true });

          // Cart badge: fetch once now + refresh on cart events.
          this.fetchCartItemCount();
          this._cartCountListener = () => this.fetchCartItemCount();
          document.addEventListener('cart:updated', this._cartCountListener);
          document.addEventListener('cart:items-added', this._cartCountListener);
          document.addEventListener('cart:refresh', this._cartCountListener);

          this._hubTabsResize = () => {
            const mobile = window.innerWidth <= 768;
            this.isMobileViewport = mobile;
            try {
              const store = Alpine.store('wheelbuilder');
              if (store) store.isMobileViewport = mobile;
            } catch (_) {}
            if (!mobile) {
              this.drawerState = 'expanded';
              this._teardownMobileDrawerScrollResizeObserver();
              this._clearAllDrawerContentScrollStyles();
              this.summarySheetPainted = false;
              this._teardownMobileSummarySheetA11y();
              this.mobileForceOptions = false;
            } else if (!this.mobileShowOptions) {
              this.setDrawerState('peek');
            }
            this.syncMobileFooterStore();
            this.$nextTick(() => {
              this.applyDrawerStateClass();
              if (this.selectedId) this.setIndicatorPosition(this.selectedId);
            });
          };
          window.addEventListener('resize', this._hubTabsResize, { passive: true });

          this._touchCancelUnlock = () => {
            if (this.isDragging) this.handleDragCancel();
          };
          document.addEventListener('touchcancel', this._touchCancelUnlock, { passive: true });

          if (typeof IntersectionObserver !== 'undefined') {
            const builderSection = this.$root?.closest?.('section.page-width.wheelbuilder') || this.$root;
            this._progressRailObserver = new IntersectionObserver((entries) => {
              for (const e of entries) {
                this.progressRailVisible = e.isIntersecting;
              }
            }, { threshold: 0 });
            this._progressRailObserver.observe(builderSection);
          }

          document.addEventListener('wheelbuilder:update-progress', () => {
            this.$nextTick(() => {
              this.updateProgress();
              this.syncMobileFooterStore();
            });
          });
          document.addEventListener('wheelbuilder:selections-cleared', () => {
            this.progress = 0;
            this.progressRailSteps = 0;
            this.hasShownSummary = false;
          });
          document.addEventListener('wheelbuilder:form-state-changed', () => {
            this._formStateEpoch = (this._formStateEpoch || 0) + 1;
            this.syncMobileFooterStore();
            this.$nextTick(() => {
              if (this.isMobileViewport) this.syncMobileSheet();
            });
          });

          this._prevIsSummaryReady = this.isSummaryReady;
          this.$watch(
            () => this.isSummaryReady,
            (ready) => {
              if (ready && !this._prevIsSummaryReady) {
                this.mobileForceOptions = false;
                // Desktop completion: trigger one summary scroll pass when readiness flips true.
                if (typeof window !== 'undefined' && window.innerWidth > 768) {
                  this.$nextTick(() => {
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        this.scrollToSummary();
                      });
                    });
                  });
                }
              }
              this._prevIsSummaryReady = ready;
            },
          );

          this.$watch(
            () =>
              hubbuilderMobileWizardActive(this) &&
              this.mobileStep === 'summary' &&
              this.isSummaryReady &&
              !this.mobileForceOptions,
            (open) => {
              if (this._mobileSummaryA11yDeferTimer) {
                clearTimeout(this._mobileSummaryA11yDeferTimer);
                this._mobileSummaryA11yDeferTimer = null;
              }
              if (open) {
                this.summarySheetPainted = false;
                this.refreshSelectedFormSummaryRows();
                this.$nextTick(() => {
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      let tries = 0;
                      const maxTries = 40;
                      const poll = () => {
                        this._mobileSummaryA11yDeferTimer = null;
                        const stillOpen =
                          hubbuilderMobileWizardActive(this) &&
                          this.mobileStep === 'summary' &&
                          this.isSummaryReady &&
                          !this.mobileForceOptions;
                        if (!stillOpen) {
                          this.summarySheetPainted = false;
                          return;
                        }
                        if (getVisibleHubbuilderSummarySheet()) {
                          this.summarySheetPainted = true;
                          this._setupMobileSummarySheetA11y();
                          return;
                        }
                        tries += 1;
                        if (tries >= maxTries) return;
                        this._mobileSummaryA11yDeferTimer = setTimeout(poll, 50);
                      };
                      poll();
                    });
                  });
                });
              } else {
                this.summarySheetPainted = false;
                this._teardownMobileSummarySheetA11y();
              }
            },
          );

          this.$watch('mobileStep', (to, from) => {
            this.syncMobileFooterStore();
            if (from && to !== from && window.innerWidth <= 768) {
              const rank = { chooser: 0, options: 1, summary: 2, 'cart-added': 3 };
              const goingForward = (rank[to] ?? 0) > (rank[from] ?? 0);
              this.setWizardDirection(goingForward ? 'forward' : 'backward');
              /* Never height-tween — see wheelBuilderTabs. */
              if (to === 'summary' || from === 'summary' || to === 'cart-added' || from === 'cart-added') {
                this.beginScreenTransition(320);
              }
            }
          });

          /* Parity with wheelBuilderTabs: drawerState / mobileShowOptions / progress
             are the single source of truth for the mobile footer store + drawer
             scroll layout. Without these reactive watchers the footer CTA, summary
             visibility, and content max-height can drift out of sync when state
             flips indirectly (tab sync, rules load, drag), leaving a blank drawer
             or a footer with no label. */
          this.$watch('drawerState', () => {
            this.applyDrawerStateClass();
            const panel = this.getDrawerPanel();
            if (panel && !this.isDragging) {
              panel.style.removeProperty('--drawer-drag');
            }
            this.syncMobileFooterStore();
            this.$nextTick(() => {
              requestAnimationFrame(() => this.syncMobileDrawerContentScrollLayout());
            });
          });
          this.$watch('mobileShowOptions', () => {
            this.syncMobileFooterStore();
            this.$nextTick(() => {
              requestAnimationFrame(() => this.syncMobileDrawerContentScrollLayout());
            });
          });
          this.$watch('progress', () => this.syncMobileFooterStore());

          this.$nextTick(() => {
            const firstId = this.$id('tab', 1);
            this.select(firstId, 0, { skipInitialLayoutScroll: true });
            this.updateProgress();
            this.applyDrawerStateClass();
            if (
              this.singleTabMode ||
              (Array.isArray(this.labels) && this.labels.length === 1)
            ) {
              const raw = (this.mobileWizardTitle && String(this.mobileWizardTitle).trim()) || '';
              this.selectedTabLabel =
                raw ||
                (this.labels && this.labels[0] != null ? String(this.labels[0]) : '');
              this.mobileShowOptions = true;
            }
            this.syncMobileFooterStore();
            this._ensureMobileDrawerScrollResizeObserver();
            requestAnimationFrame(() =>
              requestAnimationFrame(() => this.syncMobileDrawerContentScrollLayout())
            );
          });

          if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
            stemDebugLog('hubBuilderTabs.init → fetchStemRules', {
              model: this.model,
              labels: this.labels,
            });
            this.fetchStemRules();
          } else {
            this.fetchRules();
            if (labels.includes('driver')) {
              this.fetchDriverRules();
            }
          }
        } catch (e) {
          console.error('[HubBuilder] Tabs.init error', e);
        }
      },

      destroy() {
        if (this._cartCountListener) {
          document.removeEventListener('cart:updated', this._cartCountListener);
          document.removeEventListener('cart:items-added', this._cartCountListener);
          document.removeEventListener('cart:refresh', this._cartCountListener);
          this._cartCountListener = null;
        }
        if (this.calculateCollapsedOffset) {
          window.removeEventListener('resize', this.calculateCollapsedOffset);
        }
        if (this._hubTabsResize) {
          window.removeEventListener('resize', this._hubTabsResize);
          this._hubTabsResize = null;
        }
        if (this._touchCancelUnlock) {
          document.removeEventListener('touchcancel', this._touchCancelUnlock);
          this._touchCancelUnlock = null;
        }
        if (this._progressRailObserver) {
          this._progressRailObserver.disconnect();
          this._progressRailObserver = null;
        }
        this._teardownMobileSummarySheetA11y?.();
        this._teardownMobileDrawerScrollResizeObserver?.();
      },

      get wbCopy() {
        const w = typeof window !== 'undefined' ? window.WHEELBUILDER_I18N : null;
        return w && typeof w === 'object' ? w : {};
      },

      get mobileStep() {
        if (!this.mobileShowOptions) return 'chooser';
        /* Step 4 — cart confirmation. Prefer footer form (same as CTA), not only
           the visible tabpanel form — multi-tab hub can leave getActiveFormData()
           on a sibling while getFooterActionFormData() already sees addedToCart.
           That mismatch kept "Configure options" + reset while CHECKOUT showed. */
        const footerF =
          typeof this.getFooterActionFormData === 'function'
            ? this.getFooterActionFormData()
            : null;
        const activeF = this.getActiveFormData();
        const cartForm = footerF?.addedToCart ? footerF : activeF?.addedToCart ? activeF : null;
        if (cartForm && hubbuilderIsMobileViewport(this)) return 'cart-added';
        if (this.mobileForceOptions) return 'options';
        if (this.isEveryOptionSelected()) return 'summary';
        return 'options';
      },

      wbDrawerCartAddedVisible() {
        return this.mobileStep === 'cart-added';
      },

      /**
       * Single always-on peek label. Closed drawer must NOT reuse the expanded
       * footer's multi-span x-show tree (span-y clip + checkout fill-mode +
       * hub multi-tab form races → blank blue pill). Prefer footer form.
       * Depends on `_formStateEpoch` so tabs re-read after form ATC/checkout.
       */
      get peekCtaLabel() {
        void this._formStateEpoch;
        const c = this.wbCopy;
        const f =
          (typeof this.getFooterActionFormData === 'function' && this.getFooterActionFormData()) ||
          this.getActiveFormData();
        if (f?.isCheckingOut) return c.checkingOut || 'Checking out…';
        if (f?.addToCartSubmitting) return c.addingToCart || 'Adding…';
        if (f?.loading) return c.addingToCart || 'Adding…';
        if (f?.addedToCart) return c.peekCtaCheckout || 'CHECKOUT';
        if (f?.error) return c.mobileFooterUnable || 'This setup needs another tweak';
        if (f?.unavailable) return c.soldOut || 'Sold out';
        if (!this.mobileShowOptions) return c.peekCtaStart || 'Start';
        const busy =
          typeof this.footerBusyOverlayVisible === 'function'
            ? this.footerBusyOverlayVisible()
            : this.isBuildResolving;
        if (busy || this.isBuildResolving) return c.building || c.peekCtaBuilding || 'Building…';
        const ready =
          typeof this.footerIsReadyForSummary === 'function'
            ? this.footerIsReadyForSummary()
            : this.isSummaryReady;
        /* peekCtaReview copy is "ADD TO CART" in theme defaults — keep that contract. */
        if (ready) return c.peekCtaReview || 'ADD TO CART';
        if (this.progress > 0 && this.progress < 100) return c.peekCtaContinue || 'Continue';
        if (this.progress >= 100) return c.peekCtaReview || 'ADD TO CART';
        return c.peekCtaStart || 'Start';
      },

      /** True when peek should show CHECKOUT + arrow (epoch-aware for Alpine). */
      get peekCtaIsCheckout() {
        void this._formStateEpoch;
        const f =
          (typeof this.getFooterActionFormData === 'function' && this.getFooterActionFormData()) ||
          this.getActiveFormData();
        if (!f?.addedToCart) return false;
        if (f.loading || f.isCheckingOut || f.addToCartSubmitting) return false;
        if (f.cartBtnBusyOverlayVisible) return false;
        return true;
      },

      /** Hide plain peek label while spinner/check owns the pill. */
      get peekCtaShowLabel() {
        void this._formStateEpoch;
        const f =
          (typeof this.getFooterActionFormData === 'function' && this.getFooterActionFormData()) ||
          this.getActiveFormData();
        if (f?.loading) return false;
        if (typeof this.footerBusyOverlayVisible === 'function' && this.footerBusyOverlayVisible()) {
          return false;
        }
        if (f?.cartBtnBusyOverlayVisible) return false;
        return true;
      },

      /**
       * Closed-drawer compact CTA click handler — mirrors wheelBuilderTabs.
       * Acts on the current label: checkout when added, add-to-cart when ready,
       * otherwise opens the drawer so the user can keep building.
       * Uses `getFooterActionFormData` for parity with the open-drawer footer button
       * (handles mid-transition selectedTab/display routing).
       */
      runDrawerCtaClick() {
        const f =
          typeof this.getFooterActionFormData === 'function'
            ? this.getFooterActionFormData()
            : this.getActiveFormData();
        /* Re-entry guard — see wheelBuilder.js runDrawerCtaClick. */
        if (f && f.isCheckingOut) return;
        if (f && f.addedToCart) {
          if (typeof f.goToCheckout === 'function') f.goToCheckout();
          return;
        }
        const ready =
          typeof this.footerIsReadyForSummary === 'function'
            ? this.footerIsReadyForSummary()
            : this.isSummaryReady;
        const busy =
          typeof this.footerBusyOverlayVisible === 'function'
            ? this.footerBusyOverlayVisible()
            : this.isBuildResolving;
        if (
          f &&
          ready &&
          !busy &&
          typeof f.isReadyForSummary === 'function' &&
          f.isReadyForSummary() &&
          !f.unavailable &&
          !f.error &&
          !f.loading &&
          !f.isFetchingProducts &&
          !f.addToCartSubmitting
        ) {
          if (typeof f.addToCart === 'function') {
            f.addToCart();
            return;
          }
        }
        if (typeof this.openDrawer === 'function') this.openDrawer();
      },

      get mobileWizardHeaderTitle() {
        if (this.isBuildResolving) return this.wbCopy.building || 'Building…';
        return 'Configure options';
      },

      get isSummaryReady() {
        const f = this.getActiveFormData();
        return !!(f && typeof f.canShowMobileSummary === 'function' && f.canShowMobileSummary());
      },

      /** Match wheelBuilderTabs: derive from pipeline + `isReadyForSummary`, not `form.isBuildResolving` (avoids mobile label/disabled drift). */
      get isBuildResolving() {
        const f = this.getActiveFormData();
        if (!f || !this.isEveryOptionSelected()) return false;
        const coreBusy = !!(
          f.isFetchingProducts ||
          f.hubColorsLoading ||
          f.fetchingHubInventory ||
          (f.pricing && f.pricing.loading)
        );
        if (typeof f.isReadyForSummary === 'function') {
          // If pricing failed (rate-limited, timeout, etc.), surface the
          // error state instead of showing an infinite "Building…" overlay.
          if (f.error || f.unavailable) return coreBusy;
          return coreBusy || !f.isReadyForSummary();
        }
        return !!coreBusy;
      },

      get panelDataCompleteAttr() {
        if (!this.isSummaryReady || this.mobileForceOptions) return false;
        if (!this.mobileShowOptions) return true;
        const f = this.getActiveFormData();
        if (!f || typeof f.wbMobileSummarySheetOpen !== 'function') return false;
        if (!f.wbMobileSummarySheetOpen()) return false;
        return !!this.summarySheetPainted;
      },

      isEveryOptionSelected() {
        return computeHubBuilderFormEveryOptionSelected(this.getActiveFormData());
      },

      syncMobileFooterStore() {
        try {
          const store = Alpine.store('wheelbuilder');
          store.isMobileViewport = window.innerWidth <= 768;
          this.isMobileViewport = store.isMobileViewport;
          store.showMobileFooter = this.mobileShowOptions || this.mobileStep === 'summary';
          store.showSummaryPage = this.mobileStep === 'summary';
        } catch (_) {}
      },

      beginScreenTransition(duration = 440) {
        this.isScreenTransitioning = true;
        if (this.screenTransitionTimer) clearTimeout(this.screenTransitionTimer);
        this.screenTransitionTimer = setTimeout(() => {
          this.isScreenTransitioning = false;
          this.screenTransitionTimer = null;
        }, duration);
      },

      setWizardDirection(dir) {
        this.wizardDirection = dir === 'backward' ? 'backward' : 'forward';
      },

      getDrawerPanel() {
        const r = this.$root || this.$el;
        return (
          this.$refs?.mobileDrawerPanel ||
          (r && typeof r.querySelector === 'function' ? r.querySelector('.wheelbuilder-panel') : null)
        );
      },

      applyDrawerStateClass() {
        const panel = this.getDrawerPanel();
        if (!panel) return;
        panel.classList.remove('is-peek', 'is-expanded');
        panel.classList.add(`is-${this.drawerState}`);
        this.syncMobileFooterStore();
      },

      setDrawerState(state) {
        if (state === 'peek' || state === 'expanded') {
          this.drawerState = state;
          this.applyDrawerStateClass();
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.syncMobileDrawerContentScrollLayout();
              if (state === 'peek') this._refreshPeekCtaPaint();
            });
          });
        }
      },

      /**
       * Peek CTA can paint blank after expanded→peek during add/checkout:
       * labels were opacity:0 under has-price/is-price-loading, or the check
       * animation finished while the peek button was display:none. Force a
       * visible label/check on the next frame.
       */
      _refreshPeekCtaPaint() {
        if (typeof window === 'undefined' || window.innerWidth > 768) return;
        const panel = this.getDrawerPanel();
        if (!panel || !panel.classList.contains('is-peek')) return;
        const btn = panel.querySelector('.drawer-cta-compact .wheelbuilder-cart-btn');
        if (!btn) return;
        const texts = btn.querySelectorAll('.wheelbuilder-cart-btn__text, .wheelbuilder-cart-btn__status');
        texts.forEach((el) => {
          if (el.style.opacity === '0') el.style.removeProperty('opacity');
        });
        if (btn.classList.contains('loading')) {
          const cart = btn.querySelector('.wheelbuilder-cart-btn__cart');
          if (cart) {
            cart.style.display = 'block';
            cart.style.opacity = '1';
            cart.style.transform = 'scale(1)';
            const poly = cart.querySelector('polyline');
            if (poly) poly.style.strokeDashoffset = '0';
          }
        }
      },

      toggleDrawer() {
        /* Light default tap — matches wheelBuilderTabs.toggleDrawer; `confirm`
           is reserved for the drag-snap and add-to-cart moments. */
        this.setDrawerState(this.drawerState === 'peek' ? 'expanded' : 'peek');
        hubbuilderTriggerHaptic();
      },

      openDrawer() {
        this.setDrawerState('expanded');
        if (typeof window !== 'undefined' && window.innerWidth <= 768 && this.isSummaryReady) {
          this.mobileForceOptions = false;
        }
        if (typeof window !== 'undefined' && window.innerWidth <= 768 && this.mobileShowOptions) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.syncMobileDrawerContentScrollLayout();
              const scrollRoot = this.getActiveDrawerContent();
              if (this.isSummaryReady) {
                this.scrollToSummary();
              } else if (scrollRoot) {
                scrollRoot.scrollTo({ top: 0, behavior: 'instant' });
              }
            }, 180);
          });
        }
      },

      closeMobileSummarySheet() {
        if (!hubbuilderMobileWizardActive(this)) return;
        this.mobileForceOptions = true;
      },

      /** Summary drawer back: reset build then return to options (replaces footer reset on summary). */
      backFromMobileSummary() {
        if (!hubbuilderMobileWizardActive(this)) return;
        const f = this.getActiveFormData();
        if (f && typeof f.clearSelections === 'function') {
          try { f.clearSelections(true); } catch (_) { /* defensive: never block nav */ }
        }
        this.hasShownSummary = false;
        this.mobileForceOptions = true;
        this.openFirstDropdown();
        this.$nextTick(() => this.scrollDrawerToTop('auto'));
      },

      _setupMobileSummarySheetA11y() {
        if (this._mobileSummaryA11yActive || !hubbuilderMobileWizardActive(this)) return;
        this._mobileSummaryA11yActive = true;
        this._mobileSummaryPrevFocus = document.activeElement;
        document.body.classList.add('wheelbuilder-mobile-summary-sheet-open');
        document.documentElement.classList.add('wheelbuilder-mobile-summary-sheet-open');
        document.body.style.overflow = 'hidden';
        const panel = this.getDrawerPanel();
        this._mobileSummaryInertTargets = [];
        if (panel && typeof panel.querySelectorAll === 'function') {
          panel.querySelectorAll(':scope > *').forEach((child) => {
            if (child.classList && child.classList.contains('wheelbuilder-mobile-panel-footer')) return;
            child.setAttribute('inert', '');
            this._mobileSummaryInertTargets.push(child);
          });
        }
        this._mobileSummaryEscapeHandler = (e) => {
          if (e.key !== 'Escape') return;
          const sheet = getVisibleHubbuilderSummarySheet();
          if (!sheet) return;
          e.preventDefault();
          e.stopPropagation();
          this.closeMobileSummarySheet();
        };
        document.addEventListener('keydown', this._mobileSummaryEscapeHandler, true);
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshSelectedFormSummaryRows();
            const sheet = getVisibleHubbuilderSummarySheet();
            if (!sheet || !this._mobileSummaryA11yActive) return;
            this._mobileSummarySheetTrap?.deactivate();
            this._mobileSummarySheetTrap = createHubbuilderFocusTrap(sheet, this._mobileSummaryPrevFocus);
            this._mobileSummarySheetTrap.activate();
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                hubbuilderScrollMobileSummaryCardToCenter(
                  hubbuilderPrefersReducedMotion() ? 'auto' : 'smooth',
                );
              });
            });
          }, 80);
        });
      },

      _teardownMobileSummarySheetA11y() {
        if (!this._mobileSummaryA11yActive) return;
        this._mobileSummaryA11yActive = false;
        document.body.classList.remove('wheelbuilder-mobile-summary-sheet-open');
        document.documentElement.classList.remove('wheelbuilder-mobile-summary-sheet-open');
        document.body.style.overflow = '';
        if (Array.isArray(this._mobileSummaryInertTargets)) {
          this._mobileSummaryInertTargets.forEach((el) => {
            try {
              el.removeAttribute('inert');
            } catch (_) {}
          });
          this._mobileSummaryInertTargets = null;
        }
        this.getDrawerPanel()?.removeAttribute('inert');
        if (this._mobileSummaryEscapeHandler) {
          document.removeEventListener('keydown', this._mobileSummaryEscapeHandler, true);
          this._mobileSummaryEscapeHandler = null;
        }
        if (this._mobileSummarySheetTrap) {
          this._mobileSummarySheetTrap.deactivate();
          this._mobileSummarySheetTrap = null;
        }
        this._mobileSummaryPrevFocus = null;
      },

      handleDragCancel() {
        if (window.innerWidth > 768) return;
        if (!this.isDragging) return;
        this.isDragging = false;
        const panel = this.getDrawerPanel();
        if (panel) {
          panel.classList.remove('is-dragging', 'is-overdrag');
          panel.style.removeProperty('--drawer-drag');
          panel.style.transition = '';
        }
        this.startY = 0;
        this.startTime = 0;
      },

      handleDragStart(e) {
        if (window.innerWidth > 768) return;
        this.startY = e.touches[0].clientY;
        this.startTime = Date.now();
        this.isDragging = true;
        this.currentY = 0;
        const panel = this.getDrawerPanel();
        if (panel) {
          panel.classList.add('is-dragging');
          panel.style.transition = 'none';
        }
        e.preventDefault();
      },

      handleDragMove(e) {
        if (window.innerWidth > 768) return;
        if (!this.isDragging) return;
        const touchCurrentY = e.touches[0].clientY;
        let deltaY = touchCurrentY - this.startY;
        const atTop = this.drawerState === 'expanded' && deltaY < 0;
        const atBottom = this.drawerState === 'peek' && deltaY > 0;
        const panel = this.getDrawerPanel();
        if (atTop || atBottom) {
          const sign = deltaY < 0 ? -1 : 1;
          const absDelta = Math.abs(deltaY);
          deltaY = sign * Math.log2(1 + absDelta) * 12;
          if (panel) panel.classList.add('is-overdrag');
        } else if (panel) {
          panel.classList.remove('is-overdrag');
        }
        if (panel) panel.style.setProperty('--drawer-drag', `${deltaY}px`);
        e.preventDefault();
      },

      handleDragEnd(e) {
        if (window.innerWidth > 768) return;
        if (!this.isDragging) return;
        this.isDragging = false;
        const touchEndY = e.changedTouches[0].clientY;
        const deltaY = touchEndY - this.startY;
        const dragDuration = Date.now() - this.startTime;
        const velocity = dragDuration > 0 ? deltaY / dragDuration : 0;
        const panel = this.getDrawerPanel();
        if (panel) {
          panel.classList.remove('is-dragging', 'is-overdrag');
          panel.style.transition =
            'transform 0.42s cubic-bezier(0.32, 0.72, 0, 1)';
          panel.style.removeProperty('--drawer-drag');
        }
        const SNAP_DISTANCE = 36;
        const FLICK_VELOCITY = 0.38;
        const moved = Math.abs(deltaY) > SNAP_DISTANCE || Math.abs(velocity) > FLICK_VELOCITY;
        if (moved) {
          if (deltaY > 0) {
            if (this.drawerState === 'expanded') this.setDrawerState('peek');
          } else if (this.drawerState === 'peek') {
            this.setDrawerState('expanded');
          }
          hubbuilderTriggerHaptic('confirm');
        }
        setTimeout(() => {
          if (panel) panel.style.transition = '';
        }, 480);
        this.currentY = 0;
        this.startY = 0;
        this.startTime = 0;
      },

      scrollDrawerToTop(behavior = 'smooth') {
        const drawer = this.getActiveDrawerContent();
        if (!drawer) return;
        drawer.scrollTo({ top: 0, behavior });
      },

      setDesktopSummarySpacerCollapsed(collapsed) {
        if (typeof window === 'undefined' || window.innerWidth <= 768) return;
        const panel = this.getDrawerPanel();
        if (!panel) return;
        panel.classList.toggle('wb-summary-space-collapsed', !!collapsed);
      },

      syncMobileSheet() {
        const shouldTrack = this.isMobileViewport ? this.mobileShowOptions : true;
        if (!shouldTrack) {
          this.hasShownSummary = false;
          this.setDesktopSummarySpacerCollapsed(false);
          return;
        }
        if (this.isSummaryReady) {
          this.setDesktopSummarySpacerCollapsed(false);
          if (this.isMobileViewport) {
            this.refreshSelectedFormSummaryRows();
            if (!this.hasShownSummary) {
              this.setDrawerState('expanded');
            }
          }
          if (!this.hasShownSummary) {
            this.hasShownSummary = true;
            this.$nextTick(() => requestAnimationFrame(() => this.scrollToSummary()));
          }
        } else {
          this.hasShownSummary = false;
          this.setDesktopSummarySpacerCollapsed(false);
        }
      },

      scrollToSummary() {
        const activeForm = this.getActiveFormElement();
        if (!activeForm) return;
        const drawer = this.getActiveDrawerContent();
        const desktopSummary = activeForm.querySelector('.wheelbuilder-summary');
        const desktopShell = activeForm.querySelector('.wheelbuilder-summary-desktop-shell');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const run = () => {
          if (typeof window !== 'undefined' && window.innerWidth > 768) {
            if (drawer) drawer.scrollTo({ top: 0, behavior: 'auto' });
            const scrollTarget = desktopShell || desktopSummary;
            if (scrollTarget) {
              const rect = scrollTarget.getBoundingClientRect();
              const closeEnough = Math.abs(rect.top) < window.innerHeight * 0.5;
              scrollTarget.scrollIntoView({
                behavior: closeEnough ? motion : 'auto',
                block: 'center',
              });
              // Keep large spacer during travel, then quickly collapse it once summary settles.
              const settleDelay = closeEnough ? 220 : 120;
              setTimeout(() => {
                this.setDesktopSummarySpacerCollapsed(true);
              }, settleDelay);
            } else {
              hubbuilderScrollBuilderMediaIntoView('auto');
            }
            return;
          }

          hubbuilderScrollBuilderMediaIntoView('auto');
          if (drawer && desktopSummary && drawer.contains(desktopSummary)) {
            try {
              const drawerScrollable = drawer.scrollHeight > drawer.clientHeight + 12;
              if (drawerScrollable) {
                const rect = desktopSummary.getBoundingClientRect();
                const cr = drawer.getBoundingClientRect();
                const relTop = rect.top - cr.top + drawer.scrollTop;
                const target = relTop - (drawer.clientHeight - rect.height) / 2;
                drawer.scrollTo({
                  top: Math.max(0, Math.min(target, drawer.scrollHeight - drawer.clientHeight)),
                  behavior: motion,
                });
              }
            } catch (_) {}
          }
        };

        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
          requestAnimationFrame(() => requestAnimationFrame(run));
          return;
        }
        setTimeout(run, 200);
      },

      refreshSelectedFormSummaryRows() {
        const el = this.getActiveFormElement();
        const fd = hubGetAlpineData(el);
        if (fd && typeof fd.syncMobileSummarySheetRows === 'function') fd.syncMobileSummarySheetRows();
      },

      wbDrawerSummaryHeaderVisible() {
        return this.mobileStep === 'summary';
      },

      getTabpanelsContainer() {
        return this.$el?.querySelector?.('[role="tabpanels"]') || null;
      },

      getPanelSectionForSelectedTab() {
        const tabpanels = this.getTabpanelsContainer();
        if (!tabpanels || !this.selectedTab) return null;
        const tabIndex = labels.indexOf(this.selectedTab);
        if (tabIndex < 0) return null;
        const sections = tabpanels.querySelectorAll(':scope > section');
        return sections[tabIndex] || null;
      },

      getActivePanelSection() {
        const form = this.getActiveFormElement();
        const sec = form?.closest?.("section[role='tabpanel']");
        if (sec) return sec;
        return this.getPanelSectionForSelectedTab();
      },

      /** Form root for `selectedTab` by DOM index (works while Alpine `x-show` still toggles `display`). */
      getFormElementBySelectedTab() {
        const section = this.getPanelSectionForSelectedTab();
        return section?.querySelector('[x-data^="hubBuilderForm"]') || null;
      },

      /**
       * Active form: match wheelBuilder.js — pick a **visible** `tabpanel` whose `data-wb-panel-tab`
       * matches `selectedTab` first, so we never bind scroll / footer / `syncMobileDrawerContentScrollLayout`
       * to a `display:none` section (breaks autoscroll + mobile drawer max-height). Then index, then
       * first visible (Alpine `x-show` edge cases).
       */
      getActiveFormElement() {
        const tabpanels = this.getTabpanelsContainer();
        if (!tabpanels) return null;
        const selected = this.selectedTab;
        const sections = Array.from(tabpanels.querySelectorAll(':scope > section'));

        if (!selected) {
          const visiblePanel = sections.find((p) => window.getComputedStyle(p).display !== 'none');
          return visiblePanel?.querySelector('[x-data^="hubBuilderForm"]') || null;
        }

        for (const panel of sections) {
          if (window.getComputedStyle(panel).display === 'none') continue;
          const form = panel.querySelector('[x-data^="hubBuilderForm"]');
          if (form && hubbuilderReadPanelTab(form) === selected) return form;
        }

        const tabIndex = labels.indexOf(selected);
        if (tabIndex >= 0 && sections[tabIndex]) {
          const form = sections[tabIndex].querySelector('[x-data^="hubBuilderForm"]');
          if (form) return form;
        }

        const visiblePanel = sections.find((p) => window.getComputedStyle(p).display !== 'none');
        return visiblePanel?.querySelector('[x-data^="hubBuilderForm"]') || null;
      },

      getActiveFormData() {
        let d = hubGetAlpineData(this.getActiveFormElement());
        if (d) return d;
        return hubGetAlpineData(this.getFormElementBySelectedTab());
      },

      /** Footer actions should target the most relevant form even if selectedTab/display are mid-transition. */
      getFooterActionFormData() {
        const root = this.$root || this.$el;
        const formEls =
          root && typeof root.querySelectorAll === 'function'
            ? Array.from(root.querySelectorAll('[x-data^="hubBuilderForm"]'))
            : [];
        const preferred = [this.getFormElementBySelectedTab(), this.getActiveFormElement()].filter(Boolean);
        const orderedEls = [...preferred, ...formEls];
        const seenEls = new Set();
        const forms = [];
        for (const el of orderedEls) {
          if (!el || seenEls.has(el)) continue;
          seenEls.add(el);
          const d = hubGetAlpineData(el);
          if (d) forms.push(d);
        }
        if (forms.length === 0) return this.getActiveFormData();
        const added = forms.find((f) => !!f.addedToCart);
        if (added) return added;
        const ready = forms.find(
          (f) => typeof f.isReadyForSummary === 'function' && f.isReadyForSummary() && !f.loading,
        );
        if (ready) return ready;
        const complete = forms.find((f) => computeHubBuilderFormEveryOptionSelected(f));
        return complete || forms[0];
      },

      getActiveDrawerContent() {
        const fromVisible = this.getActiveFormElement()?.querySelector('.drawer-content');
        if (fromVisible) return fromVisible;
        const section = this.getPanelSectionForSelectedTab();
        return section?.querySelector('.drawer-content') ?? null;
      },

      getActiveMobileOptionsScrollRoot() {
        return this.getActiveDrawerContent();
      },

      _clearActiveDrawerContentScrollStyles() {
        const el = this.getActiveDrawerContent();
        if (!el) return;
        el.style.removeProperty('max-height');
        el.style.removeProperty('overflow-y');
        el.style.removeProperty('-webkit-overflow-scrolling');
      },

      _clearAllDrawerContentScrollStyles() {
        const root = this.$root || this.$el;
        if (!root || typeof root.querySelectorAll !== 'function') return;
        root.querySelectorAll('.drawer-content').forEach((el) => {
          el.style.removeProperty('max-height');
          el.style.removeProperty('overflow-y');
          el.style.removeProperty('-webkit-overflow-scrolling');
        });
      },

      syncMobileDrawerContentScrollLayout(retry = 0) {
        if (typeof window === 'undefined') return;
        if (window.innerWidth > 768) {
          this._clearAllDrawerContentScrollStyles();
          return;
        }
        const panel = this.getDrawerPanel();
        if (!panel || !panel.classList.contains('is-expanded') || panel.classList.contains('is-chooser') || this.mobileStep === 'cart-added') {
          this._clearActiveDrawerContentScrollStyles();
          return;
        }
        if (!this.mobileShowOptions) {
          this._clearActiveDrawerContentScrollStyles();
          return;
        }
        const drawer = this.getActiveDrawerContent();
        if (!drawer) return;
        const dcs = window.getComputedStyle(drawer);
        if (dcs.display === 'none' || dcs.visibility === 'hidden') return;
        const panelRect = panel.getBoundingClientRect();
        const drawerRect = drawer.getBoundingClientRect();
        const footer = panel.querySelector('.wheelbuilder-mobile-panel-footer');
        let footerH = 0;
        if (footer) {
          const fs = window.getComputedStyle(footer);
          if (fs.display !== 'none' && fs.visibility !== 'hidden') {
            footerH = footer.getBoundingClientRect().height;
          }
        }
        const insetBottom = 12;
        const availableBottom = panelRect.bottom - footerH - insetBottom;
        let maxH = Math.floor(availableBottom - drawerRect.top);
        if (maxH < 80 && retry < 10) {
          this.$nextTick(() => {
            requestAnimationFrame(() => this.syncMobileDrawerContentScrollLayout(retry + 1));
          });
          return;
        }
        if (maxH < 80) return;
        maxH = Math.max(120, maxH);
        drawer.style.setProperty('max-height', `${maxH}px`, 'important');
        drawer.style.setProperty('overflow-y', 'auto', 'important');
        drawer.style.setProperty('-webkit-overflow-scrolling', 'touch');
      },

      _ensureMobileDrawerScrollResizeObserver() {
        if (typeof ResizeObserver === 'undefined') return;
        if (this._mobileDrawerScrollRO) return;
        const panel = this.getDrawerPanel();
        if (!panel) return;
        this._mobileDrawerScrollRO = new ResizeObserver(() => this.syncMobileDrawerContentScrollLayout());
        this._mobileDrawerScrollRO.observe(panel);
        const tp = this.getTabpanelsContainer();
        if (tp) this._mobileDrawerScrollRO.observe(tp);
      },

      _teardownMobileDrawerScrollResizeObserver() {
        if (this._mobileDrawerScrollRO) {
          this._mobileDrawerScrollRO.disconnect();
          this._mobileDrawerScrollRO = null;
        }
      },

      setIndicatorPosition(id, listOverride = null) {
        const tab = typeof id === 'string' ? document.getElementById(id) : null;
        const list = listOverride || this.$refs?.tablist;
        if (!tab || !list) {
          if (list && id) {
            let tabIndex = null;
            if (typeof id === 'string') {
              if (id.includes('tab-mobile-')) tabIndex = parseInt(id.split('tab-mobile-')[1], 10);
              else if (id.includes('tab-')) tabIndex = parseInt(id.split('-').pop(), 10) - 1;
            }
            if (tabIndex !== null && tabIndex >= 0) {
              const tabs = list.querySelectorAll('button[role="tab"]');
              if (tabs[tabIndex]) {
                const foundTab = tabs[tabIndex];
                const tabRect = foundTab.getBoundingClientRect();
                const listRect = list.getBoundingClientRect();
                const offset = tabRect.left - listRect.left + list.scrollLeft;
                list.style.setProperty('--wb-tab-indicator-width', `${tabRect.width}px`);
                list.style.setProperty('--wb-tab-indicator-offset', `${offset}px`);
              }
            }
          }
          return;
        }
        const tabRect = tab.getBoundingClientRect();
        const listRect = list.getBoundingClientRect();
        const offset = tabRect.left - listRect.left + list.scrollLeft;
        list.style.setProperty('--wb-tab-indicator-width', `${tabRect.width}px`);
        list.style.setProperty('--wb-tab-indicator-offset', `${offset}px`);
      },

      wbShowMobilePanelFooter() {
        if (typeof window !== 'undefined' && window.innerWidth > 768) return false;
        if (this.drawerState !== 'expanded' || !this.mobileShowOptions) return false;
        /* Prefer footer form so cart-added / summary sheet gates match the CTA bindings. */
        const f =
          (typeof this.getFooterActionFormData === 'function' && this.getFooterActionFormData()) ||
          this.getActiveFormData();
        /* Must match wheelBuilderTabs: never show the bar without a bound form (blank CTAs + dead clicks). */
        if (!f || typeof f.wbMobileSummarySheetOpen !== 'function') return false;
        return !f.wbMobileSummarySheetOpen();
      },

      runActiveClearSelections() {
        const root = this.$root || this.$el;
        const forms =
          root && typeof root.querySelectorAll === 'function'
            ? Array.from(root.querySelectorAll('[x-data^="hubBuilderForm"]'))
            : [];
        let cleared = false;
        for (const formEl of forms) {
          const f = hubGetAlpineData(formEl);
          if (f && typeof f.clearSelections === 'function') {
            f.clearSelections();
            cleared = true;
          }
        }
        if (!cleared) {
          const fallback = this.getFooterActionFormData();
          if (fallback && typeof fallback.clearSelections === 'function') fallback.clearSelections();
        }
      },

      runActiveMobileCartClick() {
        const f = this.getFooterActionFormData();
        if (!f) return;
        /* Re-entry guard — see wheelBuilder.js runActiveMobileCartClick. */
        if (f.isCheckingOut) return;

        if (f.addedToCart) {
          if (typeof f.goToCheckout === 'function') f.goToCheckout();
          return;
        }
        if (f.loading || f.addToCartSubmitting) return;

        if (typeof f.addToCart === 'function') {
          // Let the form-level addToCart() perform final validation + error handling.
          f.addToCart();
        }
      },

      activeMobileCartDisabled() {
        const f = this.getFooterActionFormData();
        if (!f) return true;
        if (f.addedToCart) return false;
        /* `f.error` matches wheelBuilderTabs.activeMobileCartDisabled — an errored
           build must not leave a tappable CTA (button shows the error copy). */
        return !!(
          !f.isReadyForSummary?.() ||
          f.unavailable ||
          f.error ||
          f.addToCartSubmitting ||
          f.isFetchingProducts ||
          f.hubColorsLoading ||
          f.fetchingHubInventory ||
          (f.pricing && f.pricing.loading)
        );
      },

      /** Split pay-row: tap on the price column runs the same cart CTA handler. */
      runPayRowCartClick(event) {
        const row = event?.currentTarget;
        if (!row?.classList?.contains('has-price')) return;
        if (event.target.closest('.wheelbuilder-cart-btn')) return;
        const btn = row.querySelector('.wheelbuilder-cart-btn');
        if (!btn || btn.disabled) return;
        btn.click();
      },

      footerIsReadyForSummary() {
        const f = this.getFooterActionFormData();
        return !!(f && typeof f.isReadyForSummary === 'function' && f.isReadyForSummary());
      },

      /** Options complete on footer tab (pricing may still resolve). Mirrors wheel `isSummaryReady`. */
      footerIsSummaryReady() {
        const f = this.getFooterActionFormData();
        return !!(f && typeof f.canShowMobileSummary === 'function' && f.canShowMobileSummary());
      },

      footerCoreBusy() {
        const f = this.getFooterActionFormData();
        if (!f) return false;
        return !!(
          f.isFetchingProducts ||
          f.hubColorsLoading ||
          f.fetchingHubInventory ||
          (f.pricing && f.pricing.loading)
        );
      },

      footerBusyOverlayVisible() {
        /* Depend on epoch so tabs re-evaluate when form flips addToCartSubmitting
           (cross-component Alpine; DOM query in getFooterActionFormData alone
           does not always re-run peek/footer x-if). */
        void this._formStateEpoch;
        const f = this.getFooterActionFormData();
        if (!f) return false;
        // Do NOT include f.loading here — the .loading CSS class handles the cart animation.
        // Only show the overlay for build resolution (fetching products / resolving price).
        return !!f.cartBtnBusyOverlayVisible;
      },

      openFirstDropdown() {
        const section = this.getPanelSectionForSelectedTab() || this.getActivePanelSection();
        if (!section) return;
        const form = section.querySelector('[x-data^="hubBuilderForm"]');
        const fd = form ? hubGetAlpineData(form) : null;
        /* Open first UNFILLED option, not blindly index 0. See the matching
           comment in `wheelBuilder.js openFirstDropdown` for the full rationale —
           short version: blindly opening index 0 means a preset / deep-linked
           build (or a returning user) sees an already-filled accordion popped
           open, while the next-needed accordion stays collapsed. Skip filled
           options + constraint-disabled options; fall back to index 0 if every
           option is filled (so choice tiles stay visible instead of an all-
           collapsed stack). */
        if (fd && Array.isArray(fd.completeOptions)) {
          const opts = fd.completeOptions;
          let targetIdx = -1;
          for (let i = 0; i < opts.length; i++) {
            const o = opts[i];
            if (!o) continue;
            if (String(o.value || "").trim()) continue;
            if (typeof fd.isInputGroupDisabled === "function" && fd.isInputGroupDisabled(o.id)) continue;
            targetIdx = i;
            break;
          }
          if (targetIdx === -1) targetIdx = 0;
          opts.forEach((option, index) => {
            if (!option) return;
            option.expanded = index === targetIdx;
          });
        }
      },

      openFirstDropdownAndScroll() {
        this.openFirstDropdown();
        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
          setTimeout(() => {
            const scrollRoot = this.getActiveMobileOptionsScrollRoot();
            if (scrollRoot) scrollRoot.scrollTo({ top: 0, behavior: 'auto' });
          }, 120);
        }
      },

      resetAllForms() {
        const root = this.$root || this.$el;
        const allForms =
          root && typeof root.querySelectorAll === 'function'
            ? root.querySelectorAll('[x-data^="hubBuilderForm"]')
            : [];
        allForms.forEach((form) => {
          form.querySelectorAll('input[type="radio"]').forEach((r) => {
            r.checked = false;
          });
          const d = hubGetAlpineData(form);
          if (d && typeof d.clearSelections === 'function') d.clearSelections();
        });
      },

      selectMobileNav(id, tabIndex) {
        const tabKey = labels[tabIndex];
        this.selectedTabLabel =
          tabKey === 'complete'
            ? 'Hubset'
            : tabKey === 'stem'
              ? 'Stem'
              : tabKey === 'front'
                ? 'Front hub'
                : tabKey === 'rear'
                  ? 'Rear hub'
                  : tabKey === 'driver'
                    ? 'Driver'
                    : tabKey
                      .split('_')
                      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                      .join(' ');
        this.setWizardDirection('forward');
        this.beginScreenTransition(440);
        this.mobileShowOptions = true;
        this.hasShownSummary = false;
        this.select(id, tabIndex, { fromMobileChooser: true });
        if (window.innerWidth <= 768 && this.drawerState !== 'expanded') {
          this.setDrawerState('expanded');
        }
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.syncMobileDrawerContentScrollLayout();
            requestAnimationFrame(() => {
              const scrollRoot = this.getActiveMobileOptionsScrollRoot();
              if (scrollRoot) scrollRoot.scrollTo({ top: 0, behavior: 'auto' });
            });
          });
          if (this.$refs?.tablistMobile) {
            this.$refs.tablistMobile.style.setProperty('--wb-tab-active-index', String(tabIndex));
            const mobileTabs = this.$refs.tablistMobile.querySelectorAll('button[role="tab"]');
            if (mobileTabs[tabIndex]) {
              const t = mobileTabs[tabIndex];
              const tabRect = t.getBoundingClientRect();
              const listRect = this.$refs.tablistMobile.getBoundingClientRect();
              const offset = tabRect.left - listRect.left + this.$refs.tablistMobile.scrollLeft;
              this.$refs.tablistMobile.style.setProperty('--wb-tab-indicator-width', `${tabRect.width}px`);
              this.$refs.tablistMobile.style.setProperty('--wb-tab-indicator-offset', `${offset}px`);
            }
          }
        });
      },

      backToMobileNav() {
        if (this.singleTabMode || (Array.isArray(this.labels) && this.labels.length === 1)) {
          return;
        }
        /* Reset the active form on back-out so the chooser opens onto a clean
           build (matches wheelBuilderTabs.backToMobileNav). */
        const f = this.getActiveFormData();
        if (f && typeof f.clearSelections === 'function') {
          try { f.clearSelections(); } catch (_) { /* defensive: never block nav */ }
        }
        this.setWizardDirection('backward');
        this.beginScreenTransition(440);
        this.mobileShowOptions = false;
        this.selectedTabLabel = '';
        this.setDrawerState('expanded');
        this.$nextTick(() => this.scrollDrawerToTop('auto'));
      },

      select(id, tabIndexOverride = null, options = {}) {
        const fromMobileChooser = options && options.fromMobileChooser === true;
        const skipInitialLayoutScroll =
          options && typeof options === 'object' && options.skipInitialLayoutScroll === true;
        let tabIndex = tabIndexOverride;
        if (tabIndex === null || tabIndex === undefined) {
          if (id && String(id).includes('tab-mobile-')) {
            const parts = String(id).split('tab-mobile-');
            tabIndex = parseInt(parts[1], 10) || 0;
          } else if (id && String(id).includes('tab-')) {
            const parts = String(id).split('-');
            const last = parseInt(parts[parts.length - 1], 10);
            tabIndex = Number.isNaN(last) ? 0 : last - 1;
          } else {
            tabIndex = 0;
          }
        }
        if (tabIndex < 0 || tabIndex >= labels.length) tabIndex = 0;

        const previousTab = this.selectedTab;
        const newTab = labels[tabIndex];
        const isReturningToSameTab = previousTab === newTab;

        const desktopTabId = this.$id('tab', tabIndex + 1);
        this.selectedId = id || desktopTabId;
        this.selectedTab = newTab;

        hubbuilderTriggerHaptic();

        if (previousTab && previousTab !== labels[tabIndex]) {
          this.progress = 0;
          this.resetAllForms();
          document.dispatchEvent(new CustomEvent('wheelbuilder:tab-changed'));
          document.dispatchEvent(new CustomEvent('wheelbuilder:selections-cleared'));
        }

        this.$nextTick(() => {
          if (this.$refs?.tablist) {
            this.$refs.tablist.style.setProperty('--wb-tab-active-index', String(tabIndex));
          }
          if (this.$refs?.tablistMobile) {
            this.$refs.tablistMobile.style.setProperty('--wb-tab-active-index', String(tabIndex));
          }
          this.setIndicatorPosition(this.selectedId);
          setTimeout(() => {
            this.syncMobileDrawerContentScrollLayout();
            const activeDrawerContent = this.getActiveDrawerContent();
            if (skipInitialLayoutScroll) {
              this.openFirstDropdown();
            } else if (isReturningToSameTab && !fromMobileChooser) {
              if (window.innerWidth <= 768 && activeDrawerContent) {
                activeDrawerContent.scrollTo({ top: 0, behavior: 'auto' });
              }
            } else {
              if (window.innerWidth <= 768 && activeDrawerContent) {
                activeDrawerContent.scrollTo({ top: 0, behavior: 'auto' });
              }
              this.openFirstDropdownAndScroll();
            }
          }, 100);
          setTimeout(() => this.updateProgress(), 100);
        });
      },

      whichChild(child, parent) {
        try {
          return Array.from(parent.children).indexOf(child) + 1;
        } catch (e) {
          return 1;
        }
      },

      isSelected(id) {
        return this.selectedId === id;
      },

      syncVprogressRailFixedLayout() {
        if (typeof document === 'undefined') return;
        document.documentElement.style.removeProperty('--wb-vprogress-fixed-right');
      },

      progressRailDotIndices() {
        const n = Number(this.progressRailSteps) || 0;
        if (n <= 0) return [];
        return Array.from({ length: n }, (_, i) => i);
      },

      progressRailFilledSteps() {
        const n = Number(this.progressRailSteps) || 0;
        if (n <= 0) return 0;
        const p = Number(this.progress) || 0;
        return Math.min(n, Math.max(0, Math.round((p / 100) * n)));
      },

      updateProgress() {
        if (!this.labels || this.labels.indexOf(this.selectedTab) === -1) {
          this.progress = 0;
          this.progressRailSteps = 0;
          return;
        }

        const tabpanelsContainer = this.getTabpanelsContainer();
        if (!tabpanelsContainer) {
          this.progress = 0;
          this.progressRailSteps = 0;
          return;
        }

        let currentSection = this.getActivePanelSection();
        if (!currentSection) {
          const tabIndex = this.labels.indexOf(this.selectedTab);
          const sections = tabpanelsContainer.querySelectorAll(':scope > section');
          currentSection = sections[tabIndex] || null;
        }

        if (!currentSection) {
          this.progress = 0;
          this.progressRailSteps = 0;
          return;
        }

        const groups = currentSection.querySelectorAll('[data-option-group]');
        if (groups.length === 0) {
          this.progress = 0;
          this.progressRailSteps = 0;
          return;
        }

        this.progressRailSteps = groups.length;

        let filled = 0;
        groups.forEach((group) => {
          const checked = group.querySelector('input[type="radio"]:checked');
          if (checked && checked.value) filled++;
        });

        const newProgress = Math.round((filled / groups.length) * 100);
        const prevProgress = this.progress;
        this.progress = newProgress;

        if (
          typeof window !== 'undefined' &&
          window.innerWidth <= 768 &&
          newProgress === 100 &&
          prevProgress < 100 &&
          this.mobileShowOptions &&
          !this.mobileForceOptions
        ) {
          this.setWizardDirection('forward');
          this.beginScreenTransition(440);
        }

        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
          this.syncMobileSheet();
        } else if (newProgress === 100) {
          this.$nextTick(() => {
            const addToCartBtn = currentSection.querySelector('.wheelbuilder-btn-add');
            if (addToCartBtn && !addToCartBtn.disabled) {
              addToCartBtn.focus();
            }
          });
        }

        this.syncMobileFooterStore();
      },

      async fetchRules() {
        this.fetchingRules = true;
        this.ruleFetchError = null;
        window.__HUB_RULES_FETCHING__ = true;
        window.__HUB_RULES_ERROR__ = null;
        const hrs = hubRulesStore();
        if (hrs) {
          hrs.fetching = true;
          hrs.error = null;
        }
        try {
          const hubModel = hbGetRulesModelRaw(this);
          if (!hubModel && !this.model) {
            this.rules = [];
            this.hubRulesIndex = null;
            window.__HUB_RULES__ = [];
            window.__HUB_RULES_INDEX__ = null;
            return;
          }

          if (this.ecomEngineUrl && String(this.ecomEngineUrl).trim()) {
            const ecomBase = String(this.ecomEngineUrl).trim();
            const ecomPath = (this.ecomEngineApiPath || '').trim() || undefined;
            const region = hbDetectRegion();
            const modelForApi = hubModel || this.model;
            const rulesIndexRes = await fetchHubRulesIndexFromApi(
              ecomBase,
              ecomPath,
              modelForApi,
              region,
            );
            if (rulesIndexRes.rulesIndex?.configs?.length) {
              this.hubRulesIndex = rulesIndexRes.rulesIndex;
              this.rules = [];
              window.__HUB_RULES_INDEX__ = this.hubRulesIndex;
              window.__HUB_RULES__ = [];
              console.log('[HubBuilder] Rules index loaded (memory)', {
                hub_model: modelForApi,
                configs: this.hubRulesIndex.configs.length,
                region,
              });
            } else {
              this.hubRulesIndex = null;
              console.warn(
                '[HubBuilder] Rules index unavailable, falling back to paginated meta-objects API:',
                rulesIndexRes.errors || 'unknown',
              );
              const pageRes = await fetchHubRulesPageFromApi(ecomBase, ecomPath, modelForApi);
              if (pageRes.error) throw new Error(pageRes.error);
              this.rules = pageRes.rules || [];
              window.__HUB_RULES__ = this.rules;
              window.__HUB_RULES_INDEX__ = null;
            }
          } else {
            this.hubRulesIndex = null;
            window.__HUB_RULES_INDEX__ = null;
            const { rules, error } = await fetchHubRulesFromShopify(this.model);
            if (error) throw new Error(error);
            this.rules = rules || [];
            window.__HUB_RULES__ = this.rules;
          }
        } catch (e) {
          const paste = {
            message: e?.message,
            name: e?.name,
            lastGraphQL: window.__HUB_RULES_LAST_GRAPHQL_DIAG__,
            lastFetch: window.__HUB_RULES_LAST_FETCH_DIAG__,
            model: this.model,
            rulesModel: hbGetRulesModelRaw(this),
          };
          console.error('[HubBuilder] fetchRules error', e);
          console.error('[HubBuilder] RULES_FETCH — paste this object for debugging:', paste);
          this.ruleFetchError = 'Failed to load rules';
          window.__HUB_RULES_ERROR__ = this.ruleFetchError;
        } finally {
          this.fetchingRules = false;
          window.__HUB_RULES_FETCHING__ = false;
          const hrsDone = hubRulesStore();
          if (hrsDone) {
            hrsDone.fetching = false;
            hrsDone.error = this.ruleFetchError;
          }
          document.dispatchEvent(new CustomEvent('wheelbuilder:rules-loaded'));
        }
      },

      async fetchStemRules() {
        this.fetchingRules = true;
        this.ruleFetchError = null;
        if (typeof window !== 'undefined') {
          window.__STEM_RULES_FETCHING__ = true;
          window.__STEM_RULES_ERROR__ = null;
        }
        const hrs = hubRulesStore();
        if (hrs) {
          hrs.fetching = true;
          hrs.error = null;
        }
        try {
          const stemModel = hbGetStemRulesModelRaw(this);
          if (!stemModel && !this.model) {
            this.rules = [];
            this.hubRulesIndex = null;
            if (typeof window !== 'undefined') {
              window.__STEM_RULES__ = [];
              window.__STEM_RULES_INDEX__ = null;
            }
            return;
          }

          if (this.ecomEngineUrl && String(this.ecomEngineUrl).trim()) {
            const ecomBase = String(this.ecomEngineUrl).trim();
            const ecomPath = (this.ecomEngineApiPath || '').trim() || undefined;
            const region = hbDetectRegion();
            const modelForApi = stemModel || this.model;
            const rulesIndexRes = await fetchStemRulesIndexFromApi(
              ecomBase,
              ecomPath,
              modelForApi,
              region,
            );
            if (rulesIndexRes.rulesIndex?.configs?.length) {
              this.hubRulesIndex = rulesIndexRes.rulesIndex;
              this.rules = [];
              if (typeof window !== 'undefined') {
                window.__STEM_RULES__ = [];
                window.__STEM_RULES_INDEX__ = this.hubRulesIndex;
              }
              console.log('[StemBuilder] Rules index loaded (memory)', {
                stem_model: modelForApi,
                configs: this.hubRulesIndex.configs.length,
              });
            } else {
              this.hubRulesIndex = null;
              const pageRes = await fetchStemRulesPageFromApi(ecomBase, ecomPath, modelForApi);
              if (pageRes.error) throw new Error(pageRes.error);
              this.rules = pageRes.rules || [];
              if (typeof window !== 'undefined') {
                window.__STEM_RULES__ = this.rules;
                window.__STEM_RULES_INDEX__ = null;
              }
            }
          } else {
            this.hubRulesIndex = null;
            const { rules, error } = await fetchStemRulesFromShopify(this.model);
            if (error) throw new Error(error);
            this.rules = rules || [];
            if (typeof window !== 'undefined') {
              window.__STEM_RULES__ = this.rules;
              window.__STEM_RULES_INDEX__ = null;
            }
          }
          stemDebugLog('fetchStemRules (tabs) ok', {
            model: this.model,
            rulesModel: stemModel,
            indexConfigs: this.hubRulesIndex?.configs?.length ?? 0,
            ruleCount: this.rules.length,
          });
        } catch (e) {
          const paste = {
            message: e?.message,
            name: e?.name,
            lastGraphQL: typeof window !== 'undefined' ? window.__STEM_RULES_LAST_GRAPHQL_DIAG__ : undefined,
            lastFetch: typeof window !== 'undefined' ? window.__STEM_RULES_LAST_FETCH_DIAG__ : undefined,
            model: this.model,
          };
          console.error('[StemBuilder] fetchStemRules error', e);
          console.error('[StemBuilder] STEM_RULES_FETCH — paste this object for debugging:', paste);
          this.ruleFetchError = 'Failed to load stem rules';
          if (typeof window !== 'undefined') window.__STEM_RULES_ERROR__ = this.ruleFetchError;
        } finally {
          this.fetchingRules = false;
          if (typeof window !== 'undefined') window.__STEM_RULES_FETCHING__ = false;
          const hrsDone = hubRulesStore();
          if (hrsDone) {
            hrsDone.fetching = false;
            hrsDone.error = this.ruleFetchError;
          }
          stemDebugLog('wheelbuilder:rules-loaded dispatch', {
            model: this.model,
            fetchingRules: this.fetchingRules,
            ruleFetchError: this.ruleFetchError,
            rulesLen: Array.isArray(this.rules) ? this.rules.length : null,
          });
          document.dispatchEvent(new CustomEvent('wheelbuilder:rules-loaded'));
        }
      },

      async fetchDriverRules() {
        try {
          const { rules, error } = await fetchDriverRules(this.model);
          if (error) console.warn('[HubBuilder] fetchDriverRules error:', error);
          if (typeof window !== 'undefined') window.__DRIVER_RULES__ = rules || [];
          document.dispatchEvent(new CustomEvent('wheelbuilder:driver-rules-loaded'));
        } catch (e) {
          console.error('[HubBuilder] fetchDriverRules error', e);
          if (typeof window !== 'undefined') window.__DRIVER_RULES__ = [];
        }
      },
    };
  });

    Alpine.data('hubBuilderForm', ({ optionKeys, tab }) => {
      
      return {
      // State
      completeOptions: (optionKeys || []).map((id, i) => ({ id, label: id.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()), value: '', expanded: i === 0 })),
      fetchingHubInventory: false,
      hubColorsLoading: false,
      hasCompletedInventoryCheck: false,
      availableHubColors: [],
      isFetchingProducts: false,
      unavailable: false,
      loading: false,
      addToCartSubmitting: false,
      _suppressHandleValueSet: false,
      error: null,
      pricing: { loading: false, price: null, priceAmount: null, currencyLabel: null, compareAtPrice: null, compareAtPriceAmount: null, savings: null },
      products: { front: null, rear: null },
      normalizedModelKey: null,
      tab: tab || 'complete',
      colorToHandleMap: {},
      driverHandleMap: {},

      /** Rules fetch on `hubBuilderTabs`; read Alpine store so `wheelset-builder-option` reactivity updates (window is not tracked). */
      get fetchingRules() {
        const hrs = hubRulesStore();
        if (hrs && typeof hrs.fetching === 'boolean') return hrs.fetching;
        return !!(
          window.__HUB_RULES_FETCHING__ ||
          (typeof window !== 'undefined' && window.__STEM_RULES_FETCHING__)
        );
      },
      get ruleFetchError() {
        const hrs = hubRulesStore();
        if (hrs && hrs.error != null) return hrs.error;
        return (
          window.__HUB_RULES_ERROR__ ||
          (typeof window !== 'undefined' && window.__STEM_RULES_ERROR__) ||
          null
        );
      },

      // UI flags expected by shared option snippet
      showHubUnavailableMessage: false,
      showProductUnavailableMessage: false,
      loadingOperations: 0,
      addedToCart: false,
      mobileCartAddedOpen: false,
      mobileCartAddedLines: [],
      _mobileCartAddedProducts: null,
      _mobileCartAddedEscapeHandler: null,
      /* Transient "Going to checkout…" busy state — paired with the same
         state in wheelBuilder.js. Flipped true inside `goToCheckout()`
         so the cart-CTA's busy-overlay machinery (spinner + status copy)
         lights up the instant the user taps, before window.location
         actually unloads the page. Without this the tap feels silent
         during the ~200-1500ms navigation window. */
      isCheckingOut: false,
      mobileSummarySheetRows: [],

      init() {
        // Compute normalized key once for matching against Model fields with spaces
        this.normalizedModelKey = (window.__HUB_BUILDER_NORMALIZED_MODEL__
          || normalizeHandleToKey(window.__HUB_BUILDER_MODEL__));
        

        // Watch for option value changes to replicate accordion behavior
        this.watchOptions();

        // Re-apply constraints when async rules index finishes (wheel builder pattern).
        this.rulesLoadedHandler = () => {
          this.applyRuleAvailabilityConstraints();
          if (typeof window !== 'undefined' && window.__STEM_BUILDER__) return;
          if (this.tab !== 'driver') this.updateHubColorAvailability();
          if (this.tab === 'driver') this.updateDriverAvailability();
        };
        document.addEventListener('wheelbuilder:rules-loaded', this.rulesLoadedHandler);

        this.wasComplete = false;
        // Watch for changes in selections and re-apply constraints
        this.$watch('completeOptions', () => {
          this.applyRuleAvailabilityConstraints();
          if (this.tab === 'driver') {
            this.updateDriverAvailability();
          }
          if (this.addedToCart) {
            this.addedToCart = false;
          }
          if (this.mobileCartAddedOpen) {
            this.closeMobileCartAddedSheet();
          }
          if (this.addToCartSubmitting) {
            this.addToCartSubmitting = false;
          }
          const isNowComplete = this.isEveryOptionSelected();
          if (isNowComplete && !this.wasComplete) {
            this.updatePricingForSelectedColor();
          }
          this.wasComplete = isNowComplete;
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        }, { deep: true });

        if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
          this.hubColorsLoading = false;
          this.fetchingHubInventory = false;
          stemDebugGroup('hubBuilderForm init (stem)', () => {
            stemDebugLog('completeOptions', this.completeOptions.map((o) => ({ id: o.id, value: o.value })));
            stemDebugLog('window stem snapshot', {
              __HUB_BUILDER_MODEL__: window.__HUB_BUILDER_MODEL__,
              __HUB_BUILDER_NORMALIZED_MODEL__: window.__HUB_BUILDER_NORMALIZED_MODEL__,
              __STEM_BUILDER_VARIANT_ID__: window.__STEM_BUILDER_VARIANT_ID__,
              __STEM_BUILDER_PRODUCT_HANDLE__: window.__STEM_BUILDER_PRODUCT_HANDLE__,
              __HUB_BUILDER_OPTIONS__: window.__HUB_BUILDER_OPTIONS__,
            });
          });
        } else {
          // Hub color / driver maps load after rules index (see rulesLoadedHandler).
        }

        this.$nextTick(() => this.syncMobileSummarySheetRows());
      },

      // Helpers
      formatLabel(id) {
        // Keep the user-facing label stable even if the underlying key is
        // `driver_style` (legacy) or `driver_type` (renamed definition).
        if (id === 'driver_style' || id === 'driver_type') return 'Driver Type';
        return String(id || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
      },

      /** Swatch image URL for hub / spoke color summary rows; map from `wheelbuilder-color-swatch-assets.liquid`. */
      summaryRowSwatchUrl(option) {
        if (typeof window === 'undefined' || typeof window.wheelbuilderSummarySwatchUrl !== 'function') {
          return '';
        }
        return window.wheelbuilderSummarySwatchUrl(option) || '';
      },

      get validationHint() {
        const empty = this.completeOptions.find((o) => (o.value ?? '') === '');
        return empty ? this.formatLabel(empty.id) : '';
      },

      /** Shown when a later option group is locked (shared `wheelset-builder-option` snippet). */
      get validationLockMessage() {
        const empty = this.completeOptions.find((o) => (o.value ?? '') === '');
        if (!empty) return '';
        return `Please select ${this.formatLabel(empty.id)} first`;
      },

      get wbCopy() {
        const w = typeof window !== 'undefined' ? window.WHEELBUILDER_I18N : null;
        return w && typeof w === 'object' ? w : {};
      },

      _getTabsData() {
        const tabsEl = this.$el?.closest?.('[x-data^="hubBuilderTabs"]');
        return tabsEl ? hubGetAlpineData(tabsEl) : null;
      },

      get progress() {
        return this._getTabsData()?.progress ?? 0;
      },

      wbMobileSummaryStepLocksOptions() {
        const t = this._getTabsData();
        if (typeof window === 'undefined' || !hubbuilderMobileWizardActive(t)) return false;
        return !!(t && t.mobileStep === 'summary');
      },

      showWheelbuilderOptionGroups() {
        const t = this._getTabsData();
        if (hubbuilderMobileWizardActive(t)) {
          // Cart-added step replaces the option groups inline (native drawer page).
          if (this.addedToCart) return false;
          if (!this.canShowMobileSummary()) return true;
          if (!this.wbMobileSummarySheetOpen()) return true;
          return !t?.summarySheetPainted;
        }
        return !this.isEveryOptionSelected();
      },

      canShowMobileSummary() {
        return (
          this.isEveryOptionSelected() &&
          !this.isFetchingProducts &&
          !this.fetchingHubInventory &&
          !this.hubColorsLoading
        );
      },

      getOptionById(id) {
        return this.completeOptions.find((o) => o.id === id) || {};
      },

      summaryCardTintStyle() {
        const fn = typeof window !== 'undefined' ? window.wheelbuilderSummaryTintVars : null;
        if (typeof fn !== 'function') return {};
        const kind = typeof window !== 'undefined' && window.__STEM_BUILDER__ ? 'stem' : 'hub';
        return fn(this.completeOptions, kind);
      },

      _norm(val) {
        return hubNormMatchValue(val);
      },

      _valueInSet(value, set) {
        const n = this._norm(value);
        for (const v of set) {
          if (this._norm(v) === n) return true;
        }
        return false;
      },

      _applyHubRuleConstraintsFromIndex(rulesIndex) {
        const idx = rulesIndex.configIndicesNorm || rulesIndex.configIndices || {};
        const options = rulesIndex.options || {};
        const intersect = (a, b) => {
          if (!a?.length) return b ? [...b] : [];
          if (!b?.length) return a ? [...a] : [];
          const setB = new Set(b);
          return a.filter((x) => setB.has(x));
        };

        for (let index = 0; index < this.completeOptions.length; index++) {
          const option = this.completeOptions[index];
          if (option.id === 'hub_model' || option.id === 'hub_colour' || option.id === 'hub_color') {
            continue;
          }
          const container = (this.$root || this.$el)?.querySelector(`[data-option-group="${option.id}"]`);
          if (!container) continue;

          const priorSelections = {};
          for (let i = 0; i < index; i++) {
            const o = this.completeOptions[i];
            if (o.value) priorSelections[o.id] = o.value;
          }

          let indices = null;
          for (const [key, val] of Object.entries(priorSelections)) {
            const n = this._norm(val);
            const slice = hubRulesIndexPickKey(idx, key);
            const indicesForVal = slice?.[n] ?? slice?.[val];
            if (!indicesForVal?.length) {
              indices = [];
              break;
            }
            indices = indices == null ? indicesForVal : intersect(indices, indicesForVal);
          }

          const tabKey = this.tab === 'front' ? 'front_handle' : this.tab === 'rear' ? 'rear_handle' : 'handle';
          const oosArr = rulesIndex?.unavailable?.[tabKey];
          if (Array.isArray(oosArr) && oosArr.length && indices?.length) {
            const oosSet = new Set(oosArr);
            indices = indices.filter((i) => !oosSet.has(i));
          }

          const uniqueValues = new Set();
          const isDriverField = option.id === 'driver_style' || option.id === 'driver_type' || option.id === 'driver';
          if (indices != null && indices.length > 0) {
            const idxSet = new Set(indices);
            const optionVals = hubRulesIndexPickKey(options, option.id);
            const valueList = Array.isArray(optionVals) ? optionVals : [];
            const idSlice = hubRulesIndexPickKey(idx, option.id);
            for (const v of valueList) {
              const n = this._norm(v);
              const indicesForVal = idSlice?.[n] ?? idSlice?.[v];
              if (indicesForVal?.some((i) => idxSet.has(i))) {
                uniqueValues.add(isDriverField ? normalizeDriverName(v) : v);
              }
            }
          } else if (Object.keys(priorSelections).length === 0) {
            const optionVals = hubRulesIndexPickKey(options, option.id);
            const valueList = Array.isArray(optionVals) ? optionVals : [];
            for (const v of valueList) {
              uniqueValues.add(isDriverField ? normalizeDriverName(v) : v);
            }
          }

          /* Empty uniqueValues = index couldn't narrow (race, transient indices [], etc.). Do not treat as
           * invalid selection — that cleared every value and emptied the mobile summary mid-session. */
          if (
            uniqueValues.size > 0 &&
            option.value &&
            !(isDriverField
              ? uniqueValues.has(normalizeDriverName(option.value))
              : this._valueInSet(option.value, uniqueValues))
          ) {
            for (let i = index; i < this.completeOptions.length; i++) {
              this.completeOptions[i].value = '';
            }
          }

          const valueElements = container.querySelectorAll('[data-value]');
          valueElements.forEach((el) => {
            const value = el.getAttribute('data-value');
            const isInput = el.tagName === 'INPUT';
            const allow = uniqueValues.size === 0 || (isDriverField
              ? uniqueValues.has(normalizeDriverName(value))
              : this._valueInSet(value, uniqueValues));
            if (allow) {
              el.style.display = '';
              el.classList.remove('disabled', 'unavailable');
              if (isInput) el.removeAttribute('disabled');
            } else {
              el.style.display = 'none';
              el.classList.add('disabled', 'unavailable');
              if (isInput) el.setAttribute('disabled', 'true');
            }
          });
        }
      },

      isEveryOptionSelected() {
        return this.completeOptions.every((o) => (o.value ?? '') !== '');
      },

      isInputGroupDisabled(key) {
        const found = this.getOptionById(key);
        const idx = this.completeOptions.indexOf(found);
        if (idx <= 0) return false;
        return (this.completeOptions[idx - 1].value ?? '') === '';
      },

      resetProductsAndAvailability() {
        this.products = { front: null, rear: null };
        this.unavailable = false;
        this.error = null;
        this.pricing = {
          loading: false,
          price: null,
          priceAmount: null,
          currencyLabel: null,
          compareAtPrice: null,
          compareAtPriceAmount: null,
          savings: null,
        };
        this.hasCompletedInventoryCheck = false;
      },

      clearSelections(silent = false) {
        if (!silent) {
          hubbuilderTriggerHaptic('error');
        }

        this._suppressHandleValueSet = true;

        this.addedToCart = false;
        this.addToCartSubmitting = false;
        this.closeMobileCartAddedSheet();
        /* Defensive: same rationale as wheelBuilder.js → clearSelections.
           Reset is the user's escape hatch if they got stranded mid-
           checkout-nav; make sure it actually escapes. */
        this.isCheckingOut = false;
        if (this._checkoutWatchdogId) {
          clearTimeout(this._checkoutWatchdogId);
          this._checkoutWatchdogId = null;
        }

        const root = this.$root || this.$el;
        if (root && typeof root.querySelectorAll === 'function') {
          root.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.checked = false;
          });
        }

        this.completeOptions.forEach((option, index) => {
          option.value = '';
          option.expanded = index === 0;
        });

        this.resetProductsAndAvailability();
        this.wasComplete = false;
        this.mobileSummarySheetRows = [];

        document.dispatchEvent(new CustomEvent('wheelbuilder:selections-cleared'));
        document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));

        this.$nextTick(() => {
          this._suppressHandleValueSet = false;
          if (!silent && typeof window !== 'undefined' && window.innerWidth <= 768) {
            const drawerContent =
              this.$el && typeof this.$el.querySelector === 'function'
                ? this.$el.querySelector('.drawer-content')
                : null;
            if (drawerContent) {
              drawerContent.scrollTo({ top: 0, behavior: 'auto' });
            }
          }
        });
      },

      isReadyForSummary() {
        if (!this.isEveryOptionSelected()) return false;
        if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
          if (this.pricing && this.pricing.loading) return false;
          return !!(this.pricing && this.pricing.price);
        }
        if (this.fetchingHubInventory || this.hubColorsLoading) return false;
        if (this.pricing && this.pricing.loading) return false;
        return !!(this.pricing && this.pricing.price);
      },

      wbMobileSummarySheetOpen() {
        // Cart-added step replaces the summary sheet.
        if (this.addedToCart) return false;
        const t = this._getTabsData();
        if (!t || typeof t.getActiveFormElement !== 'function') return false;
        const mobile = hubbuilderMobileWizardActive(t);
        const myTab = hubbuilderReadPanelTab(this.$el);
        if (!myTab || myTab !== t.selectedTab) return false;
        if (!this.canShowMobileSummary()) return false;

        const activeForm = t.getActiveFormElement();
        const activeTab = activeForm ? hubbuilderReadPanelTab(activeForm) : '';
        const sheetForThisPanel =
          (activeTab && activeTab === myTab) ||
          ((!activeForm || !activeTab) && myTab === t.selectedTab);
        return !!(mobile && !t.mobileForceOptions && sheetForThisPanel);
      },

      syncMobileSummarySheetRows() {
        const co = this.completeOptions;
        if (!Array.isArray(co) || co.length === 0) {
          this.mobileSummarySheetRows = [];
          return;
        }
        this.mobileSummarySheetRows = co
          .filter((o) => o && String(o.value ?? '').trim() !== '')
          .map((o) => ({
            id: o?.id != null ? String(o.id) : '',
            value: o?.value != null ? String(o.value) : '',
          }));
      },

      goToCheckout() {
        /* Self-debounce — see wheelBuilder.js → goToCheckout for the
           full rationale. One ask, one trip; subsequent taps during
           rAF do nothing. */
        if (this.isCheckingOut) return;

        /* Same orchestration as wheelBuilder.js → `goToCheckout`. Steps
           run inside one synchronous click-handler tick so iOS transient
           user-activation is still alive for the haptic:

           1. Haptic FIRST (still inside activation window).
           2. Flip `isCheckingOut` → cartBtnBusyOverlayVisible getter
              flips true → existing spinner + "Going to checkout…" copy
              paints on both the expanded footer button AND the peek
              mirror (they share `getFooterActionFormData()`).
           3. Broadcast `wheelbuilder:form-state-changed` so any
              listeners (peek CTA, summary sheet) re-render in the same
              frame.
           4. Defer the navigation by one paint frame (rAF) so the busy
              overlay actually reaches the screen before the page
              starts unloading — on fast networks /checkout can begin
              painting before the current document flushes its busy
              state. One rAF is enough; longer waits add perceptible
              lag.
           5. Watchdog: if navigation never commits (offline / blocked
              / 8s timeout), clear `isCheckingOut` so the user isn't
              stuck staring at the spinner. Cancelled on `pagehide`
              (real navigation). */
        hubbuilderTriggerHaptic('confirm');
        this.isCheckingOut = true;
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        /* 200ms hold so the user sees real spinner motion — see the
           matching comment in wheelBuilder.js → goToCheckout. */
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 200);
        if (this._checkoutWatchdogId) {
          clearTimeout(this._checkoutWatchdogId);
        }
        this._checkoutWatchdogId = setTimeout(() => {
          this._checkoutWatchdogId = null;
          if (this.isCheckingOut) {
            this.isCheckingOut = false;
            document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
          }
        }, 8000);
        if (!this._checkoutPageHideHandler) {
          this._checkoutPageHideHandler = () => {
            if (this._checkoutWatchdogId) {
              clearTimeout(this._checkoutWatchdogId);
              this._checkoutWatchdogId = null;
            }
          };
          window.addEventListener('pagehide', this._checkoutPageHideHandler, { once: true });
        }
      },

      get isBuildResolving() {
        if (!this.isEveryOptionSelected()) return false;
        /* Match wheelBuilderForm: do not short-circuit on `error` — that hid the busy row while labels
         * stayed off, producing an empty salmon CTA on mobile. Error copy uses dedicated spans. */
        const busy =
          !!this.isFetchingProducts ||
          !!this.hubColorsLoading ||
          !!this.fetchingHubInventory ||
          !!(this.pricing && this.pricing.loading);
        if (this.error || this.unavailable) return busy;
        return busy || !this.isReadyForSummary();
      },

      /** Build/price pipeline + add-to-cart POST (spinner). Success check uses `.loading` after the request. */
      get cartBtnBusyOverlayVisible() {
        if (this.addToCartSubmitting) return true;
        if (this.isFetchingProducts) return true;
        if (this.isBuildResolving) return true;
        /* While we're kicking off the /checkout navigation we share the
           same busy-overlay slot (spinner + "Going to checkout…" text)
           so the button feels uniformly responsive across every state
           transition — parity with wheelBuilder.js. */
        if (this.isCheckingOut) return true;
        return false;
      },

      watchOptions() {
        let oldState = this.completeOptions.map((o) => ({ id: o.id, value: o.value, expanded: o.expanded }));
        this.$watch('completeOptions', (newVal) => {
          if (this._suppressHandleValueSet) {
            oldState = newVal.map((o) => ({ id: o.id, value: o.value, expanded: o.expanded }));
            return;
          }
          const changed = newVal.filter((o, idx) => (o.value ?? '') !== (oldState[idx]?.value ?? ''));
          if (changed.length > 0) {
            changed.forEach((o) => this.handleValueSet(o));
          }
          oldState = newVal.map((o) => ({ id: o.id, value: o.value, expanded: o.expanded }));
        });
      },

      handleValueSet(opt) {
        if ((opt.value ?? '') === '') return;

        /* NOTE: no haptic fires here — mirrors wheelBuilder.handleValueSet.
           Previously fired `confirm` on the false → true transition of
           `isEveryOptionSelected()` to mark the "going to summary page"
           moment, but in practice the last option is usually a color swatch
           and users felt a doubled vibration (light field-tap + confirm)
           that read as different from every other (non-last) field tap.
           `confirm` haptic stays reserved for the cart button (add to cart /
           checkout) so every field selection feels identical. */
        document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));

        const idx = this.completeOptions.indexOf(opt);
        const nextIdx = idx + 1;
        const nextOpt = this.completeOptions[nextIdx];
        const hasAhead = this.completeOptions.slice(nextIdx).some((o) => (o.value ?? '') !== '');

        if (nextOpt) {
          if (hasAhead) {
            opt.expanded = false;
            for (let i = nextIdx; i < this.completeOptions.length; i++) {
              const sub = this.completeOptions[i];
              sub.value = '';
              sub.expanded = i === nextIdx;
            }
          } else {
            this.activateOptionGroup(nextOpt.id, { scroll: false });
          }

          if ((opt.value ?? '') !== '') {
            /* Autoscroll after accordion expand settles (~350ms). Shorter
               delays measured stale layout and broke scroll position. */
            const desktop =
              typeof window !== 'undefined' && window.innerWidth > 768;
            this.$nextTick(() => {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    const panel = this.$root.querySelector(
                      `[data-option-group="${nextOpt.id}"]`,
                    );
                    if (panel) {
                      this.scrollToPanel(
                        panel,
                        desktop ? 'smooth' : 'auto',
                        30,
                        { nextGroupEnter: desktop, allowScrollUp: false },
                      );
                    } else {
                      let retries = 0;
                      const retryScroll = () => {
                        retries++;
                        const retryPanel = this.$root.querySelector(
                          `[data-option-group="${nextOpt.id}"]`,
                        );
                        if (retryPanel) {
                          this.scrollToPanel(
                            retryPanel,
                            desktop ? 'smooth' : 'auto',
                            30,
                            { nextGroupEnter: desktop, allowScrollUp: false },
                          );
                        } else if (retries < 3) {
                          setTimeout(retryScroll, 100);
                        }
                      };
                      setTimeout(retryScroll, 100);
                    }
                  });
                });
              }, 350);
            });
          }
        } else if (
          (opt.value ?? '') !== '' &&
          typeof window !== 'undefined' &&
          window.innerWidth <= 768
        ) {
          this.completeOptions.forEach((o) => {
            o.expanded = false;
          });
        }

        if (typeof window === 'undefined' || !window.__STEM_BUILDER__) {
          const structural = [
            'hub_model',
            'flange_type',
            'brake_type',
            'front_spacing',
            'rear_spacing',
            'front_hole_count',
            'rear_hole_count',
            'driver_style',
            'driver_type',
          ];
          if (structural.includes(opt.id)) {
            if (this.tab !== 'driver') {
              this.updateHubColorAvailability();
            }
            this.applyRuleAvailabilityConstraints();
          }

          if (opt.id === 'hub_colour' || opt.id === 'hub_color') {
            this.updatePricingForSelectedColor();
          }

          if (this.tab === 'driver' && opt.id === 'hub_model') {
            this.updateDriverAvailability();
          }

          if (this.tab === 'driver' && (opt.id === 'driver_style' || opt.id === 'driver_type' || opt.id === 'driver')) {
            this.updatePricingForSelectedColor();
          }
        } else if (this.isEveryOptionSelected()) {
          stemDebugLog('handleValueSet (stem): all options selected → updatePricingForSelectedColor');
          this.updatePricingForSelectedColor();
        } else if (stemBuilderDeepDebugEnabled()) {
          stemDebugLog('handleValueSet (stem): option change', {
            id: opt?.id,
            value: opt?.value,
            selectedSnapshot: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
          });
        }
      },

      scrollToPanel(el, behavior = 'smooth', _topOffset = 30, scrollOptions = {}) {
        if (!el) return;
        const { nextGroupEnter = false } = scrollOptions;
        requestAnimationFrame(() => {
          try {
            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
              // Apply drawer max-height before clientHeight/scrollHeight math (ResizeObserver can
              // otherwise run after this and invalidate the scroll position).
              const tb = this._getTabsData();
              if (tb && typeof tb.syncMobileDrawerContentScrollLayout === 'function') {
                tb.syncMobileDrawerContentScrollLayout();
              }
              let scrollContainer = el.closest('.drawer-content');
              if (!scrollContainer) {
                const tabsData = this._getTabsData();
                const section = tabsData?.getActivePanelSection?.();
                if (section) {
                  scrollContainer = section.querySelector('.drawer-content');
                }
              }
              if (!scrollContainer) {
                const tabsData = this._getTabsData();
                const section = tabsData?.getPanelSectionForSelectedTab?.();
                if (section) {
                  scrollContainer = section.querySelector('.drawer-content');
                }
              }
              if (!scrollContainer) {
                const tabsEl =
                  this.$el?.closest?.('[x-data^="hubBuilderTabs"]') ||
                  this.$el?.closest?.('[x-data*="hubBuilderTabs"]');
                const tabpanelsContainer =
                  tabsEl && typeof tabsEl.querySelector === 'function'
                    ? tabsEl.querySelector('[role="tabpanels"]')
                    : null;
                if (tabpanelsContainer) {
                  const visiblePanel = Array.from(
                    tabpanelsContainer.querySelectorAll(':scope > section'),
                  ).find((panel) => window.getComputedStyle(panel).display !== 'none');
                  if (visiblePanel) {
                    scrollContainer = visiblePanel.querySelector('.drawer-content');
                  }
                }
              }
              if (scrollContainer) {
                const scrollPort = hubbuilderResolveOptionsScrollContainer(scrollContainer);
                hubbuilderMobileDrawerScrollGroupToViewportCenter(
                  el,
                  scrollPort || scrollContainer,
                  behavior,
                  _topOffset,
                );
              } else {
                el.scrollIntoView({ behavior, block: 'center', inline: 'nearest' });
              }
            } else {
              el.scrollIntoView({
                behavior,
                block: 'center',
                inline: 'nearest',
              });
              if (behavior === 'auto' && nextGroupEnter) {
                requestAnimationFrame(() => {
                  el.classList.remove('wb-next-group-enter');
                  void el.offsetWidth;
                  el.classList.add('wb-next-group-enter');
                  setTimeout(() => el.classList.remove('wb-next-group-enter'), 320);
                });
              }
            }
          } catch (_) {}
        });
      },

      activateOptionGroup(optionId, { scroll = true } = {}) {
        if (!optionId) return;
        if (this.isInputGroupDisabled(optionId)) return;
        this.completeOptions.forEach((entry) => {
          entry.expanded = entry.id === optionId;
        });
        if (!scroll) return;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const panel = this.$root.querySelector(`[data-option-group="${optionId}"]`);
            if (panel) {
              const desktop =
                typeof window !== 'undefined' && window.innerWidth > 768;
              this.scrollToPanel(
                panel,
                desktop ? 'smooth' : 'auto',
                30,
                { nextGroupEnter: false },
              );
            }
          });
        });
      },

      editBuildFromSummaryRow(optionId) {
        if (!optionId) return;
        if (!this.isEveryOptionSelected()) return;
        if (this.isInputGroupDisabled(optionId)) return;

        const tabs = this._getTabsData();
        if (
          typeof window !== 'undefined' &&
          window.innerWidth <= 768 &&
          tabs &&
          hubbuilderMobileWizardActive(tabs) &&
          typeof tabs.closeMobileSummarySheet === 'function'
        ) {
          tabs.closeMobileSummarySheet();
        }

        const idx = this.completeOptions.findIndex((o) => o && o.id === optionId);
        if (idx < 0) return;

        if (typeof window !== 'undefined' && typeof window.triggerHaptic === 'function') {
          window.triggerHaptic();
        }

        this._suppressHandleValueSet = true;
        for (let i = idx; i < this.completeOptions.length; i++) {
          const opt = this.completeOptions[i];
          opt.value = '';
          const group = this.$root?.querySelector?.(`[data-option-group="${opt.id}"]`);
          if (group) {
            group.querySelectorAll('input[type="radio"]').forEach((input) => {
              input.checked = false;
            });
          }
          opt.expanded = i === idx;
        }

        document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));

        this.$nextTick(() => {
          this._suppressHandleValueSet = false;
          this.syncMobileSummarySheetRows();
          if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
            if (typeof this.updatePricingForSelectedColor === 'function') {
              this.updatePricingForSelectedColor();
            }
          } else {
            this.applyRuleAvailabilityConstraints();
            if (this.tab !== 'driver') {
              this.updateHubColorAvailability();
            }
            this.updatePricingForSelectedColor();
          }
          requestAnimationFrame(() => {
            const panel = this.$root?.querySelector?.(`[data-option-group="${optionId}"]`);
            if (panel) {
              this.openDrawer?.();
              const desktop =
                typeof window !== 'undefined' && window.innerWidth > 768;
              this.scrollToPanel(
                panel,
                desktop ? 'smooth' : 'auto',
                30,
                { nextGroupEnter: false },
              );
            }
          });
        });
      },

      updateCartCount() {
        try {
          if (window.Shopify && typeof window.Shopify.updateCartInfo === 'function') {
            window.Shopify.updateCartInfo();
            return;
          }
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(`${root}cart.js`)
            .then((response) => response.json())
            .then((cart) => {
              document.querySelectorAll('[data-cart-count-number]').forEach((el) => {
                el.textContent = cart.item_count < 100 ? cart.item_count : '99+';
              });
              document.querySelectorAll('[data-cart-count-bubble], .cart-link__count').forEach((el) => {
                if (cart.item_count > 0) el.classList.remove('is-cart-empty');
                else el.classList.add('is-cart-empty');
              });
              document.querySelectorAll('.cart-count-bubble, .cart-count').forEach((element) => {
                if (element.tagName === 'SPAN') {
                  element.textContent = cart.item_count;
                } else {
                  const countSpan = element.querySelector('span');
                  if (countSpan) countSpan.textContent = cart.item_count;
                }
                element.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
              });
              if (window.FoxThemeCartHelpers && typeof window.FoxThemeCartHelpers.updateCartCount === 'function') {
                window.FoxThemeCartHelpers.updateCartCount(cart.item_count);
              }
            })
            .catch((err) => console.warn('[HubBuilder] Could not update cart count:', err));
        } catch (err) {
          console.warn('[HubBuilder] updateCartCount:', err);
        }
      },

      async refreshCartDrawerSilently(addToCartResult) {
        try {
          this.updateCartCount();
          if (addToCartResult.sections && addToCartResult.sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(addToCartResult.sections['cart-drawer'], 'text/html');
            const newItems = doc.querySelector('.f-cart-drawer__items');
            const currentItems = document.querySelector('.f-cart-drawer__items');
            if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
            const newFooter = doc.querySelector('.f-drawer__footer');
            const currentFooter = document.querySelector('.f-drawer__footer');
            if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.classList.remove('is-empty');
          } else {
            const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            const response = await fetch(`${root}?section_id=cart-drawer`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newItems = doc.querySelector('.f-cart-drawer__items');
            const currentItems = document.querySelector('.f-cart-drawer__items');
            if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
            const newFooter = doc.querySelector('.f-drawer__footer');
            const currentFooter = document.querySelector('.f-drawer__footer');
            if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.classList.remove('is-empty');
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: addToCartResult } }));
        } catch (err) {
          console.warn('[HubBuilder] Could not refresh cart drawer:', err);
        }
      },

      /** Split pay-row: tap on the price column runs the same cart CTA handler. */
      runPayRowCartClick(event) {
        const row = event?.currentTarget;
        if (!row?.classList?.contains('has-price')) return;
        if (event.target.closest('.wheelbuilder-cart-btn')) return;
        const btn = row.querySelector('.wheelbuilder-cart-btn');
        if (!btn || btn.disabled) return;
        btn.click();
      },

      buildMobileCartAddedLines() {
        const subtitle = this.completeOptions
          .filter((o) => o?.value)
          .map((o) => o.value)
          .join(', ');
        const products = Array.isArray(this._mobileCartAddedProducts)
          ? this._mobileCartAddedProducts
          : [];

        if (products.length > 0) {
          return products.map((entry) => {
            const variantTitle =
              entry.variant?.title && entry.variant.title !== 'Default Title'
                ? entry.variant.title
                : '';
            const label = entry.sideLabel ? `${entry.sideLabel}: ` : '';
            const detail = [variantTitle, subtitle].filter(Boolean).join(' · ');
            return {
              title: (label ? label : '') + (entry.product?.title || 'Your build'),
              image: hubbuilderProductImageUrl(entry.product),
              subtitle: detail,
            };
          });
        }

        const fallbackTitle =
          this.$root?.querySelector?.('.mobile-options-intro__title')?.textContent?.trim() ||
          'Your build';
        return [{ title: fallbackTitle, image: '', subtitle }];
      },

      wbMobileCartAddedOpen() {
        // Same teleport issue as wheelBuilder.js — don't try to read the form
        // element's data-wb-panel-tab from inside the teleported node.
        if (!this.mobileCartAddedOpen || !hubbuilderMobileCartAddedEnabled()) return false;
        return true;
      },

      _setupMobileCartAddedA11y() {
        if (!hubbuilderMobileCartAddedEnabled()) return;
        document.body.classList.add('wheelbuilder-mobile-cart-added-open');
        document.documentElement.classList.add('wheelbuilder-mobile-cart-added-open');
        if (this._mobileCartAddedEscapeHandler) {
          document.removeEventListener('keydown', this._mobileCartAddedEscapeHandler, true);
        }
        this._mobileCartAddedEscapeHandler = (e) => {
          if (e.key !== 'Escape') return;
          if (!this.wbMobileCartAddedOpen()) return;
          e.preventDefault();
          e.stopPropagation();
          this.closeMobileCartAddedSheet();
        };
        document.addEventListener('keydown', this._mobileCartAddedEscapeHandler, true);
      },

      _teardownMobileCartAddedA11y() {
        document.body.classList.remove('wheelbuilder-mobile-cart-added-open');
        document.documentElement.classList.remove('wheelbuilder-mobile-cart-added-open');
        if (this._mobileCartAddedEscapeHandler) {
          document.removeEventListener('keydown', this._mobileCartAddedEscapeHandler, true);
          this._mobileCartAddedEscapeHandler = null;
        }
      },

      showMobileCartAddedSheet() {
        if (!hubbuilderMobileCartAddedEnabled()) return;
        // Do NOT closeMobileSummarySheet — that resets mobileForceOptions which
        // flips the view back to configure-options beneath an invisible sheet.
        this.mobileCartAddedLines = this.buildMobileCartAddedLines();
        this.mobileCartAddedOpen = true;
        this._setupMobileCartAddedA11y();
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
      },

      closeMobileCartAddedSheet() {
        if (!this.mobileCartAddedOpen) return;
        this.mobileCartAddedOpen = false;
        this._teardownMobileCartAddedA11y();
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
      },

      openCartDrawerFromBuilder() {
        // Prefer the theme's own CartDrawer reference (set by cart-drawer.js).
        if (window.FoxTheme?.CartDrawer && typeof window.FoxTheme.CartDrawer.openDrawer === 'function') {
          window.FoxTheme.CartDrawer.openDrawer();
          return;
        }
        const drawer =
          document.getElementById('Drawer-Cart') ||
          document.querySelector('drawer-component');
        if (drawer && typeof drawer.openDrawer === 'function') {
          drawer.openDrawer();
          return;
        }
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = `${root}cart`;
      },

      checkoutFromMobileCartAdded() {
        this.closeMobileCartAddedSheet();
        this.goToCheckout();
      },

      async addToCart() {
        if (!this.isEveryOptionSelected()) {
          this.error = 'Please select all options before adding to cart';
          return;
        }
        if (this.loading || this.addToCartSubmitting) return;

        /* Haptic at tap-start — see wheelBuilder.js `addToCart` for the
           full rationale. iOS WebKit cannot deliver a haptic after any
           `await`; firing here is the only reliable path. The success
           haptic later in this function still fires but on iOS it's
           best-effort (Android still gets both pulses). */
        hubbuilderTriggerHaptic('confirm');

        const items = [];
        this._mobileCartAddedProducts = [];
        const properties = Object.fromEntries(this.completeOptions.map((o) => [this.formatLabel(o.id), o.value]));

        const pushHandle = async (handle, sideLabel) => {
          const product = await fetchProductJsonByHandle(handle);
          const variant = Array.isArray(product?.variants)
            ? (product.variants.find((v) => v?.available) || product.variants[0])
            : null;
          if (!variant) return false;
          const sideProps = { ...properties };
          if (sideLabel) sideProps.Side = sideLabel;
          items.push({ id: variant.id, quantity: 1, properties: sideProps });
          this._mobileCartAddedProducts.push({ product, variant, sideLabel });
          return true;
        };

        try {
          if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
            // Look up the matched stem config / stem_rule row to get the specific purchasable
            // variant/product for these selections, rather than the parent PDP variant.
            // Parent fallback ONLY when no rules index and no stem_rules exist for this model —
            // never when an index/rule matched but the product could not be fetched.
            let cartVariantId = null;
            let matchedHandle = null;
            let stemDisplayProduct = null;
            let stemDisplayVariant = null;
            const rulesIndex = window.__STEM_RULES_INDEX__;

            if (rulesIndex?.configs?.length) {
              const pickedIdx = pickStemConfigFromRulesIndex(rulesIndex, this.completeOptions);
              if (!pickedIdx) {
                console.error('[StemBuilder] addToCart: no stem index config matched', {
                  selections: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
                });
                this.error = 'This stem configuration is not available. Please change your selections.';
                return;
              }
              const src = stemPricingSourceFromIndexMatch(pickedIdx.handles, pickedIdx.config);
              console.log('[StemBuilder] addToCart: matched index config', {
                index: pickedIdx.index,
                productHandle: src.productHandle,
                variantId: src.variantId,
              });
              if (src.variantId) {
                cartVariantId = src.variantId;
              } else if (src.productHandle) {
                matchedHandle = src.productHandle;
                try {
                  const product = await fetchProductJsonByHandle(src.productHandle);
                  const variant = Array.isArray(product?.variants)
                    ? (product.variants.find((v) => v?.available) || product.variants[0])
                    : null;
                  if (variant) {
                    cartVariantId = variant.id;
                    stemDisplayProduct = product;
                    stemDisplayVariant = variant;
                  }
                } catch (fetchErr) {
                  console.error('[StemBuilder] addToCart: failed to fetch matched stem product', {
                    productHandle: src.productHandle,
                    error: fetchErr && fetchErr.message,
                  });
                }
              }

              if (!cartVariantId) {
                this.error = matchedHandle
                  ? 'Selected stem configuration is not available for purchase. Please contact us if this should be available.'
                  : 'This stem configuration is not available. Please change your selections.';
                return;
              }
            } else {
              const modelHandle = window.__HUB_BUILDER_MODEL__;
              let rules = [];
              try {
                rules = await ensureStemRules(modelHandle);
              } catch (rulesErr) {
                console.error('[StemBuilder] addToCart: failed to fetch stem_rules', rulesErr);
              }

              if (Array.isArray(rules) && rules.length > 0) {
                const picked = pickStemRuleRowForPricing(rules, this.completeOptions);
                if (!picked) {
                  console.error('[StemBuilder] addToCart: no stem_rule matched current selections', {
                    selections: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
                  });
                  this.error = 'This stem configuration is not available. Please change your selections.';
                  return;
                }
                const f = Object.fromEntries(picked.fields.map((x) => [x.key, x.value]));
                const src = stemRulePricingSourceFromFields(f);
                console.log('[StemBuilder] addToCart: matched rule', {
                  ruleHandle: picked.handle,
                  productHandle: src.productHandle,
                  variantId: src.variantId,
                });
                if (src.variantId) {
                  cartVariantId = src.variantId;
                } else if (src.productHandle) {
                  matchedHandle = src.productHandle;
                  try {
                    const product = await fetchProductJsonByHandle(src.productHandle);
                    const variant = Array.isArray(product?.variants)
                      ? (product.variants.find((v) => v?.available) || product.variants[0])
                      : null;
                    if (variant) {
                      cartVariantId = variant.id;
                      stemDisplayProduct = product;
                      stemDisplayVariant = variant;
                    }
                  } catch (fetchErr) {
                    console.error('[StemBuilder] addToCart: failed to fetch matched stem product', {
                      productHandle: src.productHandle,
                      error: fetchErr && fetchErr.message,
                    });
                  }
                }

                if (!cartVariantId) {
                  this.error = matchedHandle
                    ? 'Selected stem configuration is not available for purchase. Please contact us if this should be available.'
                    : 'This stem configuration is not available. Please change your selections.';
                  return;
                }
              } else {
                // No stem_rules configured for this model — legitimate fallback to parent.
                console.warn('[StemBuilder] addToCart: no stem_rules for model, using parent variant', { modelHandle });
                cartVariantId = window.__STEM_BUILDER_VARIANT_ID__;
              }
            }

            if (!cartVariantId) {
              this.error = 'Product variant is not configured for the stem builder.';
              return;
            }
            if (!stemDisplayProduct && window.__STEM_BUILDER_PRODUCT_HANDLE__) {
              try {
                stemDisplayProduct = await fetchProductJsonByHandle(window.__STEM_BUILDER_PRODUCT_HANDLE__);
                stemDisplayVariant = Array.isArray(stemDisplayProduct?.variants)
                  ? stemDisplayProduct.variants.find((v) => String(v.id) === String(cartVariantId)) ||
                    stemDisplayProduct.variants[0]
                  : null;
              } catch (_) {}
            }
            if (stemDisplayProduct) {
              this._mobileCartAddedProducts.push({
                product: stemDisplayProduct,
                variant: stemDisplayVariant,
                sideLabel: null,
              });
            }
            console.log('[StemBuilder] addToCart: pushing item', { variantId: cartVariantId, properties });
            items.push({ id: cartVariantId, quantity: 1, properties });
          } else if (this.tab === 'driver') {
            const selectedDriver = (this.getOptionById('driver_style').value || this.getOptionById('driver_type').value || this.getOptionById('driver').value);
            const driverKey = normalizeDriverName(selectedDriver);
            const handle = this.driverHandleMap[driverKey];
            if (!handle) {
              this.error = 'Selected driver is unavailable.';
              return;
            }
            const ok = await pushHandle(handle, 'Driver');
            if (!ok) {
              this.error = 'No purchasable driver variant found.';
              return;
            }
          } else if (this.tab === 'complete' || this.tab === 'front' || this.tab === 'rear') {
            const selectedColor = (this.getOptionById('hub_colour').value || this.getOptionById('hub_color').value);
            const mapping = this.colorToHandleMap[selectedColor];
            if (!mapping) {
          this.error = 'Unable to add to cart. Please select available options.';
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress', { bubbles: true }));
          return;
            }

            if (this.tab === 'complete') {
              const okFront = mapping.front ? await pushHandle(mapping.front, 'Front') : false;
              const okRear = mapping.rear ? await pushHandle(mapping.rear, 'Rear') : false;
              if (!okFront || !okRear) {
                this.error = 'Selected color is not available for both front and rear.';
                return;
              }
            } else if (this.tab === 'front') {
              const okFront = mapping.front ? await pushHandle(mapping.front, 'Front') : false;
              if (!okFront) {
                this.error = 'Selected color is not available for the front hub.';
                return;
              }
            } else if (this.tab === 'rear') {
              const okRear = mapping.rear ? await pushHandle(mapping.rear, 'Rear') : false;
              if (!okRear) {
                this.error = 'Selected color is not available for the rear hub.';
                return;
              }
            }
          }

          if (!items.length) {
          this.error = 'Nothing to add to cart.';
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress', { bubbles: true }));
          return;
          }

          /* No haptic on click — the confirm haptic fires once `addedToCart`
             flips true below (when the success checkmark appears). The tap is
             the user's *ask*; the checkmark is the system's *answer* — putting
             the vibration on the answer makes it feel like a real confirmation. */
          this.error = null;
          this.addToCartSubmitting = true;
          this.loading = false;
          /* Tabs-scope CTAs (peek + footer) live outside this form x-data.
             Broadcast immediately so spinner / "Adding…" remount — same
             contract as wheelBuilderForm.notifyFormStateChanged(). */
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items,
              sections: ['cart-drawer'],
              sections_url: window.location.pathname,
            }),
          });
          const result = await response.json();
          if (!response.ok) {
            throw new Error(result.description || result.message || 'Failed to add to cart');
          }

          /* Perceived speed: don't block success UI on drawer HTML refresh. */
          void this.refreshCartDrawerSilently(result).catch(() => {});

          try {
            const tabs = this._getTabsData && this._getTabsData();
            if (tabs) {
              const addedQty = items.reduce((n, it) => n + (Number(it.quantity) || 1), 0);
              tabs.cartItemCount = Math.max(0, Number(tabs.cartItemCount) || 0) + addedQty;
            }
          } catch (_) {}

          /* Start celebration immediately on success — before any other paint work. */
          hubbuilderTriggerHaptic('confirm');
          this.addToCartSubmitting = false;
          this.error = null;
          this.mobileCartAddedLines = this.buildMobileCartAddedLines();
          this.loading = true;
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));

          await new Promise((resolve) => setTimeout(resolve, HUBBUILDER_ADDTOCART_CHECK_MS));

          this.loading = false;
          this.addedToCart = true;
          document.dispatchEvent(new CustomEvent('cart:items-added', { detail: { count: items.length } }));
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        } catch (e) {
          this.error = e && e.message ? e.message : 'Failed to add to cart';
          console.error(e);
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress', { bubbles: true }));
        } finally {
          this.addToCartSubmitting = false;
          this.loading = false;
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress', { bubbles: true }));
        }
      },

      async updateHubColorAvailability() {
        if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
          this.hubColorsLoading = false;
          this.fetchingHubInventory = false;
          this.hasCompletedInventoryCheck = true;
          document.documentElement.classList.remove('hubbuilder-loading');
          return;
        }
        if (this.tab === 'driver') return;
        try {
          this.hubColorsLoading = true;
          this.fetchingHubInventory = true;
          document.documentElement.classList.add('hubbuilder-loading');
          const selected = Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value]));
          const modelHandle = window.__HUB_BUILDER_MODEL__;
          const buildType = this.tab === 'front' ? 'front' : this.tab === 'rear' ? 'rear' : 'complete';

          const hubColorOptions =
            window.__HUB_BUILDER_OPTIONS__?.hub_colour || window.__HUB_BUILDER_OPTIONS__?.hub_color;
          let allColors = [];
          if (Array.isArray(hubColorOptions)) {
            allColors = hubColorOptions.filter(Boolean);
          } else if (typeof hubColorOptions === 'string') {
            let parsed = null;
            try {
              parsed = JSON.parse(hubColorOptions);
            } catch (_) {}
            if (Array.isArray(parsed)) {
              allColors = parsed.filter(Boolean);
            } else if (hubColorOptions.includes(',')) {
              allColors = hubColorOptions.split(',').map((s) => s.trim()).filter(Boolean);
            } else if (hubColorOptions.trim().length) {
              allColors = [hubColorOptions.trim()];
            }
          }
          if (!allColors.length) {
            allColors = Object.keys(colorHandleMap);
          }

          const queryParams = {
            hubModel: (selected.hub_model || modelHandle || '').toLowerCase().trim(),
            flangeType: (selected.flange_type || '').toLowerCase().trim(),
            brakeType: (selected.brake_type || '').toLowerCase().trim(),
            frontSpacing: (selected.front_spacing || '').toLowerCase().trim(),
            rearSpacing: (selected.rear_spacing || '').toLowerCase().trim(),
            driverStyle: normalizeDriverName(selected.driver_style || selected.driver_type || ''),
            frontHoleCount: (selected.front_hole_count || '').toLowerCase().trim(),
            rearHoleCount: (selected.rear_hole_count || '').toLowerCase().trim(),
          };

          const rules = getHubRulesIndex()
            ? null
            : await ensureHubRules(modelHandle);
          const rulesIndex = getHubRulesIndex();
          if (rulesIndex) {
            const selections = Object.fromEntries(
              this.completeOptions.map((o) => [o.id, o.value]).filter(([, v]) => v),
            );
            this.colorToHandleMap = buildColorToHandleMapFromHubRulesIndex(
              rulesIndex,
              selections,
              buildType,
            );
          } else {
            this.colorToHandleMap = buildColorToHandleMapFromHubRules(rules, queryParams, buildType, allColors);
          }
          this.availableHubColors = [...allColors];

          this.hasCompletedInventoryCheck = true;
          await new Promise((r) => this.$nextTick(r));
          this.hubColorsLoading = false;
          this.fetchingHubInventory = false;
          document.documentElement.classList.remove('hubbuilder-loading');
          this.setMessageVisibility(true);
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
          const selectedColor =
            this.getOptionById('hub_colour').value || this.getOptionById('hub_color').value;
          if (String(selectedColor || '').trim()) {
            this.updatePricingForSelectedColor();
          }
        } catch (e) {
          console.error('[HubBuilder] updateHubColorAvailability error', e);
          this.availableHubColors = [];
          this.colorToHandleMap = {};
          this.hasCompletedInventoryCheck = false;
          this.setMessageVisibility(false);
          this.hubColorsLoading = false;
          this.fetchingHubInventory = false;
          document.documentElement.classList.remove('hubbuilder-loading');
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        }
      },

      /** Driver tab: map driver choice → Shopify product handle from `driver_rule` metaobjects. Falls back to `hub_rule` if no driver rules exist. */
      async updateDriverAvailability() {
        if (this.tab !== 'driver') return;
        try {
          this.driverHandleMap = {};
          const modelHandle = window.__HUB_BUILDER_MODEL__;

          const driverRules = await ensureDriverRules(modelHandle);
          if (driverRules && driverRules.length > 0) {
            this.driverHandleMap = buildDriverHandleMapFromDriverRules(driverRules);
          } else {
            const selected = Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value]));
            const queryParams = {
              hubModel: (selected.hub_model || modelHandle || '').toLowerCase().trim(),
              flangeType: (selected.flange_type || '').toLowerCase().trim(),
              brakeType: (selected.brake_type || '').toLowerCase().trim(),
              frontSpacing: (selected.front_spacing || '').toLowerCase().trim(),
              rearSpacing: (selected.rear_spacing || '').toLowerCase().trim(),
              driverStyle: '',
              frontHoleCount: (selected.front_hole_count || '').toLowerCase().trim(),
              rearHoleCount: (selected.rear_hole_count || '').toLowerCase().trim(),
            };
            const rules = await ensureHubRules(modelHandle);
            this.driverHandleMap = buildDriverHandleMapFromHubRules(rules, queryParams);
          }

          const selectedDriver = (this.getOptionById('driver_style').value || this.getOptionById('driver_type').value || this.getOptionById('driver').value);
          if (selectedDriver) {
            this.updatePricingForSelectedColor();
          }
          document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress'));
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        } catch (e) {
          console.error('[HubBuilder] updateDriverAvailability error', e);
          this.driverHandleMap = {};
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        }
      },

      async updatePricingForSelectedColor() {
        // If the user is mid-edit (not all options filled), clear any stale
        // price/error and bail — no lookup is possible yet.
        if (!this.isEveryOptionSelected()) {
          this.error = null;
          this.pricing = { loading: false, price: null, compareAtPrice: null, savings: null };
          return;
        }

        // Debounce: if a new call arrives while one is in-flight, the
        // in-flight run will see its generation has been superseded and bail
        // out before committing stale prices to the UI.
        const gen = (this._pricingGen = (this._pricingGen || 0) + 1);
        const myGen = gen;

        /* Sync busy before any await — avoid one-frame stale ATC/price on mobile. */
        this.error = null;
        this.pricing = {
          loading: true,
          price: null,
          priceAmount: null,
          currencyLabel: null,
          compareAtPrice: null,
          compareAtPriceAmount: null,
          savings: null,
        };
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));

        const rawErr =
          (this.wbCopy && this.wbCopy.mobileFooterPricing) ||
          (this.wbCopy && this.wbCopy.mobileFooterUnable) ||
          "Couldn't load price. Try again.";
        const pricingErr = hubSanitizeThemeCopy(rawErr);

        const failPricing = () => {
          if (this._pricingGen !== myGen) return;
          this.error = pricingErr;
          this.pricing = {
            loading: false,
            price: null,
            compareAtPrice: null,
            savings: null,
          };
          this.$nextTick(() => {
            document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
            document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress', { bubbles: true }));
          });
        };

        const commitPricing = (patch) => {
          if (this._pricingGen !== myGen) return;
          const nz = (v) => (v != null && String(v).trim() !== '' ? v : null);
          this.pricing = {
            loading: false,
            currencyLabel: nz(patch.currencyLabel),
            priceAmount: nz(patch.priceAmount),
            price: nz(patch.price),
            compareAtPriceAmount: nz(patch.compareAtPriceAmount),
            compareAtPrice: nz(patch.compareAtPrice),
            savings: nz(patch.savings),
          };
          this.$nextTick(() => {
            document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
            document.dispatchEvent(new CustomEvent('wheelbuilder:update-progress', { bubbles: true }));
          });
        };

        try {
          if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
            let pricing = { price: null, compareAtPrice: null };
            let pricingSource = 'stem_rules';
            const rulesIndex = window.__STEM_RULES_INDEX__;

            if (rulesIndex?.configs?.length) {
              const pickedIdx = pickStemConfigFromRulesIndex(rulesIndex, this.completeOptions);
              if (!pickedIdx) {
                stemDebugLog('updatePricingForSelectedColor (stem): no index config matched', {
                  selections: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
                });
                failPricing();
                return;
              }
              const src = stemPricingSourceFromIndexMatch(pickedIdx.handles, pickedIdx.config);
              pricingSource = 'stem_rules_index';
              stemDebugLog('updatePricingForSelectedColor (stem): matched index config', {
                index: pickedIdx.index,
                pricingSourceFields: src,
                selections: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
              });
              try {
                if (src.variantId) {
                  pricing = await fetchVariantPricingById(src.variantId);
                } else if (src.productHandle) {
                  pricing = await hubFetchPricingWithTimeout(src.productHandle);
                }
              } catch (stemPriceErr) {
                console.warn('[StemBuilder] stem index pricing resolution failed', stemPriceErr);
              }
              // Index present: never fall back to parent __STEM_BUILDER_VARIANT_ID__
              if (!pricing.price) {
                stemDebugLog('updatePricingForSelectedColor (stem): no price from index', { pricingSource });
                failPricing();
                return;
              }
            } else {
              // No rules index: use stem_rules rows. Parent fallback ONLY when no rules exist
              // for this model (same contract as addToCart) — never when rules exist but
              // no match / no purchasable price source.
              try {
                const modelHandle = window.__HUB_BUILDER_MODEL__;
                const rules = await ensureStemRules(modelHandle);
                const hasRules = Array.isArray(rules) && rules.length > 0;
                if (hasRules) {
                  const picked = pickStemRuleRowForPricing(rules, this.completeOptions);
                  if (!picked) {
                    stemDebugLog('updatePricingForSelectedColor (stem): no stem_rule matched', {
                      selections: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
                    });
                    failPricing();
                    return;
                  }
                  const f = Object.fromEntries(picked.fields.map((x) => [x.key, x.value]));
                  const src = stemRulePricingSourceFromFields(f);
                  stemDebugLog('updatePricingForSelectedColor (stem): matched rule', {
                    ruleHandle: picked.handle,
                    pricingSourceFields: src,
                    selections: Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value])),
                  });
                  try {
                    if (src.variantId) {
                      pricing = await fetchVariantPricingById(src.variantId);
                    } else if (src.productHandle) {
                      pricing = await hubFetchPricingWithTimeout(src.productHandle);
                    }
                  } catch (stemPriceErr) {
                    console.warn('[StemBuilder] stem rule pricing resolution failed', stemPriceErr);
                  }
                  if (!pricing.price) {
                    stemDebugLog('updatePricingForSelectedColor (stem): no price from stem_rules', {
                      pricingSource,
                    });
                    failPricing();
                    return;
                  }
                } else {
                  const vid = window.__STEM_BUILDER_VARIANT_ID__;
                  if (vid) {
                    pricingSource = 'default_variant';
                    stemDebugLog('updatePricingForSelectedColor (stem): no stem_rules, fallback Liquid variant', {
                      variantId: vid,
                    });
                    pricing = await fetchVariantPricingById(vid);
                  }
                }
              } catch (stemPriceErr) {
                console.warn('[StemBuilder] stem rule pricing resolution failed', stemPriceErr);
                const vid = window.__STEM_BUILDER_VARIANT_ID__;
                if (vid) {
                  pricingSource = 'default_variant_after_error';
                  pricing = await fetchVariantPricingById(vid);
                }
              }

              if (!pricing.price) {
                stemDebugLog('updatePricingForSelectedColor (stem): no price', { pricingSource });
                failPricing();
                return;
              }
            }

            stemDebugLog('updatePricingForSelectedColor (stem): final pricing', {
              pricingSource,
              price: pricing.price,
              compareAtPrice: pricing.compareAtPrice,
            });

            const priceAmt = pricing.price ? parseFloat(pricing.price.amount) : 0;
            const compareAmt = pricing.compareAtPrice ? parseFloat(pricing.compareAtPrice.amount) : 0;
            const isOnSale = compareAmt > 0 && compareAmt > priceAmt;
            commitPricing(
              buildPayRowPricingPatch(
                pricing.price,
                isOnSale ? pricing.compareAtPrice : null,
                isOnSale && pricing.price
                  ? { amount: String(compareAmt - priceAmt), currencyCode: pricing.price.currencyCode }
                  : null
              )
            );
          } else if (this.tab === 'driver') {
            const selectedDriver = (this.getOptionById('driver_style').value || this.getOptionById('driver_type').value || this.getOptionById('driver').value);
            const driverKey = normalizeDriverName(selectedDriver);
            const handle = this.driverHandleMap[driverKey];
            if (!handle) {
              failPricing();
              return;
            }
            const pricing = await hubFetchPricingWithTimeout(handle);
            const priceAmt = pricing.price ? parseFloat(pricing.price.amount) : 0;
            const compareAmt = pricing.compareAtPrice ? parseFloat(pricing.compareAtPrice.amount) : 0;
            const isOnSale = compareAmt > 0 && compareAmt > priceAmt;
            commitPricing(
              buildPayRowPricingPatch(
                pricing.price,
                isOnSale ? pricing.compareAtPrice : null,
                isOnSale && pricing.price
                  ? { amount: String(compareAmt - priceAmt), currencyCode: pricing.price.currencyCode }
                  : null
              )
            );
          } else {
            const color = (this.getOptionById('hub_colour').value || this.getOptionById('hub_color').value);
            const mapping = this.colorToHandleMap[color];
            if (!mapping) {
              failPricing();
              return;
            }
            if (this.tab === 'complete') {
              const handles = [mapping.front, mapping.rear].filter(Boolean);
              const results = await Promise.all(handles.map((h) => hubFetchPricingWithTimeout(h)));
              let sum = 0;
              let sumCompare = 0;
              let currency = null;
              results.forEach((r) => {
                if (r.price) {
                  sum += parseFloat(r.price.amount || 0);
                  currency = r.price.currencyCode || currency;
                }
                if (r.compareAtPrice) {
                  sumCompare += parseFloat(r.compareAtPrice.amount || 0);
                }
              });
              const priceObj = currency ? { amount: String(sum), currencyCode: currency } : null;
              const compareObj = currency && sumCompare > 0 ? { amount: String(sumCompare), currencyCode: currency } : null;
              const isOnSale = sumCompare > 0 && sumCompare > sum;
              commitPricing(
                buildPayRowPricingPatch(
                  priceObj,
                  isOnSale ? compareObj : null,
                  isOnSale && currency
                    ? { amount: String(sumCompare - sum), currencyCode: currency }
                    : null
                )
              );
            } else {
              const handle =
                this.tab === 'rear' ? mapping.rear || mapping.any : mapping.front || mapping.any;
              if (!handle) {
                failPricing();
                return;
              }
              const pricing = await hubFetchPricingWithTimeout(handle);
              const priceAmt = pricing.price ? parseFloat(pricing.price.amount) : 0;
              const compareAmt = pricing.compareAtPrice ? parseFloat(pricing.compareAtPrice.amount) : 0;
              const isOnSale = compareAmt > 0 && compareAmt > priceAmt;
              commitPricing(
                buildPayRowPricingPatch(
                  pricing.price,
                  isOnSale ? pricing.compareAtPrice : null,
                  isOnSale && pricing.price
                    ? { amount: String(compareAmt - priceAmt), currencyCode: pricing.price.currencyCode }
                    : null
                )
              );
            }
          }
          if (this.isEveryOptionSelected() && !this.pricing.price) {
            console.warn('[HubBuilder] pricing unavailable after all options selected');
          }
        } catch (e) {
          console.error('[HubBuilder] updatePricingForSelectedColor', e);
          failPricing();
        } finally {
          this.syncMobileSummarySheetRows();
          document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
        }
      },

      /** Constrain option values from rules index or stem_rule metaobjects. */
      async applyStemRuleAvailabilityConstraints() {
        try {
          const tabsData = this._getTabsData();
          const rulesIndex = tabsData?.hubRulesIndex || window.__STEM_RULES_INDEX__;
          if (
            rulesIndex?.options &&
            (rulesIndex?.configIndicesNorm || rulesIndex?.configIndices)
          ) {
            this._applyHubRuleConstraintsFromIndex(rulesIndex);
            return;
          }

          const modelHandle = window.__HUB_BUILDER_MODEL__;
          const rules = await ensureStemRules(modelHandle);
          const selected = Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value]));
          const optionIds = new Set(this.completeOptions.map((o) => o.id));

          const relevant = (rules || []).filter((r) => {
            const f = Object.fromEntries(r.fields.map((x) => [x.key, x.value]));
            for (const [key, value] of Object.entries(selected)) {
              if (!value || !f[key]) continue;
              if (!hubMetaobjectFieldsMatch(f[key], value)) return false;
            }
            return true;
          });

          stemDebugGroup('applyStemRuleAvailabilityConstraints', () => {
            stemDebugLog('modelHandle', modelHandle);
            stemDebugLog('rules total → relevant', {
              totalRules: (rules || []).length,
              relevantCount: relevant.length,
              relevantSampleHandles: relevant.slice(0, 8).map((r) => r?.handle),
            });
            stemDebugLog('selected', selected);
          });

          this.completeOptions.forEach((option) => {
            if (option.id === 'stem_model') return;
            if (!selected[option.id]) {
              const availableValues = new Set();
              relevant.forEach((rule) => {
                const fields = Object.fromEntries(rule.fields.map((x) => [x.key, x.value]));
                if (optionIds.has(option.id) && fields[option.id]) {
                  availableValues.add(fields[option.id]);
                }
              });
              const unconstrained = availableValues.size === 0;
              const optionContainer = this.$root.querySelector(`[data-option-group="${option.id}"]`);
              if (!optionContainer) {
                stemDebugLog(`[${option.id}] no DOM [data-option-group]`);
                return;
              }
              const valueElements = optionContainer.querySelectorAll('[data-value]');
              let shown = 0;
              let hidden = 0;
              valueElements.forEach((el) => {
                const value = el.getAttribute('data-value');
                const isContainer = !el.tagName || el.tagName !== 'INPUT';
                const allow =
                  unconstrained ||
                  [...availableValues].some((av) => hubMetaobjectFieldsMatch(av, value));
                if (allow) {
                  shown += 1;
                  el.style.display = '';
                  el.classList.remove('disabled', 'unavailable');
                  if (!isContainer) el.removeAttribute('disabled');
                } else {
                  hidden += 1;
                  el.style.display = 'none';
                  el.classList.add('disabled', 'unavailable');
                  if (!isContainer) el.setAttribute('disabled', 'true');
                }
              });
              stemDebugLog(`option "${option.id}"`, {
                unconstrained,
                allowedValuesFromRules: [...availableValues],
                valueElementsCount: valueElements.length,
                shown,
                hidden,
              });
            }
          });
        } catch (e) {
          console.error('[StemBuilder] applyStemRuleAvailabilityConstraints error:', e);
        }
      },

      async applyDriverRuleAvailabilityConstraints() {
        try {
          const modelHandle = window.__HUB_BUILDER_MODEL__;
          let rules = await ensureDriverRules(modelHandle);
          if (!rules || rules.length === 0) {
            rules = await ensureHubRules(modelHandle);
          }

          const selected = Object.fromEntries(this.completeOptions.map((o) => [o.id, o.value]));

          const relevant = (rules || []).filter((r) => {
            const f = Object.fromEntries(r.fields.map((x) => [x.key, x.value]));
            for (const [key, value] of Object.entries(selected)) {
              if (!value || !f[key]) continue;
              if (key === 'driver_style' || key === 'driver_type' || key === 'driver') {
                const driverRuleValue = f.driver_style || f.driver_type || f.driver || f.freehub_driver || f.freehub || f[key];
                if (!normalizeAndCompareDriver(driverRuleValue, value)) return false;
              } else if (key === 'hub_model') {
                if (!hubMetaobjectFieldsMatch(f.hub_model_handle || f.hub_model || f[key], value)) return false;
              } else {
                if (f[key] !== value) return false;
              }
            }
            return true;
          });

          this.completeOptions.forEach((option) => {
            if (option.id === 'hub_model') return;
            if (!selected[option.id]) {
              const availableValues = new Set();
              const isDriverField = option.id === 'driver_style' || option.id === 'driver_type' || option.id === 'driver';

              relevant.forEach((rule) => {
                const fields = Object.fromEntries(rule.fields.map((x) => [x.key, x.value]));
                if (fields[option.id]) {
                  if (isDriverField) {
                    availableValues.add(normalizeDriverName(fields[option.id]));
                  } else {
                    availableValues.add(fields[option.id]);
                  }
                }
              });

              const unconstrained = availableValues.size === 0;
              const optionContainer = this.$root.querySelector(`[data-option-group="${option.id}"]`);

              if (optionContainer) {
                const valueElements = optionContainer.querySelectorAll('[data-value]');
                valueElements.forEach((el) => {
                  const value = el.getAttribute('data-value');
                  const isContainer = !el.tagName || el.tagName !== 'INPUT';
                  const allow = unconstrained || (isDriverField
                    ? availableValues.has(normalizeDriverName(value))
                    : availableValues.has(value));

                  if (allow) {
                    el.style.display = '';
                    el.classList.remove('disabled', 'unavailable');
                    if (!isContainer) el.removeAttribute('disabled');
                  } else {
                    el.style.display = 'none';
                    el.classList.add('disabled', 'unavailable');
                    if (!isContainer) el.setAttribute('disabled', 'true');
                  }
                });
              }
            }
          });
        } catch (e) {
          console.error('[HubBuilder] applyDriverRuleAvailabilityConstraints error:', e);
        }
      },

      // Disable option values based on hub rules (or stem_rule / driver_rule rows)
      async applyRuleAvailabilityConstraints() {
        if (typeof window !== 'undefined' && window.__STEM_BUILDER__) {
          await this.applyStemRuleAvailabilityConstraints();
          return;
        }
        if (this.tab === 'driver') {
          await this.applyDriverRuleAvailabilityConstraints();
          return;
        }
        try {
          const tabsData = this._getTabsData();
          const rulesIndex = tabsData?.hubRulesIndex || window.__HUB_RULES_INDEX__;
          if (
            rulesIndex?.options &&
            (rulesIndex?.configIndicesNorm || rulesIndex?.configIndices)
          ) {
            this._applyHubRuleConstraintsFromIndex(rulesIndex);
            return;
          }

          if (window.__HUB_RULES_FETCHING__ || window.__STEM_RULES_FETCHING__) {
            return;
          }

          const modelHandle = window.__HUB_BUILDER_MODEL__;
          const rules = await ensureHubRules(modelHandle);
          if (getHubRulesIndex()) {
            this._applyHubRuleConstraintsFromIndex(getHubRulesIndex());
            return;
          }
          if (!rules || rules.length === 0) return;
          const selected = Object.fromEntries(this.completeOptions.map((o)=>[o.id,o.value]));
          
          
          const buildType = this.tab === 'front' ? 'front' : (this.tab === 'rear' ? 'rear' : 'complete');
          
          // Filter rules that match current selections so far
          const relevant = (rules||[]).filter((r)=>{
            const f = Object.fromEntries(r.fields.map((x)=>[x.key,x.value]));
            
            // Check if any selected options conflict with this rule
            for (const [key, value] of Object.entries(selected)) {
              if (!value || !f[key]) continue;
              if (key === 'driver_style' || key === 'driver_type' || key === 'driver') {
                const driverRuleValue = f.driver_style || f.driver_type || f.driver || f.freehub_driver || f.freehub || f[key];
                if (!normalizeAndCompareDriver(driverRuleValue, value)) return false;
              } else {
                if (f[key] !== value) return false;
              }
            }
            return true; // This rule is compatible with current selections
          });
          
          
          
          // For each option that's not yet selected, determine available values
          this.completeOptions.forEach(option => {
            // Skip hub model and hub colours here – they are not rule-hidden at this level
            if (option.id === 'hub_model' || option.id === 'hub_colour' || option.id === 'hub_color') {
              return;
            }
            if (!selected[option.id]) {
              const availableValues = new Set();
              const isDriverField = (option.id === 'driver_style' || option.id === 'driver_type' || option.id === 'driver');
              
              relevant.forEach(rule => {
                const fields = Object.fromEntries(rule.fields.map(x => [x.key, x.value]));
                if (fields[option.id]) {
                  if (isDriverField) {
                    availableValues.add(normalizeDriverName(fields[option.id]));
                  } else {
                    availableValues.add(fields[option.id]);
                  }
                }
              });

              // Match wheel builder: empty derived set => do not hide (no positive constraint data).
              const unconstrained = availableValues.size === 0;

              // Apply constraints to the option in the UI
              const optionContainer = this.$root.querySelector(`[data-option-group="${option.id}"]`);
              
              if (optionContainer) {
                // Find all value elements within this option (both inputs and containers)
                const valueElements = optionContainer.querySelectorAll('[data-value]');
                valueElements.forEach(el => {
                  const value = el.getAttribute('data-value');
                  const isContainer = !el.tagName || el.tagName !== 'INPUT';
                  const allow = unconstrained || (isDriverField
                    ? availableValues.has(normalizeDriverName(value))
                    : availableValues.has(value));
                  
                  if (allow) {
                    // Enable this option
                    el.style.display = '';
                    el.classList.remove('disabled', 'unavailable');
                    if (!isContainer) {
                      el.removeAttribute('disabled');
                    }
                  } else {
                    // Disable/hide this option
                    el.style.display = 'none';
                    el.classList.add('disabled', 'unavailable');
                    if (!isContainer) {
                      el.setAttribute('disabled', 'true');
                    }
                  }
                });
              }
            }
          });
        } catch (e) {
          console.error('[HubBuilder] applyRuleAvailabilityConstraints error:', e);
        }
      },

      // UI helpers (no-ops for now, used by snippet conditions)
      setMessageVisibility(hasInventory) {
        this.showHubUnavailableMessage = hasInventory === true && (!this.availableHubColors || this.availableHubColors.length === 0);
        this.showProductUnavailableMessage = this.unavailable === true;
      },
      updateHubColorUI() { /* no-op for hub builder */ },
    };
  });
  }

  // --- Helpers used across components ---
  const STOREFRONT_API_VERSION = '2025-07';
  /** Fallback if Theme settings → Storefront API token is empty (often wrong for the current shop → 401). */
  const STOREFRONT_TOKEN_FALLBACK = '3e04c4f9f0dc8b0641e4ff7cfe7b98fb';

  function getHubStorefrontToken() {
    const t = typeof window !== 'undefined' && window.__STOREFRONT_ACCESS_TOKEN__;
    if (typeof t === 'string' && t.trim()) return t.trim();
    return STOREFRONT_TOKEN_FALLBACK;
  }

  /** Storefront GraphQL must hit the shop host (e.g. *.myshopify.com), not localhost during theme dev / preview. */
  function shopifyPermanentHost() {
    const d = typeof window !== 'undefined' && window.__SHOPIFY_PERMANENT_DOMAIN__;
    if (!d || typeof d !== 'string') return '';
    return d.replace(/^https?:\/\//i, '').split('/')[0].trim();
  }

  function isLocalDevHostname(host) {
    const h = String(host || '').toLowerCase();
    return !h || h === 'localhost' || h === '127.0.0.1' || h.startsWith('127.') || h.endsWith('.localhost');
  }

  /** Undo rare HTML entities in theme strings passed through Liquid/JSON into JS. */
  function hubSanitizeThemeCopy(s) {
    if (s == null || typeof s !== 'string') return s;
    return s
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&');
  }

  function hubSleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  /**
   * Local theme-dev sessions can burst into temporary 429 responses.
   * Retry with exponential backoff so transient throttle does not
   * surface as a permanent builder failure.
   */
  async function hubFetchWith429Retry(url, options, attempts = 6) {
    let lastResponse = null;
    for (let i = 0; i < attempts; i++) {
      const response = await fetch(url, options);
      lastResponse = response;
      if (response.status !== 429) return response;
      if (i < attempts - 1) {
        const retryAfter = Number(response.headers?.get?.('retry-after'));
        const waitMs = Number.isFinite(retryAfter) && retryAfter > 0
          ? Math.max(500, retryAfter * 1000)
          : Math.min(500 * Math.pow(2, i), 8000);
        await hubSleep(waitMs);
      }
    }
    return lastResponse;
  }

  async function storefrontGraphQL(query, variables) {
    const DBG = '[HubBuilder] storefrontGraphQL';
    const host = isLocalDevHostname(window.location.hostname)
      ? shopifyPermanentHost()
      : window.location.hostname;
    const usingPermanentDomain = isLocalDevHostname(window.location.hostname) && !!shopifyPermanentHost();
    if (!host) {
      const diag = {
        phase: 'missing_host',
        windowHostname: window.location.hostname,
        __SHOPIFY_PERMANENT_DOMAIN__: window.__SHOPIFY_PERMANENT_DOMAIN__,
        hint: 'Set window.__SHOPIFY_PERMANENT_DOMAIN__ from Liquid (shop.permanent_domain) when on localhost.',
      };
      console.error('[HubBuilder] Missing shop host for Storefront API.', diag);
      if (typeof window !== 'undefined') window.__HUB_RULES_LAST_GRAPHQL_DIAG__ = diag;
      return { errors: [{ message: 'Missing shop domain for GraphQL' }] };
    }
    const endpoint = `https://${host}/api/${STOREFRONT_API_VERSION}/graphql.json`;
    let res;
    try {
      res = await hubFetchWith429Retry(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': getHubStorefrontToken(),
        },
        body: JSON.stringify({ query, variables }),
      });
    } catch (networkErr) {
      const diag = {
        phase: 'network',
        name: networkErr?.name,
        message: networkErr?.message,
        cause: networkErr?.cause,
        endpoint,
        hostUsed: host,
        usingPermanentDomain,
        windowHostname: window.location.hostname,
        storefrontApiVersion: STOREFRONT_API_VERSION,
      };
      console.error(`${DBG} fetch() threw (network / CORS / blocked). Copy this object for support:`, diag);
      if (typeof window !== 'undefined') window.__HUB_RULES_LAST_GRAPHQL_DIAG__ = diag;
      throw networkErr;
    }
    const resForText = res.clone();
    let data;
    try {
      data = await res.json();
    } catch (parseErr) {
      const text = await resForText.text().catch(() => '');
      const diag = {
        phase: 'json_parse',
        status: res.status,
        statusText: res.statusText,
        endpoint,
        hostUsed: host,
        bodyPreview: String(text).slice(0, 800),
        parseMessage: parseErr?.message,
      };
      console.error(`${DBG} JSON parse failed — copy diag:`, diag);
      if (typeof window !== 'undefined') window.__HUB_RULES_LAST_GRAPHQL_DIAG__ = diag;
      console.error('[HubBuilder] storefrontGraphQL JSON parse failed', {
        status: res.status,
        statusText: res.statusText,
        endpoint,
        bodyPreview: String(text).slice(0, 500),
        parseErr,
      });
      throw parseErr;
    }
    if (!res.ok) {
      const diag = {
        phase: 'http_not_ok',
        status: res.status,
        statusText: res.statusText,
        endpoint,
        hostUsed: host,
        responseKeys: data && typeof data === 'object' ? Object.keys(data) : [],
        errors: data?.errors,
      };
      console.error(`${DBG} non-OK HTTP — copy diag:`, diag);
      if (typeof window !== 'undefined') window.__HUB_RULES_LAST_GRAPHQL_DIAG__ = diag;
      console.error('[HubBuilder] storefrontGraphQL non-OK response', {
        status: res.status,
        statusText: res.statusText,
        endpoint,
        data,
      });
    } else if (data && Array.isArray(data.errors) && data.errors.length) {
      const diag = {
        phase: 'graphql_errors',
        endpoint,
        hostUsed: host,
        errors: data.errors,
      };
      console.warn(`${DBG} GraphQL errors in 200 response — copy diag:`, diag);
      if (typeof window !== 'undefined') window.__HUB_RULES_LAST_GRAPHQL_DIAG__ = diag;
    }
    return data;
  }

  function getCountryCodeForContext() {
    // Prefer section-provided country (Markets), then Shopify country, then HTML lang-country, then US
    const explicit = window.__HUB_BUILDER_COUNTRY__;
    if (explicit && typeof explicit === 'string') return explicit.toUpperCase();
    const shopifyCountry = window.Shopify && window.Shopify.country;
    if (shopifyCountry && typeof shopifyCountry === 'string') return shopifyCountry.toUpperCase();
    const htmlLang = (document.documentElement.getAttribute('lang') || '').toUpperCase();
    // Try to extract trailing country code from patterns like en-US
    const match = htmlLang.match(/-[A-Z]{2}$/);
    if (match) return match[0].slice(1);
    return 'US';
  }

  function wbResolveBuilderCurrency() {
    return String(
      window.__WHEEL_BUILDER_CURRENCY__ ||
        window.__HUB_BUILDER_CURRENCY__ ||
        window.Shopify?.currency?.active ||
        'USD'
    ).toUpperCase();
  }

  function wbResolveBuilderLocale() {
    const country =
      window.__WHEEL_BUILDER_COUNTRY__ ||
      window.__HUB_BUILDER_COUNTRY__ ||
      window.Shopify?.country ||
      '';
    const baseLocale = window.Shopify?.locale || 'en';
    return country ? `${baseLocale}-${country}` : baseLocale;
  }

  function wbPayRowCurrencyLabel(currencyCode) {
    switch (String(currencyCode || '').toUpperCase()) {
      case 'USD':
        return 'USD';
      case 'CAD':
        return 'CAD';
      case 'EUR':
        return '€';
      default:
        return null;
    }
  }

  function wbFormatAmountOnly(value) {
    return new Intl.NumberFormat(wbResolveBuilderLocale(), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(value || 0));
  }

  function wbBuildPayRowPriceFields(numericValue, currencyCode) {
    const code = String(currencyCode || wbResolveBuilderCurrency()).toUpperCase();
    const label = wbPayRowCurrencyLabel(code);
    const amount = wbFormatAmountOnly(numericValue);

    if (!label) {
      try {
        return {
          currencyLabel: null,
          priceAmount: null,
          price: new Intl.NumberFormat(wbResolveBuilderLocale(), {
            style: 'currency',
            currency: code,
          }).format(Number(numericValue || 0)),
        };
      } catch (_) {
        return { currencyLabel: null, priceAmount: null, price: `${code} ${amount}` };
      }
    }

    return {
      currencyLabel: label,
      priceAmount: amount,
      price: `${label}\u00a0${amount}`,
    };
  }

  function buildPayRowPricingPatch(priceMoney, compareMoney, savingsMoney) {
    if (!priceMoney || typeof priceMoney.amount === 'undefined') {
      return { price: null, priceAmount: null, currencyLabel: null, compareAtPrice: null, compareAtPriceAmount: null, savings: null };
    }
    const code = priceMoney.currencyCode || wbResolveBuilderCurrency();
    const priceParts = wbBuildPayRowPriceFields(parseFloat(priceMoney.amount), code);
    const compareParts =
      compareMoney && typeof compareMoney.amount !== 'undefined'
        ? wbBuildPayRowPriceFields(parseFloat(compareMoney.amount), code)
        : null;
    const savingsParts =
      savingsMoney && typeof savingsMoney.amount !== 'undefined'
        ? wbBuildPayRowPriceFields(parseFloat(savingsMoney.amount), code)
        : null;

    return {
      currencyLabel: priceParts.currencyLabel,
      priceAmount: priceParts.priceAmount,
      price: priceParts.price,
      compareAtPriceAmount: compareParts?.priceAmount ?? null,
      compareAtPrice: compareParts
        ? compareParts.currencyLabel
          ? compareParts.priceAmount
          : compareParts.price
        : null,
      savings: savingsParts?.price ?? null,
    };
  }

  function formatMoneyV2(money) {
    if (!money || typeof money.amount === 'undefined') return '';
    const amount = parseFloat(money.amount);
    if (!isFinite(amount)) return '';
    const code = money.currencyCode || window.__HUB_BUILDER_CURRENCY__ || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
    } catch (_) {
      return `${code} ${amount.toFixed(2)}`;
    }
  }

  /**
   * Fetch pricing for a product handle using the session-aware product.js endpoint.
   *
   * Why product.js instead of the Storefront API:
   *   - product.js is evaluated server-side against the logged-in buyer's session.
   *     Shopify applies ALL catalogue memberships (B2B or otherwise) and returns the
   *     lowest applicable price automatically — the same "lowest catalogue wins" rule
   *     that applies everywhere else in the theme.
   *   - The Storefront API without a buyerIdentity / customer access token returns only
   *     retail (public) prices, so B2B customers would see incorrect retail pricing.
   *   - product.js also returns presentment-currency prices (respects Shopify Markets /
   *     currency selector), so multi-currency works correctly on both D2C and B2B.
   */
  async function fetchProductPricingByHandle(handle) {
    const json = await fetchProductJsonByHandle(handle);
    const variant = Array.isArray(json?.variants)
      ? (json.variants.find(v => v?.available) || json.variants[0])
      : null;
    if (!variant || typeof variant.price !== 'number') return { price: null, compareAtPrice: null };
    // Currency: prefer the value set from Liquid (localization.country.currency.iso_code),
    // fall back to Shopify's runtime active currency, then USD.
    const rawCode =
      (window.__HUB_BUILDER_CURRENCY__ && String(window.__HUB_BUILDER_CURRENCY__).trim()) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
    const code = rawCode.trim().toUpperCase();
    return {
      price: { amount: String(variant.price / 100), currencyCode: code },
      compareAtPrice:
        variant.compare_at_price && typeof variant.compare_at_price === 'number'
          ? { amount: String(variant.compare_at_price / 100), currencyCode: code }
          : null,
    };
  }

  const HUB_PRICING_FETCH_TIMEOUT_MS = 14000;
  const HUB_PRICING_CACHE_TTL_MS = 5000;
  const hubPricingCache = new Map();
  const hubPricingInflight = new Map();

  async function fetchVariantPricingById(variantId) {
    const id = Number(variantId);
    if (!id || !Number.isFinite(id)) return { price: null, compareAtPrice: null };
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let res;
    try {
      res = await fetch(`${root}variants/${id}.js`);
    } catch (_) {
      return { price: null, compareAtPrice: null };
    }
    if (!res.ok) return { price: null, compareAtPrice: null };
    let v;
    try {
      v = await res.json();
    } catch (_) {
      return { price: null, compareAtPrice: null };
    }
    const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    if (typeof v.price !== 'number') return { price: null, compareAtPrice: null };
    return {
      price: { amount: String(v.price / 100), currencyCode: code },
      compareAtPrice:
        v.compare_at_price && typeof v.compare_at_price === 'number'
          ? { amount: String(v.compare_at_price / 100), currencyCode: code }
          : null,
    };
  }

  async function hubFetchPricingWithTimeout(handle) {
    const h = String(handle || '').trim();
    if (!h) return { price: null, compareAtPrice: null };

    const now = Date.now();
    const cached = hubPricingCache.get(h);
    if (cached && (now - cached.ts) < HUB_PRICING_CACHE_TTL_MS) {
      return cached.value;
    }

    if (hubPricingInflight.has(h)) {
      return hubPricingInflight.get(h);
    }

    const request = Promise.race([
      fetchProductPricingByHandle(h),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Pricing request timed out')), HUB_PRICING_FETCH_TIMEOUT_MS),
      ),
    ])
      .then((value) => {
        hubPricingCache.set(h, { ts: Date.now(), value });
        return value;
      })
      .finally(() => {
        hubPricingInflight.delete(h);
      });

    hubPricingInflight.set(h, request);
    return request;
  }

  const HUB_META_OBJECTS_API_DEFAULT = 'https://meta-objects-api.onrender.com';
  const HUB_META_OBJECTS_API_PATH_DEFAULT = '/api/product-database/meta-objects';
  const HB_DEFAULT_REGION = 'us';

  function hbDetectRegion() {
    try {
      const urlOverride = (typeof location !== 'undefined'
        ? new URLSearchParams(location.search).get('wb_region')
        : '')?.trim()?.toLowerCase();
      if (urlOverride) return urlOverride;
      const overrideEl = typeof document !== 'undefined' ? document.querySelector?.('[data-wb-region]') : null;
      const dataOverride = overrideEl?.getAttribute?.('data-wb-region')?.trim()?.toLowerCase();
      if (dataOverride) return dataOverride;
      const c = String(window?.Shopify?.country || '').toUpperCase().trim();
      if (c === 'CA') return 'canada';
      if (c === 'US') return 'us';
      const EU = new Set([
        'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
        'GB','UK','CH','NO','IS','LI',
      ]);
      if (EU.has(c)) return 'eu';
      return HB_DEFAULT_REGION;
    } catch (_) {
      return HB_DEFAULT_REGION;
    }
  }

  function getHubMetaObjectsApiConfig(apiConfig = {}) {
    const baseUrl = (
      apiConfig.ecomEngineUrl
      || window.__HUB_BUILDER_META_OBJECTS_API_URL__
      || HUB_META_OBJECTS_API_DEFAULT
    ).trim().replace(/\/$/, '');
    const apiPath = (
      apiConfig.ecomEngineApiPath
      || window.__HUB_BUILDER_META_OBJECTS_API_PATH__
      || HUB_META_OBJECTS_API_PATH_DEFAULT
    ).replace(/^\//, '');
    return { baseUrl, apiPath };
  }

  /**
   * Fetch precomputed rules index from meta-objects-api (Postgres).
   * workspace: hubs | stems | wheels
   */
  async function fetchRulesIndexFromMetaObjectsApi({
    baseUrl,
    apiPath,
    workspace,
    modelColumn,
    modelValue,
    region = '',
  }) {
    try {
      // Theme settings often include a trailing slash; strip so we never request //api/...
      const base = String(baseUrl || '').trim().replace(/\/+$/, '');
      const pathBase = (apiPath || HUB_META_OBJECTS_API_PATH_DEFAULT).replace(/^\//, '');
      const path = pathBase.replace(/\/?$/, '') + '/rules';
      const url = new URL(`${base}/${path}`);
      url.searchParams.set('workspace', workspace);
      if (modelValue) {
        url.searchParams.set(modelColumn, modelValue);
        url.searchParams.set('model', modelValue);
      }
      if (region && String(region).trim()) {
        url.searchParams.set('region', String(region).trim().toLowerCase());
      }
      const res = await fetch(url.toString(), {
        headers: {
          'Content-Type': 'application/json',
          'X-Workspace': workspace,
          // Bypass ngrok free-tier browser interstitial for storefront fetch() calls.
          'ngrok-skip-browser-warning': 'true',
        },
      });
      if (!res.ok) {
        if (res.status === 503) return { rulesIndex: null, errors: 'Rules index not ready' };
        return { rulesIndex: null, errors: await res.text() };
      }
      const data = await res.json();
      if (!data.options || !data.configs) {
        return { rulesIndex: null, errors: 'Invalid rules response' };
      }
      return { rulesIndex: data, errors: null };
    } catch (e) {
      return { rulesIndex: null, errors: e?.message || String(e) };
    }
  }

  async function fetchHubRulesIndexFromApi(baseUrl, apiPath, hubModel, region) {
    for (const modelForApi of hubRulesApiModelCandidates(hubModel, hubModel)) {
      const res = await fetchRulesIndexFromMetaObjectsApi({
        baseUrl,
        apiPath,
        workspace: 'hubs',
        modelColumn: 'hub_model',
        modelValue: modelForApi,
        region,
      });
      if (res.rulesIndex?.configs?.length) return res;
      if (res.errors && res.errors !== 'No rules index for model') return res;
    }
    return { rulesIndex: null, errors: 'No rules index for model' };
  }

  async function fetchStemRulesIndexFromApi(baseUrl, apiPath, stemModel, region) {
    for (const modelForApi of stemRulesApiModelCandidates(stemModel, stemModel)) {
      const res = await fetchRulesIndexFromMetaObjectsApi({
        baseUrl,
        apiPath,
        workspace: 'stems',
        modelColumn: 'stem_model',
        modelValue: modelForApi,
        region,
      });
      if (res.rulesIndex?.configs?.length) return res;
      if (res.errors && res.errors !== 'No rules index for model') return res;
    }
    return { rulesIndex: null, errors: 'No rules index for model' };
  }

  const HUB_FETCH_PAGE_SIZE = 2000;

  function hubApiRowToRule(row, metaobjectType = 'hub_rule') {
    const fields = [];
    for (const [key, value] of Object.entries(row?.fields || {})) {
      if (value != null && String(value).trim() !== '') {
        fields.push({ key, value: String(value).trim() });
      }
    }
    const frontHandle = row?.front_handle;
    const rearHandle = row?.rear_handle;
    if (frontHandle && !fields.some((f) => f.key === 'front_handle')) {
      fields.push({ key: 'front_handle', value: String(frontHandle).trim() });
    }
    if (rearHandle && !fields.some((f) => f.key === 'rear_handle')) {
      fields.push({ key: 'rear_handle', value: String(rearHandle).trim() });
    }
    return { handle: row?.handle || '', type: metaobjectType, fields };
  }

  async function fetchHubRulesPageFromApi(baseUrl, apiPath, hubModel) {
    try {
      const base = String(baseUrl || '').trim().replace(/\/+$/, '');
      const pathBase = (apiPath || HUB_META_OBJECTS_API_PATH_DEFAULT).replace(/^\//, '');
      const allRules = [];
      let offset = 0;
      while (allRules.length < 12000) {
        const url = new URL(`${base}/${pathBase}`);
        url.searchParams.set('workspace', 'hubs');
        url.searchParams.set('hub_model', hubModel);
        url.searchParams.set('model', hubModel);
        url.searchParams.set('limit', String(HUB_FETCH_PAGE_SIZE));
        url.searchParams.set('offset', String(offset));
        const res = await fetch(url.toString(), {
          headers: {
            'Content-Type': 'application/json',
            'X-Workspace': 'hubs',
            'ngrok-skip-browser-warning': 'true',
          },
        });
        if (!res.ok) return { rules: allRules, error: await res.text() };
        const data = await res.json();
        const page = (data.metaObjects || []).map((r) => hubApiRowToRule(r, 'hub_rule'));
        allRules.push(...page);
        offset += page.length;
        if (page.length < HUB_FETCH_PAGE_SIZE) break;
      }
      return { rules: allRules, error: null };
    } catch (e) {
      return { rules: [], error: e?.message || String(e) };
    }
  }

  async function fetchStemRulesPageFromApi(baseUrl, apiPath, stemModel) {
    try {
      const base = String(baseUrl || '').trim().replace(/\/+$/, '');
      const pathBase = (apiPath || HUB_META_OBJECTS_API_PATH_DEFAULT).replace(/^\//, '');
      const allRules = [];
      let offset = 0;
      while (allRules.length < 5000) {
        const url = new URL(`${base}/${pathBase}`);
        url.searchParams.set('workspace', 'stems');
        url.searchParams.set('stem_model', stemModel);
        url.searchParams.set('model', stemModel);
        url.searchParams.set('limit', String(HUB_FETCH_PAGE_SIZE));
        url.searchParams.set('offset', String(offset));
        const res = await fetch(url.toString(), {
          headers: {
            'Content-Type': 'application/json',
            'X-Workspace': 'stems',
            'ngrok-skip-browser-warning': 'true',
          },
        });
        if (!res.ok) return { rules: allRules, error: await res.text() };
        const data = await res.json();
        const page = (data.metaObjects || []).map((r) => hubApiRowToRule(r, 'stem_rules'));
        allRules.push(...page);
        offset += page.length;
        if (page.length < HUB_FETCH_PAGE_SIZE) break;
      }
      return { rules: allRules, error: null };
    } catch (e) {
      return { rules: [], error: e?.message || String(e) };
    }
  }

  function getHubRulesIndex() {
    return window.__HUB_RULES_INDEX__ || null;
  }

  function hubIntersectConfigIndices(rulesIndex, selections, buildType) {
    const idx = rulesIndex?.configIndicesNorm || rulesIndex?.configIndices || {};
    let indices = null;
    const intersect = (a, b) => {
      if (!a?.length) return b ? [...b] : [];
      if (!b?.length) return a ? [...a] : [];
      const setB = new Set(b);
      return a.filter((x) => setB.has(x));
    };
    for (const [key, val] of Object.entries(selections || {})) {
      if (!val) continue;
      const n = hubNormMatchValue(val);
      const slice = hubRulesIndexPickKey(idx, key);
      const indicesForVal = slice?.[n] ?? slice?.[val];
      if (!indicesForVal?.length) return [];
      indices = indices == null ? indicesForVal : intersect(indices, indicesForVal);
    }
    if (indices == null) {
      indices = (rulesIndex.configs || []).map((_, i) => i);
    }
    const tabKey = buildType === 'front' ? 'front_handle' : buildType === 'rear' ? 'rear_handle' : 'handle';
    const oosArr = rulesIndex?.unavailable?.[tabKey];
    if (Array.isArray(oosArr) && oosArr.length && indices?.length) {
      const oosSet = new Set(oosArr);
      indices = indices.filter((i) => !oosSet.has(i));
    }
    return indices;
  }

  function buildColorToHandleMapFromHubRulesIndex(rulesIndex, selections, buildType) {
    const indices = hubIntersectConfigIndices(rulesIndex, selections, buildType);
    const map = {};
    const handles = rulesIndex?.handles || [];
    for (const i of indices) {
      const config = rulesIndex.configs[i] || {};
      const h = handles[i] || {};
      const color = config.hub_color || config.hub_colour;
      if (!color) continue;
      const colorKey = String(color).trim();
      if (!map[colorKey]) map[colorKey] = {};
      if (buildType === 'front' || buildType === 'complete') {
        const fh = h.front_handle || config.front_handle;
        if (fh) {
          map[colorKey].front = String(fh).trim();
          map[colorKey].any = map[colorKey].any || String(fh).trim();
        }
      }
      if (buildType === 'rear' || buildType === 'complete') {
        const rh = h.rear_handle || config.rear_handle;
        if (rh) {
          map[colorKey].rear = String(rh).trim();
          map[colorKey].any = map[colorKey].any || String(rh).trim();
        }
      }
    }
    return map;
  }

  function hubRulesApiModelCandidates(modelHandle, rulesModel) {
    const candidates = [];
    const add = (v) => {
      const s = String(v || '').trim();
      if (s && !candidates.includes(s)) candidates.push(s);
    };
    add(rulesModel);
    add(window.__HUB_BUILDER_RULES_MODEL__);
    add(window.__HUB_BUILDER_OPTIONS__?.hub_model);
    add(window.__HUB_BUILDER_OPTIONS__?.hub_model_handle);
    const key = normalizeHubRuleModelKey(modelHandle);
    if (key.includes('hydra')) add('Hydra 2');
    if (key.includes('solix')) add('Solix');
    if (key === '11' || key.startsWith('11')) add('1/1');
    add(modelHandle);
    return candidates;
  }

  function stemRulesApiModelCandidates(modelHandle, rulesModel) {
    const candidates = [];
    const add = (v) => {
      const s = String(v || '').trim();
      if (s && !candidates.includes(s)) candidates.push(s);
    };
    add(rulesModel);
    add(window.__HUB_BUILDER_RULES_MODEL__);
    add(window.__HUB_BUILDER_OPTIONS__?.stem_model);
    add(window.__HUB_BUILDER_OPTIONS__?.stem_model_handle);
    add(window.__HUB_BUILDER_OPTIONS__?.product_handle);
    add(modelHandle);
    return candidates;
  }

  function normalizeHubRuleModelKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\b(front-hub|rear-hub|hubset|hubs|hub)\b/g, '')
      .replace(/[-_\s/]+/g, '')
      .trim();
  }

  function filterHubRuleNodesByModel(nodes, modelHandle) {
    const modelKey = normalizeHubRuleModelKey(modelHandle);
    return (nodes || []).filter((node) => {
      const map = Object.fromEntries((node.fields || []).map((f) => [f.key, f.value]));
      const hubModel = map.hub_model_handle || map.hub_model || '';
      const nodeKey = normalizeHubRuleModelKey(hubModel);
      const equal = nodeKey === modelKey;
      const contains = nodeKey.includes(modelKey) || modelKey.includes(nodeKey);
      return equal || contains;
    });
  }

  /** One network round-trip for all hub_rule rows; concurrent callers share the same promise. */
  let hubRulesAllNodesPromise = null;
  let hubRulesAllNodesCache = null;

  async function fetchHubRulesAllNodes() {
    if (hubRulesAllNodesCache) return { nodes: hubRulesAllNodesCache, error: null };
    if (!hubRulesAllNodesPromise) {
      const DBG = '[HubBuilder] fetchHubRules';
      hubRulesAllNodesPromise = (async () => {
        try {
          const modelKeyNote = '(filter per caller after fetch)';
          console.log(`${DBG}:start (shared fetch)`, {
            metaobjectTypeQueried: 'hub_rule',
            fieldKeysUsedToMatchHub: ['hub_model_handle', 'hub_model'],
            modelFilterNote: modelKeyNote,
          });

          let results = [];
          let cursor = null;
          let hasMore = true;
          let page = 0;
          while (hasMore) {
            page += 1;
            const variables = { type: 'hub_rule', entryCount: 250, cursor };
            console.log(`${DBG}:graphql variables (page ${page})`, variables);

            const response = await storefrontGraphQL(
              `query GetHubRules($type: String!, $entryCount: Int!, $cursor: String){
                metaobjects(type: $type, first: $entryCount, after: $cursor){
                  edges{ node{ handle type fields{ key value } } }
                  pageInfo{ hasNextPage endCursor }
                }
              }`,
              variables
            );

            console.log(`${DBG}:graphql response (page ${page})`, {
              topLevelKeys: response && typeof response === 'object' ? Object.keys(response) : [],
              errors: response?.errors ?? null,
              extensions: response?.extensions ?? null,
              metaobjectsNull: response?.data?.metaobjects == null,
              edgeCount: response?.data?.metaobjects?.edges?.length,
              pageInfo: response?.data?.metaobjects?.pageInfo ?? null,
            });

            const { data, errors } = response;
            if (errors) {
              console.error(`${DBG}: GraphQL errors (full)`, errors);
              if (typeof window !== 'undefined') {
                window.__HUB_RULES_LAST_GRAPHQL_DIAG__ = {
                  phase: 'metaobjects_hub_rule_query',
                  errors,
                  variables,
                  hint: 'Common causes: Storefront API missing metaobjects scope, or API version mismatch.',
                };
              }
              return { nodes: [], error: `GraphQL errors: ${JSON.stringify(errors)}` };
            }
            const edges = data?.metaobjects?.edges || [];
            if (edges[0]?.node?.fields?.length) {
              console.log(`${DBG}:sample first metaobject field keys`, {
                handle: edges[0].node.handle,
                type: edges[0].node.type,
                keys: edges[0].node.fields.map((f) => f.key),
              });
            } else if (edges.length === 0) {
              console.log(`${DBG}:no metaobjects returned for type "hub_rule" on this page`);
            }

            results = results.concat(edges.map((e) => e.node));
            hasMore = data?.metaobjects?.pageInfo?.hasNextPage;
            cursor = data?.metaobjects?.pageInfo?.endCursor;
          }

          hubRulesAllNodesCache = results;
          console.log(`${DBG}:done (shared)`, { totalMetaobjectsFetched: results.length });
          return { nodes: results, error: null };
        } catch (e) {
          const errMsg = e?.message || String(e);
          const diag = {
            phase: 'fetchHubRulesAllNodes_exception',
            name: e?.name,
            message: errMsg,
            lastGraphQL: typeof window !== 'undefined' ? window.__HUB_RULES_LAST_GRAPHQL_DIAG__ : undefined,
          };
          console.error(`${DBG}:exception`, e, diag);
          if (typeof window !== 'undefined') window.__HUB_RULES_LAST_FETCH_DIAG__ = diag;
          return { nodes: [], error: errMsg || 'Failed to fetch rules' };
        } finally {
          hubRulesAllNodesPromise = null;
        }
      })();
    }
    return hubRulesAllNodesPromise;
  }

  async function fetchHubRulesFromShopify(modelHandle) {
    const DBG = '[HubBuilder] fetchHubRules (Shopify GraphQL fallback)';
    try {
      const { nodes, error } = await fetchHubRulesAllNodes();
      if (error) return { rules: [], error };
      const filtered = filterHubRuleNodesByModel(nodes, modelHandle);
      console.log(`${DBG}: filtered`, {
        modelHandle,
        afterHubModelFilter: filtered.length,
        totalMetaobjectsFetched: nodes.length,
      });
      return { rules: filtered, error: null };
    } catch (e) {
      return { rules: [], error: e?.message || 'Failed to fetch rules' };
    }
  }

  async function ensureHubRules(modelHandle) {
    if (getHubRulesIndex()) return [];
    const cached = window.__HUB_RULES__;
    if (Array.isArray(cached) && cached.length > 0) return cached;

    const { baseUrl } = getHubMetaObjectsApiConfig({});
    const useGraphqlFallback = !baseUrl;

    return new Promise((resolve) => {
      const finish = () => {
        document.removeEventListener('wheelbuilder:rules-loaded', handler);
        clearTimeout(timeoutId);
        if (getHubRulesIndex()) resolve([]);
        else resolve(Array.isArray(window.__HUB_RULES__) ? window.__HUB_RULES__ : []);
      };
      const handler = () => finish();
      const timeoutId = setTimeout(() => {
        if (useGraphqlFallback && !getHubRulesIndex() && !(Array.isArray(window.__HUB_RULES__) && window.__HUB_RULES__.length)) {
          fetchHubRulesFromShopify(modelHandle).then(({ rules }) => {
            window.__HUB_RULES__ = rules || [];
            resolve(window.__HUB_RULES__);
          });
          return;
        }
        finish();
      }, 12000);

      if (getHubRulesIndex()) {
        finish();
        return;
      }
      if (Array.isArray(window.__HUB_RULES__) && window.__HUB_RULES__.length > 0) {
        resolve(window.__HUB_RULES__);
        return;
      }

      document.addEventListener('wheelbuilder:rules-loaded', handler);
    });
  }

  function normalizeStemRuleModelKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\b(stemset|stems|stem)\b/g, '')
      .replace(/[-_\s/]+/g, '')
      .trim();
  }

  /**
   * Storefront `metaobjects(type: …)` handle — must match the metaobject definition in Shopify
   * (Settings → Custom data → Metaobjects). Override per page: window.__STEM_RULE_METAOBJECT_TYPE__ = 'your_handle';
   */
  const STEM_RULE_METAOBJECT_TYPE = 'stem_rules';

  function getStemRuleMetaobjectType() {
    if (typeof window !== 'undefined' && window.__STEM_RULE_METAOBJECT_TYPE__) {
      const t = String(window.__STEM_RULE_METAOBJECT_TYPE__).trim();
      if (t) return t;
    }
    return STEM_RULE_METAOBJECT_TYPE;
  }

  /**
   * Match a stem_rules row to the stem PDP product handle (`__HUB_BUILDER_MODEL__`).
   * Order: stem_model_handle (normalized) → product_handle exact/prefix/SKU-style (`mt-*` for handle `mt`)
   * → stem_model display name (normalized). Avoid using only stem_model first: display names like
   * "Mountain Stem" normalize to `mountain` and won't match handle `mt`.
   */
  function stemRuleRowMatchesProductModel(map, modelHandle) {
    const modelKey = normalizeStemRuleModelKey(modelHandle);
    const mh = String(modelHandle || '').trim().toLowerCase();
    if (!mh) return false;

    const normMatch = (raw) => {
      if (raw == null || String(raw).trim() === '') return false;
      const nodeKey = normalizeStemRuleModelKey(String(raw));
      if (!nodeKey || !modelKey) return nodeKey === modelKey;
      return (
        nodeKey === modelKey ||
        nodeKey.includes(modelKey) ||
        modelKey.includes(nodeKey)
      );
    };

    if (normMatch(map.stem_model_handle)) return true;

    const ph = map.product_handle != null ? String(map.product_handle).trim().toLowerCase() : '';
    if (ph) {
      if (ph === mh || ph.startsWith(`${mh}-`)) return true;
      if (normMatch(map.product_handle)) return true;
    }

    if (normMatch(map.stem_model)) return true;

    return false;
  }

  function filterStemRuleNodesByModel(nodes, modelHandle) {
    return (nodes || []).filter((node) => {
      const map = Object.fromEntries((node.fields || []).map((f) => [f.key, f.value]));
      return stemRuleRowMatchesProductModel(map, modelHandle);
    });
  }

  /** Why rows were rejected/accepted vs product handle (deep debug only). */
  function stemDebugExplainStemRuleFilter(nodes, modelHandle, filtered) {
    if (!stemBuilderDeepDebugEnabled()) return;
    const modelKey = normalizeStemRuleModelKey(modelHandle);
    const mh = String(modelHandle || '').trim().toLowerCase();
    stemDebugLog('normalizeStemRuleModelKey(product handle)', { modelHandle, modelKey });
    const filteredSet = new Set((filtered || []).map((n) => n && n.handle).filter(Boolean));
    const rejected = (nodes || []).filter((n) => n && !filteredSet.has(n.handle)).slice(0, 6);
    rejected.forEach((node, i) => {
      const map = Object.fromEntries((node.fields || []).map((f) => [f.key, f.value]));
      const ph = map.product_handle != null ? String(map.product_handle).trim().toLowerCase() : '';
      stemDebugLog(`stem_rule row NOT matched [${i}]`, {
        ruleHandle: node.handle,
        stem_model_handle: map.stem_model_handle,
        stem_model: map.stem_model,
        product_handle: map.product_handle,
        productHandlePrefixMatch: !!(mh && ph && (ph === mh || ph.startsWith(`${mh}-`))),
        stemRuleRowMatchesProductModel: stemRuleRowMatchesProductModel(map, modelHandle),
      });
    });
    const acceptedSample = (filtered || []).slice(0, 4).map((node) => {
      const map = Object.fromEntries((node.fields || []).map((f) => [f.key, f.value]));
      return {
        handle: node.handle,
        stem_model_handle: map.stem_model_handle,
        stem_model: map.stem_model,
        fieldKeys: Object.keys(map),
      };
    });
    stemDebugLog('stem_rule rows matched (sample)', acceptedSample);
  }

  let stemRulesAllNodesPromise = null;
  let stemRulesAllNodesCache = null;

  async function fetchStemRulesAllNodes() {
    if (stemRulesAllNodesCache) {
      stemDebugLog('fetchStemRulesAllNodes: in-memory cache hit', {
        count: stemRulesAllNodesCache.length,
      });
      return { nodes: stemRulesAllNodesCache, error: null };
    }
    if (!stemRulesAllNodesPromise) {
      const DBG = '[StemBuilder] fetchStemRules';
      stemRulesAllNodesPromise = (async () => {
        try {
          let results = [];
          let cursor = null;
          let hasMore = true;
          let page = 0;
          while (hasMore) {
            page += 1;
            const variables = { type: getStemRuleMetaobjectType(), entryCount: 250, cursor };
            const response = await storefrontGraphQL(
              `query GetStemRules($type: String!, $entryCount: Int!, $cursor: String){
                metaobjects(type: $type, first: $entryCount, after: $cursor){
                  edges{ node{ handle type fields{ key value } } }
                  pageInfo{ hasNextPage endCursor }
                }
              }`,
              variables,
            );

            const { data, errors } = response;
            if (errors) {
              console.error(`${DBG}: GraphQL errors`, errors);
              if (typeof window !== 'undefined') {
                window.__STEM_RULES_LAST_GRAPHQL_DIAG__ = {
                  phase: 'metaobjects_stem_rule_query',
                  errors,
                  variables,
                };
              }
              return { nodes: [], error: `GraphQL errors: ${JSON.stringify(errors)}` };
            }
            const edges = data?.metaobjects?.edges || [];
            results = results.concat(edges.map((e) => e.node));
            hasMore = data?.metaobjects?.pageInfo?.hasNextPage;
            cursor = data?.metaobjects?.pageInfo?.endCursor;
          }
          stemRulesAllNodesCache = results;
          console.log(`${DBG}:done (shared)`, { totalMetaobjectsFetched: results.length });
          stemDebugLog('fetchStemRulesAllNodes: GraphQL pages complete', {
            totalMetaobjectsFetched: results.length,
            pages: page,
          });
          return { nodes: results, error: null };
        } catch (e) {
          const errMsg = e?.message || String(e);
          const diag = {
            phase: 'fetchStemRulesAllNodes_exception',
            name: e?.name,
            message: errMsg,
            lastGraphQL: typeof window !== 'undefined' ? window.__STEM_RULES_LAST_GRAPHQL_DIAG__ : undefined,
          };
          console.error(`${DBG}:exception`, e, diag);
          if (typeof window !== 'undefined') window.__STEM_RULES_LAST_FETCH_DIAG__ = diag;
          return { nodes: [], error: errMsg || 'Failed to fetch stem rules' };
        } finally {
          stemRulesAllNodesPromise = null;
        }
      })();
    }
    return stemRulesAllNodesPromise;
  }

  async function fetchStemRulesFromShopify(modelHandle) {
    const DBG = '[StemBuilder] fetchStemRules (Shopify GraphQL fallback)';
    try {
      const { nodes, error } = await fetchStemRulesAllNodes();
      if (error) return { rules: [], error };
      const filtered = filterStemRuleNodesByModel(nodes, modelHandle);
      stemDebugExplainStemRuleFilter(nodes, modelHandle, filtered);
      console.log(`${DBG}: filtered`, {
        modelHandle,
        afterStemModelFilter: filtered.length,
        totalMetaobjectsFetched: nodes.length,
      });
      return { rules: filtered, error: null };
    } catch (e) {
      return { rules: [], error: e?.message || 'Failed to fetch stem rules' };
    }
  }

  async function ensureStemRules(modelHandle) {
    const rulesIndex = typeof window !== 'undefined' ? window.__STEM_RULES_INDEX__ : null;
    if (rulesIndex?.configs?.length) return [];
    const cached = typeof window !== 'undefined' && Array.isArray(window.__STEM_RULES__);
    if (cached && window.__STEM_RULES__.length > 0) return window.__STEM_RULES__;

    const { baseUrl } = getHubMetaObjectsApiConfig({});
    const useGraphqlFallback = !baseUrl;

    return new Promise((resolve) => {
      const finish = () => {
        document.removeEventListener('wheelbuilder:rules-loaded', handler);
        clearTimeout(timeoutId);
        const idx = typeof window !== 'undefined' ? window.__STEM_RULES_INDEX__ : null;
        if (idx?.configs?.length) resolve([]);
        else resolve(typeof window !== 'undefined' && Array.isArray(window.__STEM_RULES__) ? window.__STEM_RULES__ : []);
      };
      const handler = () => finish();
      const timeoutId = setTimeout(() => {
        if (useGraphqlFallback && !(typeof window !== 'undefined' && window.__STEM_RULES_INDEX__?.configs?.length)
          && !(typeof window !== 'undefined' && Array.isArray(window.__STEM_RULES__) && window.__STEM_RULES__.length)) {
          fetchStemRulesFromShopify(modelHandle).then(({ rules }) => {
            if (typeof window !== 'undefined') window.__STEM_RULES__ = rules || [];
            resolve(rules || []);
          });
          return;
        }
        finish();
      }, 12000);

      if (typeof window !== 'undefined' && window.__STEM_RULES_INDEX__?.configs?.length) {
        finish();
        return;
      }
      if (typeof window !== 'undefined' && Array.isArray(window.__STEM_RULES__) && window.__STEM_RULES__.length > 0) {
        resolve(window.__STEM_RULES__);
        return;
      }

      document.addEventListener('wheelbuilder:rules-loaded', handler);
    });
  }

  /* ── driver_rule metaobject fetch (parallel to hub_rule / stem_rule) ── */

  function normalizeDriverRuleModelKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\b(hubset|hubs|hub|front-hub|rear-hub)\b/g, '')
      .replace(/[-_\s/]+/g, '')
      .trim();
  }

  function filterDriverRuleNodesByModel(nodes, modelHandle) {
    const modelKey = normalizeDriverRuleModelKey(modelHandle);
    return (nodes || []).filter((node) => {
      const map = Object.fromEntries((node.fields || []).map((f) => [f.key, f.value]));
      const hubModel =
        map.hub_model_handle || map.hub_model || map.product_handle || '';
      const nodeKey = normalizeDriverRuleModelKey(String(hubModel));
      return nodeKey === modelKey || nodeKey.includes(modelKey) || modelKey.includes(nodeKey);
    });
  }

  let driverRulesAllNodesPromise = null;
  let driverRulesAllNodesCache = null;

  async function fetchDriverRulesAllNodes() {
    if (driverRulesAllNodesCache) return { nodes: driverRulesAllNodesCache, error: null };
    if (!driverRulesAllNodesPromise) {
      const DBG = '[HubBuilder] fetchDriverRules';
      driverRulesAllNodesPromise = (async () => {
        try {
          let results = [];
          let cursor = null;
          let hasMore = true;
          let page = 0;
          while (hasMore) {
            page += 1;
            const variables = { type: 'driver_rule', entryCount: 250, cursor };
            const response = await storefrontGraphQL(
              `query GetDriverRules($type: String!, $entryCount: Int!, $cursor: String){
                metaobjects(type: $type, first: $entryCount, after: $cursor){
                  edges{ node{ handle type fields{ key value } } }
                  pageInfo{ hasNextPage endCursor }
                }
              }`,
              variables,
            );
            const { data, errors } = response;
            if (errors) {
              console.error(`${DBG}: GraphQL errors`, errors);
              return { nodes: [], error: `GraphQL errors: ${JSON.stringify(errors)}` };
            }
            const edges = data?.metaobjects?.edges || [];
            results = results.concat(edges.map((e) => e.node));
            hasMore = data?.metaobjects?.pageInfo?.hasNextPage === true;
            cursor = data?.metaobjects?.pageInfo?.endCursor || null;
          }
          driverRulesAllNodesCache = results;
          console.log(`${DBG}:done (shared)`, { totalMetaobjectsFetched: results.length });
          return { nodes: results, error: null };
        } catch (e) {
          const errMsg = e?.message || String(e);
          console.error(`${DBG}:exception`, e);
          return { nodes: [], error: errMsg || 'Failed to fetch driver rules' };
        } finally {
          driverRulesAllNodesPromise = null;
        }
      })();
    }
    return driverRulesAllNodesPromise;
  }

  async function fetchDriverRules(modelHandle) {
    const DBG = '[HubBuilder] fetchDriverRules';
    try {
      const { nodes, error } = await fetchDriverRulesAllNodes();
      if (error) return { rules: [], error };
      const filtered = filterDriverRuleNodesByModel(nodes, modelHandle);
      console.log(`${DBG}:filtered for model`, {
        modelHandle,
        afterModelFilter: filtered.length,
        totalMetaobjectsFetched: nodes.length,
      });
      return { rules: filtered };
    } catch (e) {
      console.error(`${DBG}:filter exception`, e, { modelHandle });
      return { rules: [], error: e?.message || 'Failed to fetch driver rules' };
    }
  }

  async function ensureDriverRules(modelHandle) {
    if (typeof window !== 'undefined' && Array.isArray(window.__DRIVER_RULES__)) {
      return window.__DRIVER_RULES__;
    }
    const { rules } = await fetchDriverRules(modelHandle);
    if (typeof window !== 'undefined') window.__DRIVER_RULES__ = rules || [];
    return window.__DRIVER_RULES__;
  }

  function buildDriverHandleMapFromDriverRules(rules) {
    const map = {};
    for (const r of (rules || [])) {
      const f = Object.fromEntries((r.fields || []).map((x) => [x.key, x.value]));
      const handle =
        f.driver_handle ||
        f.driver_product_handle ||
        f.freehub_handle ||
        f.freehub_product_handle ||
        f.product_handle ||
        f.handle;
      const driverRaw = f.driver_style || f.driver_type || f.driver || f.freehub_driver || f.freehub;
      if (!handle || !driverRaw) continue;
      const key = normalizeDriverName(driverRaw);
      map[key] = String(handle).trim();
    }
    return map;
  }

  /** Match metaobject list field values to current selection (hyphen/space tolerant). */
  function hubMetaobjectFieldsMatch(str1, str2) {
    if (!str1 || !str2) return false;
    let normalizedStr1 = str1;
    try {
      if (typeof str1 === "string" && str1.trim().startsWith("[") && str1.trim().endsWith("]")) {
        const parsed = JSON.parse(str1);
        if (Array.isArray(parsed) && parsed.length > 0) normalizedStr1 = parsed[0];
      }
    } catch (_) {}
    const canonical = (s) =>
      String(s)
        .toLowerCase()
        .trim()
        .replace(/[-_–—]/g, " ")
        .replace(/\s+/g, " ");
    return canonical(normalizedStr1) === canonical(str2);
  }

  /**
   * Pick a stem rules-index config row matching the current builder selections.
   * Purchasable SKU lives on handles[i].front_handle (not rear_handle / handle).
   */
  function pickStemConfigFromRulesIndex(rulesIndex, completeOptions) {
    if (!rulesIndex?.configs?.length || !Array.isArray(completeOptions) || !completeOptions.length) return null;
    const selections = Object.fromEntries(
      completeOptions.map((o) => [o.id, o.value]).filter(([, v]) => v != null && String(v).trim() !== '')
    );
    if (!Object.keys(selections).length) return null;
    // Reuse hubIntersectConfigIndices — for stems buildType doesn't matter much; pass 'complete'
    const indices = hubIntersectConfigIndices(rulesIndex, selections, 'complete');
    if (!indices?.length) return null;
    // Prefer exact single match; if multiple, try to find one with front_handle
    const withHandle = indices.filter((i) => {
      const h = rulesIndex.handles?.[i] || {};
      const c = rulesIndex.configs?.[i] || {};
      return !!(h.front_handle || c.front_handle || c.product_handle || c.pricing_product_handle);
    });
    const pickIdx = (withHandle.length === 1 ? withHandle[0] : (indices.length === 1 ? indices[0] : null));
    if (pickIdx == null) {
      // If multiple still, take first with front_handle if all share same front_handle, else null
      if (withHandle.length > 1) {
        const handles = withHandle.map((i) => String((rulesIndex.handles?.[i]?.front_handle || rulesIndex.configs?.[i]?.front_handle || '').trim()));
        if (handles.every((h) => h && h === handles[0])) {
          // same SKU — ok
          const i = withHandle[0];
          return { index: i, config: rulesIndex.configs[i] || {}, handles: rulesIndex.handles?.[i] || {} };
        }
        return null;
      }
      return null;
    }
    return {
      index: pickIdx,
      config: rulesIndex.configs[pickIdx] || {},
      handles: rulesIndex.handles?.[pickIdx] || {},
    };
  }

  function stemPricingSourceFromIndexMatch(handlesEntry, configEntry) {
    const h = handlesEntry || {};
    const c = configEntry || {};
    // Prefer explicit variant ids from config if present
    const rawVid = c.variant_id ?? c.shopify_variant_id ?? c.variantId;
    if (rawVid != null && String(rawVid).trim() !== '') {
      const digits = String(rawVid).replace(/[^\d]/g, '');
      const n = parseInt(digits, 10);
      if (n > 0) return { variantId: n, productHandle: null };
    }
    // Purchasable SKU for stems is front_handle (NOT rear_handle which is parent, NOT handle which is metaobject id)
    const productHandle = String(
      h.front_handle ||
      c.front_handle ||
      c.pricing_product_handle ||
      c.price_product_handle ||
      c.product_handle ||
      ''
    ).trim();
    if (productHandle) return { variantId: null, productHandle };
    return { variantId: null, productHandle: null };
  }

  function stemRulePricingSourceFromFields(f) {
    if (!f || typeof f !== 'object') return { variantId: null, productHandle: null };
    const rawVid = f.variant_id ?? f.shopify_variant_id ?? f.variantId;
    if (rawVid != null && String(rawVid).trim() !== '') {
      const digits = String(rawVid).replace(/[^\d]/g, '');
      const n = parseInt(digits, 10);
      if (n > 0) return { variantId: n, productHandle: null };
    }
    const h = String(
      f.pricing_product_handle || f.price_product_handle || f.product_handle || f.front_handle || '',
    ).trim();
    if (h) return { variantId: null, productHandle: h };
    return { variantId: null, productHandle: null };
  }

  /**
   * Choose the stem_rules row whose option fields match the current build and that carries
   * pricing (variant id or product handle for the purchasable SKU).
   */
  function pickStemRuleRowForPricing(rules, completeOptions) {
    if (!Array.isArray(completeOptions) || completeOptions.length === 0) return null;
    const selected = Object.fromEntries(completeOptions.map((o) => [o.id, o.value]));
    const ids = completeOptions.map((o) => o.id).filter((id) => (selected[id] ?? '') !== '');
    if (!ids.length) return null;

    const fieldMap = (r) => Object.fromEntries((r.fields || []).map((x) => [x.key, x.value]));
    const hasPriceSource = (f) => {
      const src = stemRulePricingSourceFromFields(f);
      return !!(src.variantId || src.productHandle);
    };

    const strict = (rules || []).filter((r) => {
      const f = fieldMap(r);
      if (!hasPriceSource(f)) return false;
      for (const id of ids) {
        if (!f[id] || !hubMetaobjectFieldsMatch(f[id], selected[id])) return false;
      }
      return true;
    });
    if (strict.length) return strict[0];

    let best = null;
    let bestScore = -Infinity;
    for (const r of rules || []) {
      const f = fieldMap(r);
      if (!hasPriceSource(f)) continue;
      let score = 0;
      for (const id of ids) {
        if (!f[id]) continue;
        if (hubMetaobjectFieldsMatch(f[id], selected[id])) score += 4;
        else score -= 6;
      }
      if (score > bestScore) {
        bestScore = score;
        best = r;
      }
    }
    return bestScore > -Infinity ? best : null;
  }

  function filterHubRulesBySelections(rules, queryParams) {
    return (rules || []).filter((r) => {
      const f = Object.fromEntries((r.fields || []).map((x) => [x.key, x.value]));
      if (!hubMetaobjectFieldsMatch(f.hub_model_handle || f.hub_model, queryParams.hubModel)) return false;
      if (queryParams.flangeType && f.flange_type && !hubMetaobjectFieldsMatch(f.flange_type, queryParams.flangeType)) return false;
      if (queryParams.brakeType && f.brake_type && !hubMetaobjectFieldsMatch(f.brake_type, queryParams.brakeType)) return false;
      if (queryParams.frontSpacing && f.front_spacing && !hubMetaobjectFieldsMatch(f.front_spacing, queryParams.frontSpacing)) return false;
      if (queryParams.rearSpacing && f.rear_spacing && !hubMetaobjectFieldsMatch(f.rear_spacing, queryParams.rearSpacing)) return false;
      const ruleDriverValue = f.driver_style || f.driver_type || f.driver || f.freehub_driver || f.freehub;
      if (queryParams.driverStyle && ruleDriverValue && !normalizeAndCompareDriver(ruleDriverValue, queryParams.driverStyle)) return false;
      if (queryParams.frontHoleCount && f.front_hole_count && !hubMetaobjectFieldsMatch(f.front_hole_count, queryParams.frontHoleCount)) return false;
      if (queryParams.rearHoleCount && f.rear_hole_count && !hubMetaobjectFieldsMatch(f.rear_hole_count, queryParams.rearHoleCount)) return false;
      return true;
    });
  }

  const colorHandleMap = {
    Black: "black",
    Silver: "silver",
    Gold: "gold",
    Orange: "orange",
    Purple: "purple",
    Green: "green",
    Red: "red",
    Bronze: "bronze",
    Turquoise: "turquoise",
    Blue: "blue",
    Maple: "maple",
    Pink: "pink",
    Flatearth: "flatearth",
  };

  /**
   * Product handles for add-to-cart / pricing from hub_rule `front_handle` / `rear_handle` (full Shopify handles; no color suffix).
   */
  function buildColorToHandleMapFromHubRules(rules, queryParams, buildType, allColors) {
    const relevant = filterHubRulesBySelections(rules, queryParams);
    const map = {};
    for (const r of relevant) {
      const f = Object.fromEntries((r.fields || []).map((x) => [x.key, x.value]));
      const ruleColor = f.hub_color || f.hub_colour;
      if (!ruleColor) continue;
      const color = String(ruleColor).trim();
      if (buildType === 'front' || buildType === 'complete') {
        const fh = f.front_handle || f.front_product_handle;
        if (fh) {
          const h = String(fh).trim();
          if (!map[color]) map[color] = {};
          map[color].front = h;
          map[color].any = map[color].any || h;
        }
      }
      if (buildType === 'rear' || buildType === 'complete') {
        const rh = f.rear_handle || f.rear_product_handle;
        if (rh) {
          const h = String(rh).trim();
          if (!map[color]) map[color] = {};
          map[color].rear = h;
          map[color].any = map[color].any || h;
        }
      }
    }
    return map;
  }

  /**
   * Driver-only ATC/pricing: normalized driver key → product handle from hub_rule rows.
   * Supports common metaobject field names; extend if your schema differs.
   */
  function buildDriverHandleMapFromHubRules(rules, queryParams) {
    const relevant = filterHubRulesBySelections(rules, queryParams);
    const map = {};
    for (const r of relevant) {
      const f = Object.fromEntries((r.fields || []).map((x) => [x.key, x.value]));
      const handle =
        f.driver_handle ||
        f.driver_product_handle ||
        f.freehub_handle ||
        f.freehub_product_handle ||
        f.product_handle ||
        f.handle;
      const driverRaw = f.driver_style || f.driver_type || f.driver || f.freehub_driver || f.freehub;
      if (!handle || !driverRaw) continue;
      const key = normalizeDriverName(driverRaw);
      map[key] = String(handle).trim();
    }
    return map;
  }

  /**
   * Product JSON must use the **current document origin** (e.g. theme dev `http://127.0.0.1:9292`).
   * Using `https://{shop}.myshopify.com/products/...` from localhost is cross-origin and often returns
   * 401 — which breaks pricing/cart fallbacks even when GraphQL returns $0 or empty variants.
   */
  async function fetchProductJsonByHandle(handle) {
    const h = String(handle || '').trim();
    if (!h) throw new Error('missing handle');
    const root = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = String(root).replace(/\/+$/, '');
    const url = `${base}/products/${encodeURIComponent(h)}.js`;
    const res = await hubFetchWith429Retry(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('not found');
    return await res.json();
  }

  if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', () => {
      register();
    });
  }

  /* === bfcache hygiene for the hub builder's cart CTA ============
     Symmetric to the wheelBuilder.js `pageshow` listener — when
     mobile Safari / Chrome restore this page from bfcache (user
     tapped Back from /checkout), Alpine's `init()` does NOT re-run
     and any in-flight `isCheckingOut` flag stays true → button is
     stuck on "Going to checkout…". Walk every `hubBuilderForm`
     Alpine root and clear the transient flags. */
  if (typeof window !== 'undefined') {
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      try {
        const roots = document.querySelectorAll('[x-data*="hubBuilderForm"]');
        roots.forEach((el) => {
          const stack = el._x_dataStack;
          if (!Array.isArray(stack) || !stack.length) return;
          const data = stack[0];
          if (!data) return;
          if (data.isCheckingOut) data.isCheckingOut = false;
          if (data.addToCartSubmitting) data.addToCartSubmitting = false;
          if (data.loading) data.loading = false;
          if (data._checkoutWatchdogId) {
            clearTimeout(data._checkoutWatchdogId);
            data._checkoutWatchdogId = null;
          }
        });
        document.dispatchEvent(new CustomEvent('wheelbuilder:form-state-changed'));
      } catch (_) {
        /* Never let cleanup throw — page is otherwise restored fine. */
      }
    });
  }
})();


